function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t2, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t2, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n5 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n5 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n5++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var Rt = Object.defineProperty;
var Ht = function Ht(s, o, e) {
  return o in s ? Rt(s, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : s[o] = e;
};
var l = function l(s, o, e) {
  return Ht(s, _typeof(o) != "symbol" ? o + "" : o, e);
};
import { getEnvKeystrokeText as ee, uid as te, env as S, delay as zt, createElement as I, KeystrokeHandler as O, FocusTracker as T, toUnit as le, global as f, Rect as C, DomEmitterMixin as ae, ObservableMixin as ce, Collection as Ve, isIterable as Se, CKEditorError as V, getOptimalPosition as xe, logWarning as x, EmitterMixin as at, getVisualViewportOffset as Y, isVisible as B, isNode as ct, priorities as Ut, isText as $t, ResizeObserver as ht, toArray as he, first as Kt, parseBase64EncodedObject as ut, isRange as jt } from "../../../../../@ckeditor_ckeditor5-utils@45.1.0/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { Plugin as Ee, ContextPlugin as Xt } from "../../../../../@ckeditor_ckeditor5-core@45.1.0/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { IconAccessibility as Me, IconCancel as dt, IconDropdownArrow as ue, IconDragIndicator as qt, IconPilcrow as Yt, IconThreeVerticalDots as Ie, IconText as Qt, IconPlus as Zt, IconParagraph as Jt, IconImportExport as ei, IconBold as ti, IconAlignLeft as ii, IconCheck as ft, IconPreviousArrow as si, IconNextArrow as oi, IconColorPalette as ni, IconEraser as ri, IconProjectLogo as li, IconColorTileCheck as ai } from "../../../../../@ckeditor_ckeditor5-icons@45.1.0/node_modules/@ckeditor/ckeditor5-icons/dist/index.js";
import Ne from "../../../../../color-parse@1.4.2/node_modules/color-parse/index.js";
import * as pt from "../../../../../../../_virtual/index.js";
import { HexBase as ci } from "../../../../../vanilla-colorful@0.7.2/node_modules/vanilla-colorful/lib/entrypoints/hex.js";
import "../../../../../@ckeditor_ckeditor5-engine@45.1.0/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { assignIn as hi } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/assignIn.js";
import { isObject as ie } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isObject.js";
import { cloneDeep as Oe } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/cloneDeep.js";
import { debounce as _e } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/debounce.js";
import { isElement as Pe } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isElement.js";
import { cloneDeepWith as ui } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/cloneDeepWith.js";
import { throttle as di } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/throttle.js"; /**
                                                                                                                            * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                            * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                            */
var A = /*#__PURE__*/function (_Ve) {
  function A() {
    var _this;
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, A);
    _this = _callSuper(this, A, [e, {
      idProperty: "viewUid"
    }]);
    l(_this, "_parentElement");
    _this.on("add", function (t, i, n) {
      _this._renderViewIntoCollectionParent(i, n);
    }), _this.on("remove", function (t, i) {
      i.element && _this._parentElement && i.element.remove();
    }), _this._parentElement = null;
    return _this;
  }
  _inherits(A, _Ve);
  return _createClass(A, [{
    key: "destroy",
    value: function destroy() {
      this.map(function (e) {
        return e.destroy();
      });
    }
  }, {
    key: "setParent",
    value: function setParent(e) {
      this._parentElement = e;
      var _iterator = _createForOfIteratorHelper(this),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          this._renderViewIntoCollectionParent(t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "delegate",
    value: function delegate() {
      var _this2 = this;
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      if (!e.length || !fi(e)) throw new V("ui-viewcollection-delegate-wrong-events", this);
      return {
        to: function to(t) {
          var _iterator2 = _createForOfIteratorHelper(_this2),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var i = _step2.value;
              for (var _i4 = 0, _e4 = e; _i4 < _e4.length; _i4++) {
                var n = _e4[_i4];
                i.delegate(n).to(t);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          _this2.on("add", function (i, n) {
            for (var _i2 = 0, _e2 = e; _i2 < _e2.length; _i2++) {
              var r = _e2[_i2];
              n.delegate(r).to(t);
            }
          }), _this2.on("remove", function (i, n) {
            for (var _i3 = 0, _e3 = e; _i3 < _e3.length; _i3++) {
              var r = _e3[_i3];
              n.stopDelegating(r, t);
            }
          });
        }
      };
    }
  }, {
    key: "_renderViewIntoCollectionParent",
    value: function _renderViewIntoCollectionParent(e, t) {
      e.isRendered || e.render(), e.element && this._parentElement && this._parentElement.insertBefore(e.element, this._parentElement.children[t]);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      return _superPropGet(A, "remove", this, 3)([e]);
    }
  }]);
}(Ve);
function fi(s) {
  return s.every(function (o) {
    return typeof o == "string";
  });
}
var pi = "http://www.w3.org/1999/xhtml";
var E = /*#__PURE__*/function (_at) {
  function E(e) {
    var _this3;
    _classCallCheck(this, E);
    _this3 = _callSuper(this, E);
    l(_this3, "ns");
    l(_this3, "tag");
    l(_this3, "text");
    l(_this3, "attributes");
    l(_this3, "children");
    l(_this3, "eventListeners");
    l(_this3, "_isRendered");
    l(_this3, "_revertData");
    Object.assign(_this3, Ge(We(e))), _this3._isRendered = !1, _this3._revertData = null;
    return _this3;
  }
  _inherits(E, _at);
  return _createClass(E, [{
    key: "render",
    value: function render() {
      var e = this._renderNode({
        intoFragment: !0
      });
      return this._isRendered = !0, e;
    }
  }, {
    key: "apply",
    value: function apply(e) {
      return this._revertData = ze(), this._renderNode({
        node: e,
        intoFragment: !1,
        isApplying: !0,
        revertData: this._revertData
      }), e;
    }
  }, {
    key: "revert",
    value: function revert(e) {
      if (!this._revertData) throw new V("ui-template-revert-not-applied", [this, e]);
      this._revertTemplateFromNode(e, this._revertData);
    }
  }, {
    key: "getViews",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getViews() {
      var _marked, e;
      return _regeneratorRuntime().wrap(function getViews$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e = function _e5(t) {
              var _iterator3, _step3, i;
              return _regeneratorRuntime().wrap(function e$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!t.children) {
                      _context.next = 24;
                      break;
                    }
                    _iterator3 = _createForOfIteratorHelper(t.children);
                    _context.prev = 2;
                    _iterator3.s();
                  case 4:
                    if ((_step3 = _iterator3.n()).done) {
                      _context.next = 16;
                      break;
                    }
                    i = _step3.value;
                    if (!se(i)) {
                      _context.next = 11;
                      break;
                    }
                    _context.next = 9;
                    return i;
                  case 9:
                    _context.next = 14;
                    break;
                  case 11:
                    _context.t0 = Be(i);
                    if (!_context.t0) {
                      _context.next = 14;
                      break;
                    }
                    return _context.delegateYield(e(i), "t1", 14);
                  case 14:
                    _context.next = 4;
                    break;
                  case 16:
                    _context.next = 21;
                    break;
                  case 18:
                    _context.prev = 18;
                    _context.t2 = _context["catch"](2);
                    _iterator3.e(_context.t2);
                  case 21:
                    _context.prev = 21;
                    _iterator3.f();
                    return _context.finish(21);
                  case 24:
                  case "end":
                    return _context.stop();
                }
              }, _marked, null, [[2, 18, 21, 24]]);
            };
            _marked = /*#__PURE__*/_regeneratorRuntime().mark(e);
            return _context2.delegateYield(e(this), "t0", 3);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, getViews, this);
    })
  }, {
    key: "_renderNode",
    value: function _renderNode(e) {
      var t;
      if (e.node ? t = this.tag && this.text : t = this.tag ? this.text : !this.text, t) throw new V("ui-template-wrong-syntax", this);
      return this.text ? this._renderText(e) : this._renderElement(e);
    }
  }, {
    key: "_renderElement",
    value: function _renderElement(e) {
      var t = e.node;
      return t || (t = e.node = document.createElementNS(this.ns || pi, this.tag)), this._renderAttributes(e), this._renderElementChildren(e), this._setUpListeners(e), t;
    }
  }, {
    key: "_renderText",
    value: function _renderText(e) {
      var t = e.node;
      return t ? e.revertData.text = t.textContent : t = e.node = document.createTextNode(""), Q(this.text) ? this._bindToObservable({
        schema: this.text,
        updater: bi(t),
        data: e
      }) : t.textContent = this.text.join(""), t;
    }
  }, {
    key: "_renderAttributes",
    value: function _renderAttributes(e) {
      if (!this.attributes) return;
      var t = e.node,
        i = e.revertData;
      for (var n in this.attributes) {
        var r = t.getAttribute(n),
          a = this.attributes[n];
        i && (i.attributes[n] = r);
        var u = He(a) ? a[0].ns : null;
        if (Q(a)) {
          var c = He(a) ? a[0].value : a;
          i && Ue(n) && c.unshift(r), this._bindToObservable({
            schema: c,
            updater: gi(t, n, u),
            data: e
          });
        } else if (n == "style" && typeof a[0] != "string") this._renderStyleAttribute(a[0], e);else {
          i && r && Ue(n) && a.unshift(r);
          var _c = a.map(function (h) {
            return h && (h.value || h);
          }).reduce(function (h, p) {
            return h.concat(p);
          }, []).reduce(gt, "");
          G(_c) || t.setAttributeNS(u, n, _c);
        }
      }
    }
  }, {
    key: "_renderStyleAttribute",
    value: function _renderStyleAttribute(e, t) {
      var i = t.node;
      for (var n in e) {
        var r = e[n];
        Q(r) ? this._bindToObservable({
          schema: [r],
          updater: _i(i, n),
          data: t
        }) : i.style[n] = r;
      }
    }
  }, {
    key: "_renderElementChildren",
    value: function _renderElementChildren(e) {
      var t = e.node,
        i = e.intoFragment ? document.createDocumentFragment() : t,
        n = e.isApplying;
      var r = 0;
      var _iterator4 = _createForOfIteratorHelper(this.children),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var a = _step4.value;
          if (Le(a)) {
            if (!n) {
              a.setParent(t);
              var _iterator5 = _createForOfIteratorHelper(a),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var u = _step5.value;
                  i.appendChild(u.element);
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
          } else if (se(a)) n || (a.isRendered || a.render(), i.appendChild(a.element));else if (ct(a)) i.appendChild(a);else if (n) {
            var _u = e.revertData,
              c = ze();
            _u.children.push(c), a._renderNode({
              intoFragment: !1,
              node: i.childNodes[r++],
              isApplying: !0,
              revertData: c
            });
          } else i.appendChild(a.render());
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      e.intoFragment && t.appendChild(i);
    }
  }, {
    key: "_setUpListeners",
    value: function _setUpListeners(e) {
      var _this4 = this;
      if (this.eventListeners) {
        var _loop = function _loop(t) {
          var i = _this4.eventListeners[t].map(function (n) {
            var _t$split = t.split("@"),
              _t$split2 = _slicedToArray(_t$split, 2),
              r = _t$split2[0],
              a = _t$split2[1];
            return n.activateDomEventListener(r, a, e);
          });
          e.revertData && e.revertData.bindings.push(i);
        };
        for (var t in this.eventListeners) {
          _loop(t);
        }
      }
    }
  }, {
    key: "_bindToObservable",
    value: function _bindToObservable(_ref) {
      var e = _ref.schema,
        t = _ref.updater,
        i = _ref.data;
      var n = i.revertData;
      wt(e, t, i);
      var r = e.filter(function (a) {
        return !G(a);
      }).filter(function (a) {
        return a.observable;
      }).map(function (a) {
        return a.activateAttributeListener(e, t, i);
      });
      n && n.bindings.push(r);
    }
  }, {
    key: "_revertTemplateFromNode",
    value: function _revertTemplateFromNode(e, t) {
      var _iterator6 = _createForOfIteratorHelper(t.bindings),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _n2 = _step6.value;
          var _iterator7 = _createForOfIteratorHelper(_n2),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _r = _step7.value;
              _r();
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      if (t.text) {
        e.textContent = t.text;
        return;
      }
      var i = e;
      for (var n in t.attributes) {
        var r = t.attributes[n];
        r === null ? i.removeAttribute(n) : i.setAttribute(n, r);
      }
      for (var _n = 0; _n < t.children.length; ++_n) this._revertTemplateFromNode(i.childNodes[_n], t.children[_n]);
    }
  }], [{
    key: "bind",
    value: function bind(e, t) {
      return {
        to: function to(i, n) {
          return new mi({
            eventNameOrFunction: i,
            attribute: i,
            observable: e,
            emitter: t,
            callback: n
          });
        },
        if: function _if(i, n, r) {
          return new mt({
            observable: e,
            emitter: t,
            attribute: i,
            valueIfTrue: n,
            callback: r
          });
        }
      };
    }
  }, {
    key: "extend",
    value: function extend(e, t) {
      if (e._isRendered) throw new V("template-extend-render", [this, e]);
      _t(e, Ge(We(t)));
    }
  }]);
}(at());
var K = /*#__PURE__*/function () {
  function K(o) {
    _classCallCheck(this, K);
    l(this, "attribute");
    l(this, "observable");
    l(this, "emitter");
    l(this, "callback");
    this.attribute = o.attribute, this.observable = o.observable, this.emitter = o.emitter, this.callback = o.callback;
  }
  return _createClass(K, [{
    key: "getValue",
    value: function getValue(o) {
      var e = this.observable[this.attribute];
      return this.callback ? this.callback(e, o) : e;
    }
  }, {
    key: "activateAttributeListener",
    value: function activateAttributeListener(o, e, t) {
      var _this5 = this;
      var i = function i() {
        return wt(o, e, t);
      };
      return this.emitter.listenTo(this.observable, "change:".concat(this.attribute), i), function () {
        _this5.emitter.stopListening(_this5.observable, "change:".concat(_this5.attribute), i);
      };
    }
  }]);
}();
var mi = /*#__PURE__*/function (_K) {
  function mi(e) {
    var _this6;
    _classCallCheck(this, mi);
    _this6 = _callSuper(this, mi, [e]);
    l(_this6, "eventNameOrFunction");
    _this6.eventNameOrFunction = e.eventNameOrFunction;
    return _this6;
  }
  _inherits(mi, _K);
  return _createClass(mi, [{
    key: "activateDomEventListener",
    value: function activateDomEventListener(e, t, i) {
      var _this7 = this;
      var n = function n(r, a) {
        (!t || a.target.matches(t)) && (typeof _this7.eventNameOrFunction == "function" ? _this7.eventNameOrFunction(a) : _this7.observable.fire(_this7.eventNameOrFunction, a));
      };
      return this.emitter.listenTo(i.node, e, n), function () {
        _this7.emitter.stopListening(i.node, e, n);
      };
    }
  }]);
}(K);
var mt = /*#__PURE__*/function (_K2) {
  function mt(e) {
    var _this8;
    _classCallCheck(this, mt);
    _this8 = _callSuper(this, mt, [e]);
    l(_this8, "valueIfTrue");
    _this8.valueIfTrue = e.valueIfTrue;
    return _this8;
  }
  _inherits(mt, _K2);
  return _createClass(mt, [{
    key: "getValue",
    value: function getValue(e) {
      var t = _superPropGet(mt, "getValue", this, 3)([e]);
      return G(t) ? !1 : this.valueIfTrue || !0;
    }
  }]);
}(K);
function Q(s) {
  return s ? (s.value && (s = s.value), Array.isArray(s) ? s.some(Q) : s instanceof K) : !1;
}
function wi(s, o) {
  return s.map(function (e) {
    return e instanceof K ? e.getValue(o) : e;
  });
}
function wt(s, o, _ref2) {
  var e = _ref2.node;
  var t = wi(s, e);
  var i;
  s.length == 1 && s[0] instanceof mt ? i = t[0] : i = t.reduce(gt, ""), G(i) ? o.remove() : o.set(i);
}
function bi(s) {
  return {
    set: function set(o) {
      s.textContent = o;
    },
    remove: function remove() {
      s.textContent = "";
    }
  };
}
function gi(s, o, e) {
  return {
    set: function set(t) {
      s.setAttributeNS(e, o, t);
    },
    remove: function remove() {
      s.removeAttributeNS(e, o);
    }
  };
}
function _i(s, o) {
  return {
    set: function set(e) {
      s.style[o] = e;
    },
    remove: function remove() {
      s.style[o] = null;
    }
  };
}
function We(s) {
  return ui(s, function (e) {
    if (e && (e instanceof K || Be(e) || se(e) || Le(e))) return e;
  });
}
function Ge(s) {
  if (typeof s == "string" ? s = vi(s) : s.text && yi(s), s.on && (s.eventListeners = Ti(s.on), delete s.on), !s.text) {
    s.attributes && ki(s.attributes);
    var o = [];
    if (s.children) if (Le(s.children)) o.push(s.children);else {
      var _iterator8 = _createForOfIteratorHelper(s.children),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _e6 = _step8.value;
          Be(_e6) || se(_e6) || ct(_e6) ? o.push(_e6) : o.push(new E(_e6));
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    s.children = o;
  }
  return s;
}
function ki(s) {
  for (var o in s) s[o].value && (s[o].value = he(s[o].value)), bt(s, o);
}
function Ti(s) {
  for (var o in s) bt(s, o);
  return s;
}
function vi(s) {
  return {
    text: [s]
  };
}
function yi(s) {
  s.text = he(s.text);
}
function bt(s, o) {
  s[o] = he(s[o]);
}
function gt(s, o) {
  return G(o) ? s : G(s) ? o : "".concat(s, " ").concat(o);
}
function Re(s, o) {
  for (var _e7 in o) {
    var _s$_e;
    s[_e7] ? (_s$_e = s[_e7]).push.apply(_s$_e, _toConsumableArray(o[_e7])) : s[_e7] = o[_e7];
  }
}
function _t(s, o) {
  var _s$text;
  if (o.attributes && (s.attributes || (s.attributes = {}), Re(s.attributes, o.attributes)), o.eventListeners && (s.eventListeners || (s.eventListeners = {}), Re(s.eventListeners, o.eventListeners)), o.text && (_s$text = s.text).push.apply(_s$text, _toConsumableArray(o.text)), o.children && o.children.length) {
    if (s.children.length != o.children.length) throw new V("ui-template-extend-children-mismatch", s);
    var _e8 = 0;
    var _iterator9 = _createForOfIteratorHelper(o.children),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var t = _step9.value;
        _t(s.children[_e8++], t);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
}
function G(s) {
  return !s && s !== 0;
}
function se(s) {
  return s instanceof d;
}
function Be(s) {
  return s instanceof E;
}
function Le(s) {
  return s instanceof A;
}
function He(s) {
  return ie(s[0]) && s[0].ns;
}
function ze() {
  return {
    children: [],
    bindings: [],
    attributes: {}
  };
}
function Ue(s) {
  return s == "class" || s == "style";
}
var d = /*#__PURE__*/function (_ae) {
  function d(e) {
    var _this9;
    _classCallCheck(this, d);
    _this9 = _callSuper(this, d);
    l(_this9, "element");
    l(_this9, "isRendered");
    l(_this9, "locale");
    l(_this9, "t");
    l(_this9, "template");
    l(_this9, "_viewCollections");
    l(_this9, "_unboundChildren");
    l(_this9, "_bindTemplate");
    _this9.element = null, _this9.isRendered = !1, _this9.locale = e, _this9.t = e && e.t, _this9._viewCollections = new Ve(), _this9._unboundChildren = _this9.createCollection(), _this9._viewCollections.on("add", function (t, i) {
      i.locale = e, i.t = e && e.t;
    }), _this9.decorate("render");
    return _this9;
  }
  _inherits(d, _ae);
  return _createClass(d, [{
    key: "bindTemplate",
    get: function get() {
      return this._bindTemplate ? this._bindTemplate : this._bindTemplate = E.bind(this, this);
    }
  }, {
    key: "createCollection",
    value: function createCollection(e) {
      var t = new A(e);
      return this._viewCollections.add(t), t;
    }
  }, {
    key: "registerChild",
    value: function registerChild(e) {
      Se(e) || (e = [e]);
      var _iterator0 = _createForOfIteratorHelper(e),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var t = _step0.value;
          this._unboundChildren.add(t);
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
    }
  }, {
    key: "deregisterChild",
    value: function deregisterChild(e) {
      Se(e) || (e = [e]);
      var _iterator1 = _createForOfIteratorHelper(e),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var t = _step1.value;
          this._unboundChildren.remove(t);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
    }
  }, {
    key: "setTemplate",
    value: function setTemplate(e) {
      this.template = new E(e);
    }
  }, {
    key: "extendTemplate",
    value: function extendTemplate(e) {
      E.extend(this.template, e);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isRendered) throw new V("ui-view-render-already-rendered", this);
      this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening(), this._viewCollections.map(function (e) {
        return e.destroy();
      }), this.template && this.template._revertData && this.template.revert(this.element);
    }
  }]);
}(ae(ce()));
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function kt(_ref3) {
  var s = _ref3.emitter,
    o = _ref3.activator,
    e = _ref3.callback,
    t = _ref3.contextElements,
    i = _ref3.listenerOptions;
  s.listenTo(document, "mousedown", function (n, r) {
    if (!o()) return;
    var a = typeof r.composedPath == "function" ? r.composedPath() : [],
      u = typeof t == "function" ? t() : t;
    var _iterator10 = _createForOfIteratorHelper(u),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var c = _step10.value;
        if (c.contains(r.target) || a.includes(c)) return;
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
    e();
  }, i);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function fo(s) {
  var o = /*#__PURE__*/function (_s2) {
    function o() {
      var _this0;
      _classCallCheck(this, o);
      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }
      _this0 = _callSuper(this, o, [].concat(t)), _this0.set("_isCssTransitionsDisabled", !1), _this0.initializeCssTransitionDisablerMixin();
      return _this0;
    }
    _inherits(o, _s2);
    return _createClass(o, [{
      key: "disableCssTransitions",
      value: function disableCssTransitions() {
        this._isCssTransitionsDisabled = !0;
      }
    }, {
      key: "enableCssTransitions",
      value: function enableCssTransitions() {
        this._isCssTransitionsDisabled = !1;
      }
    }, {
      key: "initializeCssTransitionDisablerMixin",
      value: function initializeCssTransitionDisablerMixin() {
        this.extendTemplate({
          attributes: {
            class: [this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
          }
        });
      }
    }]);
  }(s);
  return o;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function po(_ref4) {
  var s = _ref4.view;
  s.listenTo(s.element, "submit", function (o, e) {
    e.preventDefault(), s.fire("submit");
  }, {
    useCapture: !0
  });
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Ci(_ref5) {
  var s = _ref5.keystrokeHandler,
    o = _ref5.focusTracker,
    e = _ref5.gridItems,
    t = _ref5.numberOfColumns,
    i = _ref5.uiLanguageDirection;
  var n = typeof t == "number" ? function () {
    return t;
  } : t;
  s.set("arrowright", r(function (c, h) {
    return i === "rtl" ? u(c, h.length) : a(c, h.length);
  })), s.set("arrowleft", r(function (c, h) {
    return i === "rtl" ? a(c, h.length) : u(c, h.length);
  })), s.set("arrowup", r(function (c, h) {
    var p = c - n();
    return p < 0 && (p = c + n() * Math.floor(h.length / n()), p > h.length - 1 && (p -= n())), p;
  })), s.set("arrowdown", r(function (c, h) {
    var p = c + n();
    return p > h.length - 1 && (p = c % n()), p;
  }));
  function r(c) {
    return function (h) {
      var p = e.find(function (D) {
          return D.element === o.focusedElement;
        }),
        b = e.getIndex(p),
        g = c(b, e);
      e.get(g).focus(), h.stopPropagation(), h.preventDefault();
    };
  }
  function a(c, h) {
    return c === h - 1 ? 0 : c + 1;
  }
  function u(c, h) {
    return c === 0 ? h - 1 : c - 1;
  }
}
var oe = /*#__PURE__*/function (_d) {
  function oe() {
    var _this1;
    _classCallCheck(this, oe);
    _this1 = _callSuper(this, oe);
    var o = _this1.bindTemplate;
    _this1.set("content", ""), _this1.set("viewBox", "0 0 20 20"), _this1.set("fillColor", ""), _this1.set("isColorInherited", !0), _this1.set("isVisible", !0), _this1.setTemplate({
      tag: "svg",
      ns: "http://www.w3.org/2000/svg",
      attributes: {
        class: ["ck", "ck-icon", o.if("isVisible", "ck-hidden", function (e) {
          return !e;
        }), "ck-reset_all-excluded", o.if("isColorInherited", "ck-icon_inherit-color")],
        viewBox: o.to("viewBox"),
        "aria-hidden": !0
      }
    });
    return _this1;
  }
  _inherits(oe, _d);
  return _createClass(oe, [{
    key: "render",
    value: function render() {
      var _this10 = this;
      _superPropGet(oe, "render", this, 3)([]), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
        _this10._updateXMLContent(), _this10._colorFillPaths();
      }), this.on("change:fillColor", function () {
        _this10._colorFillPaths();
      });
    }
  }, {
    key: "_updateXMLContent",
    value: function _updateXMLContent() {
      if (this.content) {
        var _e9 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg");
        if (!_e9) throw new V("ui-iconview-invalid-svg", this);
        var t = _e9.getAttribute("viewBox");
        t && (this.viewBox = t);
        for (var _i5 = 0, _Array$from = Array.from(_e9.attributes); _i5 < _Array$from.length; _i5++) {
          var _ref6 = _Array$from[_i5];
          var i = _ref6.name;
          var n = _ref6.value;
          oe.presentationalAttributeNames.includes(i) && this.element.setAttribute(i, n);
        }
        for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
        for (; _e9.childNodes.length > 0;) this.element.appendChild(_e9.childNodes[0]);
      }
    }
  }, {
    key: "_colorFillPaths",
    value: function _colorFillPaths() {
      var _this11 = this;
      this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (o) {
        o.style.fill = _this11.fillColor;
      });
    }
  }]);
}(d);
l(oe, "presentationalAttributeNames", ["alignment-baseline", "baseline-shift", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "paint-order", "pointer-events", "shape-rendering", "stop-color", "stop-opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-overflow", "text-rendering", "transform", "unicode-bidi", "vector-effect", "visibility", "white-space", "word-spacing", "writing-mode"]);
var L = oe;
var Tt = /*#__PURE__*/function (_d2) {
  function Tt() {
    var _this12;
    _classCallCheck(this, Tt);
    _this12 = _callSuper(this, Tt), _this12.set({
      style: void 0,
      text: void 0,
      id: void 0
    });
    var o = _this12.bindTemplate;
    _this12.setTemplate({
      tag: "span",
      attributes: {
        class: ["ck", "ck-button__label"],
        style: o.to("style"),
        id: o.to("id")
      },
      children: [{
        text: o.to("text")
      }]
    });
    return _this12;
  }
  _inherits(Tt, _d2);
  return _createClass(Tt);
}(d);
var w = /*#__PURE__*/function (_d3) {
  function w(e) {
    var _this13;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Tt();
    _classCallCheck(this, w);
    _this13 = _callSuper(this, w, [e]);
    l(_this13, "children");
    l(_this13, "labelView");
    l(_this13, "iconView");
    l(_this13, "keystrokeView");
    l(_this13, "_focusDelayed", null);
    var i = _this13.bindTemplate,
      n = te();
    _this13.set("_ariaPressed", !1), _this13.set("_ariaChecked", !1), _this13.set("ariaLabel", void 0), _this13.set("ariaLabelledBy", "ck-editor__aria-label_".concat(n)), _this13.set("class", void 0), _this13.set("labelStyle", void 0), _this13.set("icon", void 0), _this13.set("isEnabled", !0), _this13.set("isOn", !1), _this13.set("isVisible", !0), _this13.set("isToggleable", !1), _this13.set("keystroke", void 0), _this13.set("label", void 0), _this13.set("role", void 0), _this13.set("tabindex", -1), _this13.set("tooltip", !1), _this13.set("tooltipPosition", "s"), _this13.set("type", "button"), _this13.set("withText", !1), _this13.set("withKeystroke", !1), _this13.children = _this13.createCollection(), _this13.labelView = _this13._setupLabelView(t), _this13.iconView = new L(), _this13.iconView.extendTemplate({
      attributes: {
        class: "ck-button__icon"
      }
    }), _this13.iconView.bind("content").to(_this13, "icon"), _this13.keystrokeView = _this13._createKeystrokeView(), _this13.bind("_tooltipString").to(_this13, "tooltip", _this13, "label", _this13, "keystroke", _this13._getTooltipString.bind(_this13));
    var r = {
      tag: "button",
      attributes: {
        class: ["ck", "ck-button", i.to("class"), i.if("isEnabled", "ck-disabled", function (a) {
          return !a;
        }), i.if("isVisible", "ck-hidden", function (a) {
          return !a;
        }), i.to("isOn", function (a) {
          return a ? "ck-on" : "ck-off";
        }), i.if("withText", "ck-button_with-text"), i.if("withKeystroke", "ck-button_with-keystroke")],
        role: i.to("role"),
        type: i.to("type", function (a) {
          return a || "button";
        }),
        tabindex: i.to("tabindex"),
        "aria-checked": i.to("_ariaChecked"),
        "aria-pressed": i.to("_ariaPressed"),
        "aria-label": i.to("ariaLabel"),
        "aria-labelledby": i.to("ariaLabelledBy"),
        "aria-disabled": i.if("isEnabled", !0, function (a) {
          return !a;
        }),
        "data-cke-tooltip-text": i.to("_tooltipString"),
        "data-cke-tooltip-position": i.to("tooltipPosition")
      },
      children: _this13.children,
      on: {
        click: i.to(function (a) {
          _this13.isEnabled ? _this13.fire("execute") : a.preventDefault();
        })
      }
    };
    _this13.bind("_ariaPressed").to(_this13, "isOn", _this13, "isToggleable", _this13, "role", function (a, u, c) {
      return !u || $e(c) ? !1 : String(!!a);
    }), _this13.bind("_ariaChecked").to(_this13, "isOn", _this13, "isToggleable", _this13, "role", function (a, u, c) {
      return !u || !$e(c) ? !1 : String(!!a);
    }), S.isSafari && (_this13._focusDelayed || (_this13._focusDelayed = zt(function () {
      return _this13.focus();
    }, 0)), r.on.mousedown = i.to(function () {
      _this13._focusDelayed();
    }), r.on.mouseup = i.to(function () {
      _this13._focusDelayed.cancel();
    })), _this13.setTemplate(r);
    return _this13;
  }
  _inherits(w, _d3);
  return _createClass(w, [{
    key: "render",
    value: function render() {
      var _this14 = this;
      _superPropGet(w, "render", this, 3)([]), this.icon && this.children.add(this.iconView), this.on("change:icon", function (e, t, i, n) {
        i && !n ? _this14.children.add(_this14.iconView, 0) : !i && n && _this14.children.remove(_this14.iconView);
      }), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._focusDelayed && this._focusDelayed.cancel(), _superPropGet(w, "destroy", this, 3)([]);
    }
  }, {
    key: "_setupLabelView",
    value: function _setupLabelView(e) {
      return e.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy"), e;
    }
  }, {
    key: "_createKeystrokeView",
    value: function _createKeystrokeView() {
      var e = new d();
      return e.setTemplate({
        tag: "span",
        attributes: {
          class: ["ck", "ck-button__keystroke"]
        },
        children: [{
          text: this.bindTemplate.to("keystroke", function (t) {
            return ee(t);
          })
        }]
      }), e;
    }
  }, {
    key: "_getTooltipString",
    value: function _getTooltipString(e, t, i) {
      return e ? typeof e == "string" ? e : (i && (i = ee(i)), e instanceof Function ? e(t, i) : "".concat(t).concat(i ? " (".concat(i, ")") : "")) : "";
    }
  }]);
}(d);
function $e(s) {
  switch (s) {
    case "radio":
    case "checkbox":
    case "option":
    case "switch":
    case "menuitemcheckbox":
    case "menuitemradio":
      return !0;
    default:
      return !1;
  }
}
var Vi = /*#__PURE__*/function (_d4) {
  function Vi(e) {
    var _this15;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Vi);
    _this15 = _callSuper(this, Vi, [e]);
    l(_this15, "children");
    l(_this15, "iconView");
    var i = _this15.bindTemplate;
    _this15.set("label", t.label || ""), _this15.set("class", t.class || null), _this15.children = _this15.createCollection(), _this15.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-form__header", i.to("class")]
      },
      children: _this15.children
    }), t.icon && (_this15.iconView = new L(), _this15.iconView.content = t.icon, _this15.children.add(_this15.iconView));
    var n = new d(e);
    n.setTemplate({
      tag: "h2",
      attributes: {
        class: ["ck", "ck-form__header__label"],
        role: "presentation"
      },
      children: [{
        text: i.to("label")
      }]
    }), _this15.children.add(n);
    return _this15;
  }
  _inherits(Vi, _d4);
  return _createClass(Vi);
}(d);
var H = /*#__PURE__*/function (_at2) {
  function H(e) {
    var _this16;
    _classCallCheck(this, H);
    _this16 = _callSuper(this, H);
    l(_this16, "focusables");
    l(_this16, "focusTracker");
    l(_this16, "keystrokeHandler");
    l(_this16, "actions");
    if (_this16.focusables = e.focusables, _this16.focusTracker = e.focusTracker, _this16.keystrokeHandler = e.keystrokeHandler, _this16.actions = e.actions, e.actions && e.keystrokeHandler) {
      var _loop2 = function _loop2(t) {
        var i = e.actions[t];
        typeof i == "string" && (i = [i]);
        var _iterator11 = _createForOfIteratorHelper(i),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var n = _step11.value;
            e.keystrokeHandler.set(n, function (r, a) {
              _this16[t](), a();
            }, e.keystrokeHandlerOptions);
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      };
      for (var t in e.actions) {
        _loop2(t);
      }
    }
    _this16.on("forwardCycle", function () {
      return _this16.focusFirst();
    }, {
      priority: "low"
    }), _this16.on("backwardCycle", function () {
      return _this16.focusLast();
    }, {
      priority: "low"
    });
    return _this16;
  }
  _inherits(H, _at2);
  return _createClass(H, [{
    key: "first",
    get: function get() {
      return this.focusables.find(fe) || null;
    }
  }, {
    key: "last",
    get: function get() {
      return this.focusables.filter(fe).slice(-1)[0] || null;
    }
  }, {
    key: "next",
    get: function get() {
      return this._getDomFocusableItem(1);
    }
  }, {
    key: "previous",
    get: function get() {
      return this._getDomFocusableItem(-1);
    }
  }, {
    key: "current",
    get: function get() {
      var _this17 = this;
      var e = null;
      return this.focusTracker.focusedElement === null ? null : (this.focusables.find(function (t, i) {
        var n = t.element === _this17.focusTracker.focusedElement;
        return n && (e = i), n;
      }), e);
    }
  }, {
    key: "focusFirst",
    value: function focusFirst() {
      this._focus(this.first, 1);
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focus(this.last, -1);
    }
  }, {
    key: "focusNext",
    value: function focusNext() {
      var e = this.next;
      if (e && this.focusables.getIndex(e) === this.current) {
        this.fire("forwardCycle");
        return;
      }
      e === this.first ? this.fire("forwardCycle") : this._focus(e, 1);
    }
  }, {
    key: "focusPrevious",
    value: function focusPrevious() {
      var e = this.previous;
      if (e && this.focusables.getIndex(e) === this.current) {
        this.fire("backwardCycle");
        return;
      }
      e === this.last ? this.fire("backwardCycle") : this._focus(e, -1);
    }
  }, {
    key: "chain",
    value: function chain(e) {
      var _this18 = this;
      var t = function t() {
        return _this18.current === null ? null : _this18.focusables.get(_this18.current);
      };
      this.listenTo(e, "forwardCycle", function (i) {
        var n = t();
        _this18.focusNext(), n !== t() && i.stop();
      }, {
        priority: "low"
      }), this.listenTo(e, "backwardCycle", function (i) {
        var n = t();
        _this18.focusPrevious(), n !== t() && i.stop();
      }, {
        priority: "low"
      });
    }
  }, {
    key: "unchain",
    value: function unchain(e) {
      this.stopListening(e);
    }
  }, {
    key: "_focus",
    value: function _focus(e, t) {
      e && this.focusTracker.focusedElement !== e.element && e.focus(t);
    }
  }, {
    key: "_getDomFocusableItem",
    value: function _getDomFocusableItem(e) {
      var t = this.focusables.length;
      if (!t) return null;
      var i = this.current;
      if (i === null) return this[e === 1 ? "first" : "last"];
      var n = this.focusables.get(i),
        r = (i + t + e) % t;
      do {
        var a = this.focusables.get(r);
        if (fe(a)) {
          n = a;
          break;
        }
        r = (r + t + e) % t;
      } while (r !== i);
      return n;
    }
  }]);
}(at());
function fe(s) {
  return j(s) && B(s.element);
}
function j(s) {
  return "focus" in s && typeof s.focus == "function";
}
function xi(s) {
  return j(s) && "focusCycler" in s && s.focusCycler instanceof H;
}
function Ei(s) {
  var o = /*#__PURE__*/function (_s3) {
    function o() {
      var _this19;
      _classCallCheck(this, o);
      for (var _len3 = arguments.length, i = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        i[_key3] = arguments[_key3];
      }
      _this19 = _callSuper(this, o, [].concat(i));
      l(_this19, "_onDragBound", _this19._onDrag.bind(_this19));
      l(_this19, "_onDragEndBound", _this19._onDragEnd.bind(_this19));
      l(_this19, "_lastDraggingCoordinates", {
        x: 0,
        y: 0
      });
      _this19.on("render", function () {
        _this19._attachListeners();
      }), _this19.set("isDragging", !1);
      return _this19;
    }
    _inherits(o, _s3);
    return _createClass(o, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.listenTo(this.element, "mousedown", this._onDragStart.bind(this)), this.listenTo(this.element, "touchstart", this._onDragStart.bind(this));
      }
    }, {
      key: "_attachDragListeners",
      value: function _attachDragListeners() {
        this.listenTo(f.document, "mouseup", this._onDragEndBound), this.listenTo(f.document, "touchend", this._onDragEndBound), this.listenTo(f.document, "mousemove", this._onDragBound), this.listenTo(f.document, "touchmove", this._onDragBound);
      }
    }, {
      key: "_detachDragListeners",
      value: function _detachDragListeners() {
        this.stopListening(f.document, "mouseup", this._onDragEndBound), this.stopListening(f.document, "touchend", this._onDragEndBound), this.stopListening(f.document, "mousemove", this._onDragBound), this.stopListening(f.document, "touchmove", this._onDragBound);
      }
    }, {
      key: "_onDragStart",
      value: function _onDragStart(i, n) {
        if (!this._isHandleElementPressed(n)) return;
        this._attachDragListeners();
        var r = 0,
          a = 0;
        n instanceof MouseEvent ? (r = n.clientX, a = n.clientY) : (r = n.touches[0].clientX, a = n.touches[0].clientY), this._lastDraggingCoordinates = {
          x: r,
          y: a
        }, this.isDragging = !0;
      }
    }, {
      key: "_onDrag",
      value: function _onDrag(i, n) {
        if (!this.isDragging) {
          this._detachDragListeners();
          return;
        }
        var r = 0,
          a = 0;
        n instanceof MouseEvent ? (r = n.clientX, a = n.clientY) : (r = n.touches[0].clientX, a = n.touches[0].clientY), n.preventDefault(), this.fire("drag", {
          deltaX: Math.round(r - this._lastDraggingCoordinates.x),
          deltaY: Math.round(a - this._lastDraggingCoordinates.y)
        }), this._lastDraggingCoordinates = {
          x: r,
          y: a
        };
      }
    }, {
      key: "_onDragEnd",
      value: function _onDragEnd() {
        this._detachDragListeners(), this.isDragging = !1;
      }
    }, {
      key: "_isHandleElementPressed",
      value: function _isHandleElementPressed(i) {
        return this.dragHandleElement ? this.dragHandleElement === i.target || i.target instanceof HTMLElement && this.dragHandleElement.contains(i.target) : !1;
      }
    }]);
  }(s);
  return o;
}
var Ii = /*#__PURE__*/function (_d5) {
  function Ii(e) {
    var _this20;
    _classCallCheck(this, Ii);
    _this20 = _callSuper(this, Ii, [e]);
    l(_this20, "children");
    l(_this20, "keystrokes");
    l(_this20, "focusCycler");
    l(_this20, "_focusTracker");
    l(_this20, "_focusables");
    _this20.children = _this20.createCollection(), _this20.keystrokes = new O(), _this20._focusTracker = new T(), _this20._focusables = new A(), _this20.focusCycler = new H({
      focusables: _this20._focusables,
      focusTracker: _this20._focusTracker,
      keystrokeHandler: _this20.keystrokes,
      actions: {
        focusPrevious: "shift + tab",
        focusNext: "tab"
      }
    }), _this20.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-dialog__actions"]
      },
      children: _this20.children
    });
    return _this20;
  }
  _inherits(Ii, _d5);
  return _createClass(Ii, [{
    key: "render",
    value: function render() {
      _superPropGet(Ii, "render", this, 3)([]), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "setButtons",
    value: function setButtons(e) {
      var _this21 = this;
      var _iterator12 = _createForOfIteratorHelper(e),
        _step12;
      try {
        var _loop3 = function _loop3() {
          var t = _step12.value;
          var i = new w(_this21.locale);
          var n;
          i.on("execute", function () {
            return t.onExecute();
          }), t.onCreate && t.onCreate(i);
          for (n in t) n != "onExecute" && n != "onCreate" && i.set(n, t[n]);
          _this21.children.add(i);
        };
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      this._updateFocusCyclableItems();
    }
  }, {
    key: "focus",
    value: function focus(e) {
      e === -1 ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
    }
  }, {
    key: "_updateFocusCyclableItems",
    value: function _updateFocusCyclableItems() {
      var _this22 = this;
      Array.from(this.children).forEach(function (e) {
        _this22._focusables.add(e), _this22._focusTracker.add(e.element);
      });
    }
  }]);
}(d);
var Oi = /*#__PURE__*/function (_d6) {
  function Oi(e) {
    var _this23;
    _classCallCheck(this, Oi);
    _this23 = _callSuper(this, Oi, [e]);
    l(_this23, "children");
    _this23.children = _this23.createCollection(), _this23.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-dialog__content"]
      },
      children: _this23.children
    });
    return _this23;
  }
  _inherits(Oi, _d6);
  return _createClass(Oi, [{
    key: "reset",
    value: function reset() {
      for (; this.children.length;) this.children.remove(0);
    }
  }]);
}(d);
var v = {
    SCREEN_CENTER: "screen-center",
    EDITOR_CENTER: "editor-center",
    EDITOR_TOP_SIDE: "editor-top-side",
    EDITOR_TOP_CENTER: "editor-top-center",
    EDITOR_BOTTOM_CENTER: "editor-bottom-center",
    EDITOR_ABOVE_CENTER: "editor-above-center",
    EDITOR_BELOW_CENTER: "editor-below-center"
  },
  Ke = le("px"),
  ne = /*#__PURE__*/function (_Ei) {
    function ne(e, _ref7) {
      var _this24;
      var t = _ref7.getCurrentDomRoot,
        i = _ref7.getViewportOffset,
        n = _ref7.keystrokeHandlerOptions;
      _classCallCheck(this, ne);
      _this24 = _callSuper(this, ne, [e]);
      l(_this24, "parts");
      l(_this24, "headerView");
      l(_this24, "closeButtonView");
      l(_this24, "actionsView");
      l(_this24, "contentView");
      l(_this24, "keystrokes");
      l(_this24, "focusTracker");
      l(_this24, "wasMoved", !1);
      l(_this24, "_getCurrentDomRoot");
      l(_this24, "_getViewportOffset");
      l(_this24, "_focusables");
      l(_this24, "_focusCycler");
      var r = _this24.bindTemplate,
        a = e.t;
      _this24.set("className", ""), _this24.set("ariaLabel", a("Editor dialog")), _this24.set("isModal", !1), _this24.set("position", v.SCREEN_CENTER), _this24.set("_isVisible", !1), _this24.set("_isTransparent", !1), _this24.set("_top", 0), _this24.set("_left", 0), _this24._getCurrentDomRoot = t, _this24._getViewportOffset = i, _this24.decorate("moveTo"), _this24.parts = _this24.createCollection(), _this24.keystrokes = new O(), _this24.focusTracker = new T(), _this24._focusables = new A(), _this24._focusCycler = new H({
        focusables: _this24._focusables,
        focusTracker: _this24.focusTracker,
        keystrokeHandler: _this24.keystrokes,
        actions: {
          focusPrevious: "shift + tab",
          focusNext: "tab"
        },
        keystrokeHandlerOptions: n
      }), _this24.setTemplate({
        tag: "div",
        attributes: {
          class: ["ck", "ck-dialog-overlay", r.if("isModal", "ck-dialog-overlay__transparent", function (u) {
            return !u;
          }), r.if("_isVisible", "ck-hidden", function (u) {
            return !u;
          })],
          tabindex: "-1"
        },
        children: [{
          tag: "div",
          attributes: {
            tabindex: "-1",
            class: ["ck", "ck-dialog", r.if("isModal", "ck-dialog_modal"), r.to("className")],
            role: "dialog",
            "aria-label": r.to("ariaLabel"),
            style: {
              top: r.to("_top", function (u) {
                return Ke(u);
              }),
              left: r.to("_left", function (u) {
                return Ke(u);
              }),
              visibility: r.if("_isTransparent", "hidden")
            }
          },
          children: _this24.parts
        }]
      });
      return _this24;
    }
    _inherits(ne, _Ei);
    return _createClass(ne, [{
      key: "render",
      value: function render() {
        var _this25 = this;
        _superPropGet(ne, "render", this, 3)([]), this.keystrokes.set("Esc", function (e, t) {
          e.defaultPrevented || (_this25.fire("close", {
            source: "escKeyPress"
          }), t());
        }), this.on("drag", function (e, _ref8) {
          var t = _ref8.deltaX,
            i = _ref8.deltaY;
          _this25.wasMoved = !0, _this25.moveBy(t, i);
        }), this.listenTo(f.window, "resize", function () {
          _this25._isVisible && !_this25.wasMoved && _this25.updatePosition();
        }), this.listenTo(f.document, "scroll", function () {
          _this25._isVisible && !_this25.wasMoved && _this25.updatePosition();
        }), this.on("change:_isVisible", function (e, t, i) {
          i && (_this25._isTransparent = !0, setTimeout(function () {
            _this25.updatePosition(), _this25._isTransparent = !1, _this25.focus();
          }, 10));
        }), this.keystrokes.listenTo(this.element);
      }
    }, {
      key: "dragHandleElement",
      get: function get() {
        return this.headerView && !this.isModal ? this.headerView.element : null;
      }
    }, {
      key: "setupParts",
      value: function setupParts(_ref9) {
        var e = _ref9.icon,
          t = _ref9.title,
          _ref9$hasCloseButton = _ref9.hasCloseButton,
          i = _ref9$hasCloseButton === void 0 ? !0 : _ref9$hasCloseButton,
          n = _ref9.content,
          r = _ref9.actionButtons;
        t && (this.headerView = new Vi(this.locale, {
          icon: e
        }), i && (this.closeButtonView = this._createCloseButton(), this.headerView.children.add(this.closeButtonView)), this.headerView.label = t, this.ariaLabel = t, this.parts.add(this.headerView, 0)), n && (n instanceof d && (n = [n]), this.contentView = new Oi(this.locale), this.contentView.children.addMany(n), this.parts.add(this.contentView)), r && (this.actionsView = new Ii(this.locale), this.actionsView.setButtons(r), this.parts.add(this.actionsView)), this._updateFocusCyclableItems();
      }
    }, {
      key: "focus",
      value: function focus() {
        this._focusCycler.focusFirst();
      }
    }, {
      key: "moveTo",
      value: function moveTo(e, t) {
        var i = this._getViewportRect(),
          n = this._getDialogRect();
        e + n.width > i.right && (e = i.right - n.width), e < i.left && (e = i.left), t < i.top && (t = i.top), this._moveTo(e, t);
      }
    }, {
      key: "_moveTo",
      value: function _moveTo(e, t) {
        this._left = e, this._top = t;
      }
    }, {
      key: "moveBy",
      value: function moveBy(e, t) {
        this.moveTo(this._left + e, this._top + t);
      }
    }, {
      key: "_moveOffScreen",
      value: function _moveOffScreen() {
        this._moveTo(-9999, -9999);
      }
    }, {
      key: "updatePosition",
      value: function updatePosition() {
        if (!this.element || !this.element.parentNode) return;
        var e = this._getViewportRect();
        var t = this.position,
          i;
        this._getCurrentDomRoot() ? i = this._getVisibleDomRootRect(e) : t = v.SCREEN_CENTER;
        var n = ne.defaultOffset,
          r = this._getDialogRect();
        switch (t) {
          case v.EDITOR_TOP_SIDE:
            {
              if (i) {
                var a = this.locale.contentLanguageDirection === "ltr" ? i.right - r.width - n : i.left + n;
                this.moveTo(a, i.top + n);
              } else this._moveOffScreen();
              break;
            }
          case v.EDITOR_CENTER:
            {
              i ? this.moveTo(Math.round(i.left + i.width / 2 - r.width / 2), Math.round(i.top + i.height / 2 - r.height / 2)) : this._moveOffScreen();
              break;
            }
          case v.SCREEN_CENTER:
            {
              this.moveTo(Math.round((e.width - r.width) / 2), Math.round((e.height - r.height) / 2));
              break;
            }
          case v.EDITOR_TOP_CENTER:
            {
              i ? this.moveTo(Math.round(i.left + i.width / 2 - r.width / 2), i.top + n) : this._moveOffScreen();
              break;
            }
          case v.EDITOR_BOTTOM_CENTER:
            {
              i ? this.moveTo(Math.round(i.left + i.width / 2 - r.width / 2), i.bottom - r.height - n) : this._moveOffScreen();
              break;
            }
          case v.EDITOR_ABOVE_CENTER:
            {
              i ? this.moveTo(Math.round(i.left + i.width / 2 - r.width / 2), i.top - r.height - n) : this._moveOffScreen();
              break;
            }
          case v.EDITOR_BELOW_CENTER:
            {
              i ? this.moveTo(Math.round(i.left + i.width / 2 - r.width / 2), i.bottom + n) : this._moveOffScreen();
              break;
            }
        }
      }
    }, {
      key: "_getVisibleDomRootRect",
      value: function _getVisibleDomRootRect(e) {
        var t = new C(this._getCurrentDomRoot()).getVisible();
        if (t) {
          if (t = e.getIntersection(t), !t) return null;
        } else return null;
        return t;
      }
    }, {
      key: "_getDialogRect",
      value: function _getDialogRect() {
        return new C(this.element.firstElementChild);
      }
    }, {
      key: "_getViewportRect",
      value: function _getViewportRect() {
        var e = new C(f.window);
        if (this.isModal) return e;
        var t = _objectSpread({
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }, this._getViewportOffset());
        return e.top += t.top, e.height -= t.top, e.bottom -= t.bottom, e.height -= t.bottom, e.left += t.left, e.right -= t.right, e.width -= t.left + t.right, e;
      }
    }, {
      key: "_updateFocusCyclableItems",
      value: function _updateFocusCyclableItems() {
        var _this26 = this;
        var e = [];
        if (this.contentView) {
          var _iterator13 = _createForOfIteratorHelper(this.contentView.children),
            _step13;
          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var t = _step13.value;
              j(t) && e.push(t);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
        }
        this.actionsView && e.push(this.actionsView), this.closeButtonView && e.push(this.closeButtonView), e.forEach(function (t) {
          _this26._focusables.add(t), _this26.focusTracker.add(t.element), xi(t) && _this26._focusCycler.chain(t.focusCycler);
        });
      }
    }, {
      key: "_createCloseButton",
      value: function _createCloseButton() {
        var _this27 = this;
        var e = new w(this.locale),
          t = this.locale.t;
        return e.set({
          label: t("Close"),
          tooltip: !0,
          icon: dt
        }), e.on("execute", function () {
          return _this27.fire("close", {
            source: "closeButton"
          });
        }), e;
      }
    }]);
  }(Ei(d));
l(ne, "defaultOffset", 15);
var ke = ne;
var y = /*#__PURE__*/function (_Ee) {
  function y(e) {
    var _this28;
    _classCallCheck(this, y);
    _this28 = _callSuper(this, y, [e]);
    l(_this28, "view");
    l(_this28, "_onHide");
    var t = e.t;
    _this28._initShowHideListeners(), _this28._initFocusToggler(), _this28._initMultiRootIntegration(), _this28.set({
      id: null,
      isOpen: !1
    }), e.accessibility.addKeystrokeInfos({
      categoryId: "navigation",
      keystrokes: [{
        label: t("Move focus in and out of an active dialog window"),
        keystroke: "Ctrl+F6",
        mayRequireFn: !0
      }]
    });
    return _this28;
  }
  _inherits(y, _Ee);
  return _createClass(y, [{
    key: "destroy",
    value: function destroy() {
      _superPropGet(y, "destroy", this, 3)([]), y._visibleDialogPlugin === this && this._unlockBodyScroll();
    }
  }, {
    key: "_initShowHideListeners",
    value: function _initShowHideListeners() {
      var _this29 = this;
      this.on("show", function (e, t) {
        _this29._show(t);
      }), this.on("show", function (e, t) {
        t.onShow && t.onShow(_this29);
      }, {
        priority: "low"
      }), this.on("hide", function () {
        y._visibleDialogPlugin && y._visibleDialogPlugin._hide();
      }), this.on("hide", function () {
        _this29._onHide && (_this29._onHide(_this29), _this29._onHide = void 0);
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_initFocusToggler",
    value: function _initFocusToggler() {
      var _this30 = this;
      var e = this.editor;
      e.keystrokes.set("Ctrl+F6", function (t, i) {
        !_this30.isOpen || _this30.view.isModal || (_this30.view.focusTracker.isFocused ? e.editing.view.focus() : _this30.view.focus(), i());
      });
    }
  }, {
    key: "_initMultiRootIntegration",
    value: function _initMultiRootIntegration() {
      var _this31 = this;
      var e = this.editor.model;
      e.document.on("change:data", function () {
        if (!_this31.view) return;
        var t = e.document.differ.getChangedRoots();
        var _iterator14 = _createForOfIteratorHelper(t),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var i = _step14.value;
            i.state && _this31.view.updatePosition();
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      });
    }
  }, {
    key: "show",
    value: function show(e) {
      this.hide(), this.fire("show:".concat(e.id), e);
    }
  }, {
    key: "_show",
    value: function _show(_ref0) {
      var _this32 = this;
      var e = _ref0.id,
        t = _ref0.icon,
        i = _ref0.title,
        _ref0$hasCloseButton = _ref0.hasCloseButton,
        n = _ref0$hasCloseButton === void 0 ? !0 : _ref0$hasCloseButton,
        r = _ref0.content,
        a = _ref0.actionButtons,
        u = _ref0.className,
        c = _ref0.isModal,
        h = _ref0.position,
        p = _ref0.onHide,
        b = _ref0.keystrokeHandlerOptions;
      var g = this.editor;
      this.view = new ke(g.locale, {
        getCurrentDomRoot: function getCurrentDomRoot() {
          return g.editing.view.getDomRoot(g.model.document.selection.anchor.root.rootName);
        },
        getViewportOffset: function getViewportOffset() {
          return g.ui.viewportOffset;
        },
        keystrokeHandlerOptions: b
      });
      var D = this.view;
      D.on("close", function () {
        _this32.hide();
      }), g.ui.view.body.add(D), g.keystrokes.listenTo(D.element), h || (h = c ? v.SCREEN_CENTER : v.EDITOR_CENTER), c && this._lockBodyScroll(), D.set({
        position: h,
        _isVisible: !0,
        className: u,
        isModal: c
      }), D.setupParts({
        icon: t,
        title: i,
        hasCloseButton: n,
        content: r,
        actionButtons: a
      }), this.id = e, p && (this._onHide = p), this.isOpen = !0, y._visibleDialogPlugin = this;
    }
  }, {
    key: "hide",
    value: function hide() {
      y._visibleDialogPlugin && y._visibleDialogPlugin.fire("hide:".concat(y._visibleDialogPlugin.id));
    }
  }, {
    key: "_hide",
    value: function _hide() {
      if (!this.view) return;
      var e = this.editor,
        t = this.view;
      t.isModal && this._unlockBodyScroll(), t.contentView && t.contentView.reset(), e.ui.view.body.remove(t), e.ui.focusTracker.remove(t.element), e.keystrokes.stopListening(t.element), t.destroy(), e.editing.view.focus(), this.id = null, this.isOpen = !1, y._visibleDialogPlugin = null;
    }
  }, {
    key: "_lockBodyScroll",
    value: function _lockBodyScroll() {
      document.documentElement.classList.add("ck-dialog-scroll-locked");
    }
  }, {
    key: "_unlockBodyScroll",
    value: function _unlockBodyScroll() {
      document.documentElement.classList.remove("ck-dialog-scroll-locked");
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Dialog";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(Ee);
l(y, "_visibleDialogPlugin");
var Te = y;
var z = /*#__PURE__*/function (_w) {
  function z(e) {
    var _this33;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Tt();
    _classCallCheck(this, z);
    _this33 = _callSuper(this, z, [e, t]);
    l(_this33, "_checkIconHolderView", new Pi());
    _this33.set({
      hasCheckSpace: !1,
      _hasCheck: _this33.isToggleable
    });
    var i = _this33.bindTemplate;
    _this33.extendTemplate({
      attributes: {
        class: ["ck-list-item-button", i.if("isToggleable", "ck-list-item-button_toggleable")]
      }
    }), _this33.bind("_hasCheck").to(_this33, "hasCheckSpace", _this33, "isToggleable", function (n, r) {
      return n || r;
    });
    return _this33;
  }
  _inherits(z, _w);
  return _createClass(z, [{
    key: "render",
    value: function render() {
      _superPropGet(z, "render", this, 3)([]), this._hasCheck && this.children.add(this._checkIconHolderView, 0), this._watchCheckIconHolderMount();
    }
  }, {
    key: "_watchCheckIconHolderMount",
    value: function _watchCheckIconHolderMount() {
      var _this34 = this;
      this._checkIconHolderView.bind("isOn").to(this, "isOn", function (e) {
        return _this34.isToggleable && e;
      }), this.on("change:_hasCheck", function (e, t, i) {
        var n = _this34.children,
          r = _this34._checkIconHolderView;
        i ? n.add(r, 0) : n.remove(r);
      });
    }
  }]);
}(w);
var Pi = /*#__PURE__*/function (_d7) {
  function Pi() {
    var _this35;
    _classCallCheck(this, Pi);
    _this35 = _callSuper(this, Pi);
    l(_this35, "children");
    l(_this35, "_checkIconView", _this35._createCheckIconView());
    var e = _this35.bindTemplate;
    _this35.children = _this35.createCollection(), _this35.set("isOn", !1), _this35.setTemplate({
      tag: "span",
      children: _this35.children,
      attributes: {
        class: ["ck", "ck-list-item-button__check-holder", e.to("isOn", function (t) {
          return t ? "ck-on" : "ck-off";
        })]
      }
    });
    return _this35;
  }
  _inherits(Pi, _d7);
  return _createClass(Pi, [{
    key: "render",
    value: function render() {
      _superPropGet(Pi, "render", this, 3)([]), this.isOn && this.children.add(this._checkIconView, 0), this._watchCheckIconMount();
    }
  }, {
    key: "_watchCheckIconMount",
    value: function _watchCheckIconMount() {
      var _this36 = this;
      this.on("change:isOn", function (e, t, i) {
        var n = _this36.children,
          r = _this36._checkIconView;
        i && !n.has(r) ? n.add(r) : !i && n.has(r) && n.remove(r);
      });
    }
  }, {
    key: "_createCheckIconView",
    value: function _createCheckIconView() {
      var e = new L();
      return e.content = ft, e.extendTemplate({
        attributes: {
          class: "ck-list-item-button__check-icon"
        }
      }), e;
    }
  }]);
}(d);
var vt = /*#__PURE__*/function (_z) {
  function vt(o) {
    var _this37;
    _classCallCheck(this, vt);
    _this37 = _callSuper(this, vt, [o]), _this37.set({
      withText: !0,
      withKeystroke: !0,
      tooltip: !1,
      role: "menuitem"
    }), _this37.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__item__button"]
      }
    });
    return _this37;
  }
  _inherits(vt, _z);
  return _createClass(vt);
}(z);
var de = /*#__PURE__*/function (_d8) {
  function de(e) {
    var _this38;
    _classCallCheck(this, de);
    _this38 = _callSuper(this, de, [e]);
    l(_this38, "id");
    _this38.set("text", void 0), _this38.set("for", void 0), _this38.id = "ck-editor__label_".concat(te());
    var t = _this38.bindTemplate;
    _this38.setTemplate({
      tag: "label",
      attributes: {
        class: ["ck", "ck-label"],
        id: _this38.id,
        for: t.to("for")
      },
      children: [{
        text: t.to("text")
      }]
    });
    return _this38;
  }
  _inherits(de, _d8);
  return _createClass(de);
}(d);
var Bi = /*#__PURE__*/function (_d9) {
  function Bi(o, e) {
    var _this39;
    _classCallCheck(this, Bi);
    _this39 = _callSuper(this, Bi, [o]);
    var t = o.t,
      i = new de();
    i.text = t("Help Contents. To close this dialog press ESC."), _this39.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-accessibility-help-dialog__content"],
        "aria-labelledby": i.id,
        role: "document",
        tabindex: -1
      },
      children: [I(document, "p", {}, t("Below, you can find a list of keyboard shortcuts that can be used in the editor."))].concat(_toConsumableArray(_this39._createCategories(Array.from(e.values()))), [i])
    });
    return _this39;
  }
  _inherits(Bi, _d9);
  return _createClass(Bi, [{
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }, {
    key: "_createCategories",
    value: function _createCategories(o) {
      var _this40 = this;
      return o.map(function (e) {
        var t = [I(document, "h3", {}, e.label)].concat(_toConsumableArray(Array.from(e.groups.values()).map(function (i) {
          return _this40._createGroup(i);
        }).flat()));
        return e.description && t.splice(1, 0, I(document, "p", {}, e.description)), I(document, "section", {}, t);
      });
    }
  }, {
    key: "_createGroup",
    value: function _createGroup(o) {
      var _this41 = this;
      var e = o.keystrokes.sort(function (i, n) {
          return i.label.localeCompare(n.label);
        }).map(function (i) {
          return _this41._createGroupRow(i);
        }).flat(),
        t = [I(document, "dl", {}, e)];
      return o.label && t.unshift(I(document, "h4", {}, o.label)), t;
    }
  }, {
    key: "_createGroupRow",
    value: function _createGroupRow(o) {
      var e = this.locale.t,
        t = I(document, "dt"),
        i = I(document, "dd"),
        n = Fi(o.keystroke),
        r = [];
      var _iterator15 = _createForOfIteratorHelper(n),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var a = _step15.value;
          r.push(a.map(Li).join(""));
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return t.innerHTML = o.label, i.innerHTML = r.join(", ") + (o.mayRequireFn && S.isMac ? " ".concat(e("(may require <kbd>Fn</kbd>)")) : ""), [t, i];
    }
  }]);
}(d);
function Li(s) {
  return ee(s).split("+").map(function (o) {
    return "<kbd>".concat(o, "</kbd>");
  }).join("+");
}
function Fi(s) {
  return typeof s == "string" ? [[s]] : typeof s[0] == "string" ? [s] : s;
}
var mo = /*#__PURE__*/function (_Ee2) {
  function mo() {
    var _this42;
    _classCallCheck(this, mo);
    _this42 = _callSuper(this, mo, arguments);
    l(_this42, "contentView", null);
    return _this42;
  }
  _inherits(mo, _Ee2);
  return _createClass(mo, [{
    key: "init",
    value: function init() {
      var _this43 = this;
      var e = this.editor,
        t = e.locale.t;
      e.ui.componentFactory.add("accessibilityHelp", function () {
        var i = _this43._createButton(w);
        return i.set({
          tooltip: !0,
          withText: !1,
          label: t("Accessibility help")
        }), i;
      }), e.ui.componentFactory.add("menuBar:accessibilityHelp", function () {
        var i = _this43._createButton(vt);
        return i.label = t("Accessibility"), i;
      }), e.keystrokes.set("Alt+0", function (i, n) {
        _this43._toggleDialog(), n();
      }), this._setupRootLabels();
    }
  }, {
    key: "_createButton",
    value: function _createButton(e) {
      var _this44 = this;
      var t = this.editor,
        i = t.plugins.get("Dialog"),
        n = t.locale,
        r = new e(n);
      return r.set({
        keystroke: "Alt+0",
        icon: Me,
        isToggleable: !0
      }), r.on("execute", function () {
        return _this44._toggleDialog();
      }), r.bind("isOn").to(i, "id", function (a) {
        return a === "accessibilityHelp";
      }), r;
    }
  }, {
    key: "_setupRootLabels",
    value: function _setupRootLabels() {
      var e = this.editor,
        t = e.editing.view,
        i = e.t;
      e.ui.on("ready", function () {
        t.change(function (r) {
          var _iterator16 = _createForOfIteratorHelper(t.document.roots),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var a = _step16.value;
              n(r, a);
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }), e.on("addRoot", function (r, a) {
          var u = e.editing.view.document.getRoot(a.rootName);
          t.change(function (c) {
            return n(c, u);
          });
        }, {
          priority: "low"
        });
      });
      function n(r, a) {
        var c = [a.getAttribute("aria-label"), i("Press %0 for help.", [ee("Alt+0")])].filter(function (h) {
          return h;
        }).join(". ");
        r.setAttribute("aria-label", c, a);
      }
    }
  }, {
    key: "_toggleDialog",
    value: function _toggleDialog() {
      var e = this.editor,
        t = e.plugins.get("Dialog"),
        i = e.locale.t;
      this.contentView || (this.contentView = new Bi(e.locale, e.accessibility.keystrokeInfos)), t.id === "accessibilityHelp" ? t.hide() : t.show({
        id: "accessibilityHelp",
        className: "ck-accessibility-help-dialog",
        title: i("Accessibility help"),
        icon: Me,
        hasCloseButton: !0,
        content: this.contentView
      });
    }
  }], [{
    key: "requires",
    get: function get() {
      return [Te];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "AccessibilityHelp";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(Ee);
var k = /*#__PURE__*/function (_A) {
  function k(e) {
    var _this45;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, k);
    _this45 = _callSuper(this, k, [t]);
    l(_this45, "locale");
    l(_this45, "_bodyCollectionContainer");
    _this45.locale = e;
    return _this45;
  }
  _inherits(k, _A);
  return _createClass(k, [{
    key: "bodyCollectionContainer",
    get: function get() {
      return this._bodyCollectionContainer;
    }
  }, {
    key: "attachToDom",
    value: function attachToDom() {
      this._bodyCollectionContainer = new E({
        tag: "div",
        attributes: {
          class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
          dir: this.locale.uiLanguageDirection,
          role: "application"
        },
        children: this
      }).render(), (!k._bodyWrapper || !k._bodyWrapper.isConnected) && (k._bodyWrapper = I(document, "div", {
        class: "ck-body-wrapper"
      }), document.body.appendChild(k._bodyWrapper)), k._bodyWrapper.appendChild(this._bodyCollectionContainer);
    }
  }, {
    key: "detachFromDom",
    value: function detachFromDom() {
      _superPropGet(k, "destroy", this, 3)([]), this._bodyCollectionContainer && this._bodyCollectionContainer.remove(), k._bodyWrapper && !k._bodyWrapper.childElementCount && (k._bodyWrapper.remove(), delete k._bodyWrapper);
    }
  }]);
}(A);
l(k, "_bodyWrapper");
var ve = k;
var yt = /*#__PURE__*/function (_w2) {
  function yt(e) {
    var _this46;
    _classCallCheck(this, yt);
    _this46 = _callSuper(this, yt, [e]);
    l(_this46, "toggleSwitchView");
    _this46.isToggleable = !0, _this46.toggleSwitchView = _this46._createToggleView(), _this46.extendTemplate({
      attributes: {
        class: "ck-switchbutton"
      }
    });
    return _this46;
  }
  _inherits(yt, _w2);
  return _createClass(yt, [{
    key: "render",
    value: function render() {
      _superPropGet(yt, "render", this, 3)([]), this.children.add(this.toggleSwitchView);
    }
  }, {
    key: "_createToggleView",
    value: function _createToggleView() {
      var e = new d();
      return e.setTemplate({
        tag: "span",
        attributes: {
          class: ["ck", "ck-button__toggle"]
        },
        children: [{
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__toggle__inner"]
          }
        }]
      }), e;
    }
  }]);
}(w);
var wo = /*#__PURE__*/function (_Ct) {
  function wo() {
    _classCallCheck(this, wo);
    return _callSuper(this, wo, arguments);
  }
  _inherits(wo, _Ct);
  return _createClass(wo);
}(Ct(w));
var Ai = /*#__PURE__*/function (_Ct2) {
  function Ai() {
    _classCallCheck(this, Ai);
    return _callSuper(this, Ai, arguments);
  }
  _inherits(Ai, _Ct2);
  return _createClass(Ai);
}(Ct(z));
function Ct(s) {
  var o = /*#__PURE__*/function (_s4) {
    function o() {
      var _this47;
      _classCallCheck(this, o);
      for (var _len4 = arguments.length, i = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        i[_key4] = arguments[_key4];
      }
      _this47 = _callSuper(this, o, [].concat(i));
      l(_this47, "buttonView");
      l(_this47, "_fileInputView");
      _this47.buttonView = _this47, _this47._fileInputView = new Di(_this47.locale), _this47._fileInputView.bind("acceptedType").to(_this47), _this47._fileInputView.bind("allowMultipleFiles").to(_this47), _this47._fileInputView.delegate("done").to(_this47), _this47.on("execute", function () {
        _this47._fileInputView.open();
      }), _this47.extendTemplate({
        attributes: {
          class: "ck-file-dialog-button"
        }
      });
      return _this47;
    }
    _inherits(o, _s4);
    return _createClass(o, [{
      key: "render",
      value: function render() {
        _superPropGet(o, "render", this, 3)([]), this.children.add(this._fileInputView);
      }
    }]);
  }(s);
  return o;
}
var Di = /*#__PURE__*/function (_d0) {
  function Di(o) {
    var _this48;
    _classCallCheck(this, Di);
    _this48 = _callSuper(this, Di, [o]), _this48.set("acceptedType", void 0), _this48.set("allowMultipleFiles", !1);
    var e = _this48.bindTemplate;
    _this48.setTemplate({
      tag: "input",
      attributes: {
        class: ["ck-hidden"],
        type: "file",
        tabindex: "-1",
        accept: e.to("acceptedType"),
        multiple: e.to("allowMultipleFiles")
      },
      on: {
        change: e.to(function () {
          var t, i;
          (i = (t = _this48.element) == null ? void 0 : t.files) != null && i.length && _this48.fire("done", _this48.element.files), _this48.element.value = "";
        })
      }
    });
    return _this48;
  }
  _inherits(Di, _d0);
  return _createClass(Di, [{
    key: "open",
    value: function open() {
      this.element.click();
    }
  }]);
}(d);
var bo = /*#__PURE__*/function (_d1) {
  function bo(e, t) {
    var _this49;
    _classCallCheck(this, bo);
    _this49 = _callSuper(this, bo, [e]);
    l(_this49, "buttonView");
    l(_this49, "children");
    var i = _this49.bindTemplate;
    _this49.set("isCollapsed", !1), _this49.set("label", ""), _this49.buttonView = _this49._createButtonView(), _this49.children = _this49.createCollection(), _this49.set("_collapsibleAriaLabelUid", void 0), t && _this49.children.addMany(t), _this49.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-collapsible", i.if("isCollapsed", "ck-collapsible_collapsed")]
      },
      children: [_this49.buttonView, {
        tag: "div",
        attributes: {
          class: ["ck", "ck-collapsible__children"],
          role: "region",
          hidden: i.if("isCollapsed", "hidden"),
          "aria-labelledby": i.to("_collapsibleAriaLabelUid")
        },
        children: _this49.children
      }]
    });
    return _this49;
  }
  _inherits(bo, _d1);
  return _createClass(bo, [{
    key: "render",
    value: function render() {
      _superPropGet(bo, "render", this, 3)([]), this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.buttonView.focus();
    }
  }, {
    key: "_createButtonView",
    value: function _createButtonView() {
      var _this50 = this;
      var e = new w(this.locale),
        t = e.bindTemplate;
      return e.set({
        withText: !0,
        icon: ue
      }), e.extendTemplate({
        attributes: {
          "aria-expanded": t.to("isOn", function (i) {
            return String(i);
          })
        }
      }), e.bind("label").to(this), e.bind("isOn").to(this, "isCollapsed", function (i) {
        return !i;
      }), e.on("execute", function () {
        _this50.isCollapsed = !_this50.isCollapsed;
      }), e;
    }
  }]);
}(d);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function go(s, o) {
  var e = s.t,
    t = {
      Black: e("Black"),
      "Dim grey": e("Dim grey"),
      Grey: e("Grey"),
      "Light grey": e("Light grey"),
      White: e("White"),
      Red: e("Red"),
      Orange: e("Orange"),
      Yellow: e("Yellow"),
      "Light green": e("Light green"),
      Green: e("Green"),
      Aquamarine: e("Aquamarine"),
      Turquoise: e("Turquoise"),
      "Light blue": e("Light blue"),
      Blue: e("Blue"),
      Purple: e("Purple")
    };
  return o.map(function (i) {
    var n = t[i.label];
    return n && n != i.label && (i.label = n), i;
  });
}
function _o(s) {
  return s.map(Si).filter(function (o) {
    return !!o;
  });
}
function Si(s) {
  return typeof s == "string" ? {
    model: s,
    label: s,
    hasBorder: !1,
    view: {
      name: "span",
      styles: {
        color: s
      }
    }
  } : {
    model: s.color,
    label: s.label || s.color,
    hasBorder: s.hasBorder === void 0 ? !1 : s.hasBorder,
    view: {
      name: "span",
      styles: {
        color: "".concat(s.color)
      }
    }
  };
}
var Vt = /*#__PURE__*/function (_w3) {
  function Vt(o) {
    var _this51;
    _classCallCheck(this, Vt);
    _this51 = _callSuper(this, Vt, [o]);
    var e = _this51.bindTemplate;
    _this51.set("color", void 0), _this51.set("hasBorder", !1), _this51.icon = ai, _this51.extendTemplate({
      attributes: {
        style: {
          backgroundColor: e.to("color", function (t) {
            return S.isMediaForcedColors ? null : t;
          })
        },
        class: ["ck", "ck-color-grid__tile", e.if("hasBorder", "ck-color-selector__color-tile_bordered")]
      }
    });
    return _this51;
  }
  _inherits(Vt, _w3);
  return _createClass(Vt, [{
    key: "render",
    value: function render() {
      _superPropGet(Vt, "render", this, 3)([]), this.iconView.fillColor = "hsl(0, 0%, 100%)";
    }
  }]);
}(w);
var je = /*#__PURE__*/function (_d10) {
  function je(e, t) {
    var _this52;
    _classCallCheck(this, je);
    _this52 = _callSuper(this, je, [e]);
    l(_this52, "columns");
    l(_this52, "items");
    l(_this52, "focusTracker");
    l(_this52, "keystrokes");
    var i = t && t.colorDefinitions ? t.colorDefinitions : [];
    _this52.columns = (t == null ? void 0 : t.columns) || 5;
    var n = {
      gridTemplateColumns: "repeat( ".concat(_this52.columns, ", 1fr)")
    };
    _this52.set("selectedColor", void 0), _this52.items = _this52.createCollection(), _this52.focusTracker = new T(), _this52.keystrokes = new O(), _this52.items.on("add", function (r, a) {
      a.isOn = a.color === _this52.selectedColor;
    }), i.forEach(function (r) {
      var a = new Vt();
      a.set({
        color: r.color,
        label: r.label,
        tooltip: !0,
        hasBorder: r.options.hasBorder
      }), a.on("execute", function () {
        _this52.fire("execute", {
          value: r.color,
          hasBorder: r.options.hasBorder,
          label: r.label
        });
      }), _this52.items.add(a);
    }), _this52.setTemplate({
      tag: "div",
      children: _this52.items,
      attributes: {
        class: ["ck", "ck-color-grid"],
        style: n
      }
    }), _this52.on("change:selectedColor", function (r, a, u) {
      var _iterator17 = _createForOfIteratorHelper(_this52.items),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var c = _step17.value;
          c.isOn = c.color === u;
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    });
    return _this52;
  }
  _inherits(je, _d10);
  return _createClass(je, [{
    key: "focus",
    value: function focus() {
      this.items.length && this.items.first.focus();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this.items.length && this.items.last.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this53 = this;
      var e;
      _superPropGet(je, "render", this, 3)([]);
      var _iterator18 = _createForOfIteratorHelper(this.items),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var t = _step18.value;
          this.focusTracker.add(t.element);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      this.items.on("add", function (t, i) {
        _this53.focusTracker.add(i.element);
      }), this.items.on("remove", function (t, i) {
        _this53.focusTracker.remove(i.element);
      }), this.keystrokes.listenTo(this.element), Ci({
        keystrokeHandler: this.keystrokes,
        focusTracker: this.focusTracker,
        gridItems: this.items,
        numberOfColumns: this.columns,
        uiLanguageDirection: (e = this.locale) == null ? void 0 : e.uiLanguageDirection
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(je, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }]);
}(d);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function xt(s, o) {
  if (!s) return "";
  var e = Et(s);
  if (!e) return "";
  if (e.space === o) return s;
  if (!Gi(e)) return "";
  var i = pt[e.space][o];
  if (!i) return "";
  var n = i(e.space === "hex" ? e.hexValue : e.values);
  return Wi(n, o);
}
function Mi(s) {
  if (!s) return "";
  var o = Et(s);
  return o ? o.space === "hex" ? o.hexValue : xt(s, "hex") : "#000";
}
function Ni(s, o) {
  customElements.get(s) === void 0 && customElements.define(s, o);
}
function Wi(s, o) {
  switch (o) {
    case "hex":
      return "#".concat(s);
    case "rgb":
      return "rgb(".concat(s[0], ", ").concat(s[1], ", ").concat(s[2], ")");
    case "hsl":
      return "hsl(".concat(s[0], ", ").concat(s[1], "%, ").concat(s[2], "%)");
    case "hwb":
      return "hwb(".concat(s[0], ", ").concat(s[1], ", ").concat(s[2], ")");
    case "lab":
      return "lab(".concat(s[0], "% ").concat(s[1], " ").concat(s[2], ")");
    case "lch":
      return "lch(".concat(s[0], "% ").concat(s[1], " ").concat(s[2], ")");
    default:
      return "";
  }
}
function Et(s) {
  if (s.startsWith("#")) {
    var _e0 = Ne(s);
    return {
      space: "hex",
      values: _e0.values,
      hexValue: s,
      alpha: _e0.alpha
    };
  }
  var o = Ne(s);
  return o.space ? o : null;
}
function Gi(s) {
  return Object.keys(pt).includes(s.space);
}
var Ri = /*#__PURE__*/function (_d11) {
  function Ri(e, t) {
    var _this54;
    _classCallCheck(this, Ri);
    _this54 = _callSuper(this, Ri, [e]);
    l(_this54, "fieldView");
    l(_this54, "labelView");
    l(_this54, "statusView");
    l(_this54, "fieldWrapperChildren");
    var i = "ck-labeled-field-view-".concat(te()),
      n = "ck-labeled-field-view-status-".concat(te());
    _this54.fieldView = t(_this54, i, n), _this54.set("label", void 0), _this54.set("isEnabled", !0), _this54.set("isEmpty", !0), _this54.set("isFocused", !1), _this54.set("errorText", null), _this54.set("infoText", null), _this54.set("class", void 0), _this54.set("placeholder", void 0), _this54.labelView = _this54._createLabelView(i), _this54.statusView = _this54._createStatusView(n), _this54.fieldWrapperChildren = _this54.createCollection([_this54.fieldView, _this54.labelView]), _this54.bind("_statusText").to(_this54, "errorText", _this54, "infoText", function (a, u) {
      return a || u;
    });
    var r = _this54.bindTemplate;
    _this54.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-labeled-field-view", r.to("class"), r.if("isEnabled", "ck-disabled", function (a) {
          return !a;
        }), r.if("isEmpty", "ck-labeled-field-view_empty"), r.if("isFocused", "ck-labeled-field-view_focused"), r.if("placeholder", "ck-labeled-field-view_placeholder"), r.if("errorText", "ck-error")]
      },
      children: [{
        tag: "div",
        attributes: {
          class: ["ck", "ck-labeled-field-view__input-wrapper"]
        },
        children: _this54.fieldWrapperChildren
      }, _this54.statusView]
    });
    return _this54;
  }
  _inherits(Ri, _d11);
  return _createClass(Ri, [{
    key: "_createLabelView",
    value: function _createLabelView(e) {
      var t = new de(this.locale);
      return t.for = e, t.bind("text").to(this, "label"), t;
    }
  }, {
    key: "_createStatusView",
    value: function _createStatusView(e) {
      var t = new d(this.locale),
        i = this.bindTemplate;
      return t.setTemplate({
        tag: "div",
        attributes: {
          class: ["ck", "ck-labeled-field-view__status", i.if("errorText", "ck-labeled-field-view__status_error"), i.if("_statusText", "ck-hidden", function (n) {
            return !n;
          })],
          id: e,
          role: i.if("errorText", "alert")
        },
        children: [{
          text: i.to("_statusText")
        }]
      }), t;
    }
  }, {
    key: "focus",
    value: function focus(e) {
      this.fieldView.focus(e);
    }
  }]);
}(d);
var Hi = /*#__PURE__*/function (_d12) {
  function Hi(e) {
    var _this55;
    _classCallCheck(this, Hi);
    _this55 = _callSuper(this, Hi, [e]);
    l(_this55, "focusTracker");
    _this55.set("value", void 0), _this55.set("id", void 0), _this55.set("placeholder", void 0), _this55.set("tabIndex", void 0), _this55.set("isReadOnly", !1), _this55.set("hasError", !1), _this55.set("ariaDescribedById", void 0), _this55.set("ariaLabel", void 0), _this55.focusTracker = new T(), _this55.bind("isFocused").to(_this55.focusTracker), _this55.set("isEmpty", !0);
    var t = _this55.bindTemplate;
    _this55.setTemplate({
      tag: "input",
      attributes: {
        class: ["ck", "ck-input", t.if("isFocused", "ck-input_focused"), t.if("isEmpty", "ck-input-text_empty"), t.if("hasError", "ck-error")],
        id: t.to("id"),
        placeholder: t.to("placeholder"),
        tabindex: t.to("tabIndex"),
        readonly: t.to("isReadOnly"),
        "aria-invalid": t.if("hasError", !0),
        "aria-describedby": t.to("ariaDescribedById"),
        "aria-label": t.to("ariaLabel")
      },
      on: {
        input: t.to(function () {
          var _this56;
          for (var _len5 = arguments.length, i = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            i[_key5] = arguments[_key5];
          }
          (_this56 = _this55).fire.apply(_this56, ["input"].concat(i)), _this55._updateIsEmpty();
        }),
        change: t.to(_this55._updateIsEmpty.bind(_this55))
      }
    });
    return _this55;
  }
  _inherits(Hi, _d12);
  return _createClass(Hi, [{
    key: "render",
    value: function render() {
      var _this57 = this;
      _superPropGet(Hi, "render", this, 3)([]), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", function (e, t, i) {
        _this57._setDomElementValue(i), _this57._updateIsEmpty();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Hi, "destroy", this, 3)([]), this.focusTracker.destroy();
    }
  }, {
    key: "select",
    value: function select() {
      this.element.select();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.value = this.element.value = "", this._updateIsEmpty();
    }
  }, {
    key: "_updateIsEmpty",
    value: function _updateIsEmpty() {
      this.isEmpty = zi(this.element);
    }
  }, {
    key: "_setDomElementValue",
    value: function _setDomElementValue(e) {
      this.element.value = !e && e !== 0 ? "" : e;
    }
  }]);
}(d);
function zi(s) {
  return !s.value;
}
var It = /*#__PURE__*/function (_Hi) {
  function It(o) {
    var _this58;
    _classCallCheck(this, It);
    _this58 = _callSuper(this, It, [o]), _this58.set("inputMode", "text");
    var e = _this58.bindTemplate;
    _this58.extendTemplate({
      attributes: {
        inputmode: e.to("inputMode")
      }
    });
    return _this58;
  }
  _inherits(It, _Hi);
  return _createClass(It);
}(Hi);
var Ui = /*#__PURE__*/function (_It) {
  function Ui(o) {
    var _this59;
    _classCallCheck(this, Ui);
    _this59 = _callSuper(this, Ui, [o]), _this59.extendTemplate({
      attributes: {
        type: "text",
        class: ["ck-input-text"]
      }
    });
    return _this59;
  }
  _inherits(Ui, _It);
  return _createClass(Ui);
}(It);
var $i = /*#__PURE__*/function (_It2) {
  function $i(o) {
    var _this60;
    var _ref1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      e = _ref1.min,
      t = _ref1.max,
      i = _ref1.step;
    _classCallCheck(this, $i);
    _this60 = _callSuper(this, $i, [o]);
    var n = _this60.bindTemplate;
    _this60.set("min", e), _this60.set("max", t), _this60.set("step", i), _this60.extendTemplate({
      attributes: {
        type: "number",
        class: ["ck-input-number"],
        min: n.to("min"),
        max: n.to("max"),
        step: n.to("step")
      }
    });
    return _this60;
  }
  _inherits($i, _It2);
  return _createClass($i);
}(It);
var Ki = /*#__PURE__*/function (_d13) {
  function Ki(e) {
    var _this61;
    _classCallCheck(this, Ki);
    _this61 = _callSuper(this, Ki, [e]);
    l(_this61, "children");
    var t = _this61.bindTemplate;
    _this61.set("isVisible", !1), _this61.set("position", "se"), _this61.children = _this61.createCollection(), _this61.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-reset", "ck-dropdown__panel", t.to("position", function (i) {
          return "ck-dropdown__panel_".concat(i);
        }), t.if("isVisible", "ck-dropdown__panel-visible")],
        tabindex: "-1"
      },
      children: _this61.children,
      on: {
        selectstart: t.to(function (i) {
          i.target.tagName.toLocaleLowerCase() !== "input" && i.preventDefault();
        })
      }
    });
    return _this61;
  }
  _inherits(Ki, _d13);
  return _createClass(Ki, [{
    key: "focus",
    value: function focus() {
      if (this.children.length) {
        var _e1 = this.children.first;
        typeof _e1.focus == "function" ? _e1.focus() : x("ui-dropdown-panel-focus-child-missing-focus", {
          childView: this.children.first,
          dropdownPanel: this
        });
      }
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      if (this.children.length) {
        var _e10 = this.children.last;
        typeof _e10.focusLast == "function" ? _e10.focusLast() : _e10.focus();
      }
    }
  }]);
}(d);
var W = /*#__PURE__*/function (_d14) {
  function W(e, t, i) {
    var _this62;
    _classCallCheck(this, W);
    _this62 = _callSuper(this, W, [e]);
    l(_this62, "buttonView");
    l(_this62, "panelView");
    l(_this62, "focusTracker");
    l(_this62, "keystrokes");
    l(_this62, "listView");
    l(_this62, "toolbarView");
    l(_this62, "menuView");
    var n = _this62.bindTemplate;
    _this62.buttonView = t, _this62.panelView = i, _this62.set("isOpen", !1), _this62.set("isEnabled", !0), _this62.set("class", void 0), _this62.set("id", void 0), _this62.set("panelPosition", "auto"), _this62.panelView.bind("isVisible").to(_this62, "isOpen"), _this62.keystrokes = new O(), _this62.focusTracker = new T(), _this62.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-dropdown", n.to("class"), n.if("isEnabled", "ck-disabled", function (r) {
          return !r;
        })],
        id: n.to("id"),
        "aria-describedby": n.to("ariaDescribedById")
      },
      children: [t, i]
    }), t.extendTemplate({
      attributes: {
        class: ["ck-dropdown__button"],
        "data-cke-tooltip-disabled": n.to("isOpen")
      }
    });
    return _this62;
  }
  _inherits(W, _d14);
  return _createClass(W, [{
    key: "render",
    value: function render() {
      var _this63 = this;
      _superPropGet(W, "render", this, 3)([]), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", function () {
        _this63.isOpen = !_this63.isOpen;
      }), this.on("change:isOpen", function (t, i, n) {
        if (n) if (_this63.panelPosition === "auto") {
          var r = W._getOptimalPosition({
            element: _this63.panelView.element,
            target: _this63.buttonView.element,
            fitInViewport: !0,
            positions: _this63._panelPositions
          });
          _this63.panelView.position = r ? r.name : _this63._defaultPanelPositionName;
        } else _this63.panelView.position = _this63.panelPosition;
      }), this.keystrokes.listenTo(this.element);
      var e = function e(t, i) {
        _this63.isOpen && (_this63.isOpen = !1, i());
      };
      this.keystrokes.set("arrowdown", function (t, i) {
        _this63.buttonView.isEnabled && !_this63.isOpen && (_this63.isOpen = !0, i());
      }), this.keystrokes.set("arrowright", function (t, i) {
        _this63.isOpen && i();
      }), this.keystrokes.set("arrowleft", e), this.keystrokes.set("esc", e);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.buttonView.focus();
    }
  }, {
    key: "_panelPositions",
    get: function get() {
      var _W$defaultPanelPositi = W.defaultPanelPositions,
        e = _W$defaultPanelPositi.south,
        t = _W$defaultPanelPositi.north,
        i = _W$defaultPanelPositi.southEast,
        n = _W$defaultPanelPositi.southWest,
        r = _W$defaultPanelPositi.northEast,
        a = _W$defaultPanelPositi.northWest,
        u = _W$defaultPanelPositi.southMiddleEast,
        c = _W$defaultPanelPositi.southMiddleWest,
        h = _W$defaultPanelPositi.northMiddleEast,
        p = _W$defaultPanelPositi.northMiddleWest;
      return this.locale.uiLanguageDirection !== "rtl" ? [i, n, u, c, e, r, a, h, p, t] : [n, i, c, u, e, a, r, p, h, t];
    }
  }, {
    key: "_defaultPanelPositionName",
    get: function get() {
      return this.locale.uiLanguageDirection === "rtl" ? "sw" : "se";
    }
  }]);
}(d);
l(W, "defaultPanelPositions", {
  south: function south(e, t) {
    return {
      top: e.bottom,
      left: e.left - (t.width - e.width) / 2,
      name: "s"
    };
  },
  southEast: function southEast(e) {
    return {
      top: e.bottom,
      left: e.left,
      name: "se"
    };
  },
  southWest: function southWest(e, t) {
    return {
      top: e.bottom,
      left: e.left - t.width + e.width,
      name: "sw"
    };
  },
  southMiddleEast: function southMiddleEast(e, t) {
    return {
      top: e.bottom,
      left: e.left - (t.width - e.width) / 4,
      name: "sme"
    };
  },
  southMiddleWest: function southMiddleWest(e, t) {
    return {
      top: e.bottom,
      left: e.left - (t.width - e.width) * 3 / 4,
      name: "smw"
    };
  },
  north: function north(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - (t.width - e.width) / 2,
      name: "n"
    };
  },
  northEast: function northEast(e, t) {
    return {
      top: e.top - t.height,
      left: e.left,
      name: "ne"
    };
  },
  northWest: function northWest(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - t.width + e.width,
      name: "nw"
    };
  },
  northMiddleEast: function northMiddleEast(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - (t.width - e.width) / 4,
      name: "nme"
    };
  },
  northMiddleWest: function northMiddleWest(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - (t.width - e.width) * 3 / 4,
      name: "nmw"
    };
  }
}), l(W, "_getOptimalPosition", xe);
var ye = W;
var ji = /*#__PURE__*/function (_w4) {
  function ji(e) {
    var _this64;
    _classCallCheck(this, ji);
    _this64 = _callSuper(this, ji, [e]);
    l(_this64, "arrowView");
    _this64.arrowView = _this64._createArrowView(), _this64.extendTemplate({
      attributes: {
        "aria-haspopup": !0,
        "aria-expanded": _this64.bindTemplate.to("isOn", function (t) {
          return String(t);
        })
      }
    }), _this64.delegate("execute").to(_this64, "open");
    return _this64;
  }
  _inherits(ji, _w4);
  return _createClass(ji, [{
    key: "render",
    value: function render() {
      _superPropGet(ji, "render", this, 3)([]), this.children.add(this.arrowView);
    }
  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var e = new L();
      return e.content = ue, e.extendTemplate({
        attributes: {
          class: "ck-dropdown__arrow"
        }
      }), e;
    }
  }]);
}(w);
var F = /*#__PURE__*/function (_d15) {
  function F(e) {
    var _this65;
    _classCallCheck(this, F);
    _this65 = _callSuper(this, F, [e]);
    l(_this65, "children");
    var t = _this65.bindTemplate;
    _this65.set("isVisible", !0), _this65.children = _this65.createCollection(), _this65.setTemplate({
      tag: "li",
      attributes: {
        class: ["ck", "ck-list__item", t.if("isVisible", "ck-hidden", function (i) {
          return !i;
        })],
        role: "presentation"
      },
      children: _this65.children
    });
    return _this65;
  }
  _inherits(F, _d15);
  return _createClass(F, [{
    key: "focus",
    value: function focus() {
      this.children.first && this.children.first.focus();
    }
  }]);
}(d);
var Fe = /*#__PURE__*/function (_d16) {
  function Fe(o) {
    var _this66;
    _classCallCheck(this, Fe);
    _this66 = _callSuper(this, Fe, [o]), _this66.setTemplate({
      tag: "li",
      attributes: {
        class: ["ck", "ck-list__separator"]
      }
    });
    return _this66;
  }
  _inherits(Fe, _d16);
  return _createClass(Fe);
}(d);
var Z = /*#__PURE__*/function (_d17) {
  function Z(e) {
    var _this67;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new de();
    _classCallCheck(this, Z);
    _this67 = _callSuper(this, Z, [e]);
    l(_this67, "labelView");
    l(_this67, "items");
    l(_this67, "children");
    var i = _this67.bindTemplate,
      n = new Ae(e);
    _this67.set({
      label: "",
      isVisible: !0
    }), _this67.labelView = t, _this67.labelView.bind("text").to(_this67, "label"), _this67.children = _this67.createCollection(), _this67.children.addMany([_this67.labelView, n]), n.set({
      role: "group",
      ariaLabelledBy: t.id
    }), n.focusTracker.destroy(), n.keystrokes.destroy(), _this67.items = n.items, _this67.setTemplate({
      tag: "li",
      attributes: {
        role: "presentation",
        class: ["ck", "ck-list__group", i.if("isVisible", "ck-hidden", function (r) {
          return !r;
        })]
      },
      children: _this67.children
    });
    return _this67;
  }
  _inherits(Z, _d17);
  return _createClass(Z, [{
    key: "focus",
    value: function focus() {
      if (this.items) {
        var _e11 = this.items.find(function (t) {
          return !(t instanceof Fe);
        });
        _e11 && _e11.focus();
      }
    }
  }]);
}(d);
var Ae = /*#__PURE__*/function (_d18) {
  function Ae(e) {
    var _this68;
    _classCallCheck(this, Ae);
    _this68 = _callSuper(this, Ae, [e]);
    l(_this68, "focusables");
    l(_this68, "items");
    l(_this68, "focusTracker");
    l(_this68, "keystrokes");
    l(_this68, "_focusCycler");
    l(_this68, "_listItemGroupToChangeListeners", new WeakMap());
    var t = _this68.bindTemplate;
    _this68.focusables = new A(), _this68.items = _this68.createCollection(), _this68.focusTracker = new T(), _this68.keystrokes = new O(), _this68._focusCycler = new H({
      focusables: _this68.focusables,
      focusTracker: _this68.focusTracker,
      keystrokeHandler: _this68.keystrokes,
      actions: {
        focusPrevious: "arrowup",
        focusNext: "arrowdown"
      }
    }), _this68.set("ariaLabel", void 0), _this68.set("ariaLabelledBy", void 0), _this68.set("role", void 0), _this68.setTemplate({
      tag: "ul",
      attributes: {
        class: ["ck", "ck-reset", "ck-list"],
        role: t.to("role"),
        "aria-label": t.to("ariaLabel"),
        "aria-labelledby": t.to("ariaLabelledBy")
      },
      children: _this68.items
    });
    return _this68;
  }
  _inherits(Ae, _d18);
  return _createClass(Ae, [{
    key: "render",
    value: function render() {
      var _this69 = this;
      _superPropGet(Ae, "render", this, 3)([]);
      var _iterator19 = _createForOfIteratorHelper(this.items),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _e12 = _step19.value;
          _e12 instanceof Z ? this._registerFocusableItemsGroup(_e12) : _e12 instanceof F && this._registerFocusableListItem(_e12);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      this.items.on("change", function (e, t) {
        var _iterator20 = _createForOfIteratorHelper(t.removed),
          _step20;
        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var i = _step20.value;
            i instanceof Z ? _this69._deregisterFocusableItemsGroup(i) : i instanceof F && _this69._deregisterFocusableListItem(i);
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
        var _iterator21 = _createForOfIteratorHelper(Array.from(t.added).reverse()),
          _step21;
        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _i6 = _step21.value;
            _i6 instanceof Z ? _this69._registerFocusableItemsGroup(_i6, t.index) : _this69._registerFocusableListItem(_i6, t.index);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
      }), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Ae, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusFirst",
    value: function focusFirst() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
  }, {
    key: "_registerFocusableListItem",
    value: function _registerFocusableListItem(e, t) {
      this.focusTracker.add(e.element), this.focusables.add(e, t);
    }
  }, {
    key: "_deregisterFocusableListItem",
    value: function _deregisterFocusableListItem(e) {
      this.focusTracker.remove(e.element), this.focusables.remove(e);
    }
  }, {
    key: "_getOnGroupItemsChangeCallback",
    value: function _getOnGroupItemsChangeCallback(e) {
      var _this70 = this;
      return function (t, i) {
        var _iterator22 = _createForOfIteratorHelper(i.removed),
          _step22;
        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var n = _step22.value;
            _this70._deregisterFocusableListItem(n);
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
        var _iterator23 = _createForOfIteratorHelper(Array.from(i.added).reverse()),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var _n3 = _step23.value;
            _this70._registerFocusableListItem(_n3, _this70.items.getIndex(e) + i.index);
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      };
    }
  }, {
    key: "_registerFocusableItemsGroup",
    value: function _registerFocusableItemsGroup(e, t) {
      var _this71 = this;
      Array.from(e.items).forEach(function (n, r) {
        var a = _typeof(t) < "u" ? t + r : void 0;
        _this71._registerFocusableListItem(n, a);
      });
      var i = this._getOnGroupItemsChangeCallback(e);
      this._listItemGroupToChangeListeners.set(e, i), e.items.on("change", i);
    }
  }, {
    key: "_deregisterFocusableItemsGroup",
    value: function _deregisterFocusableItemsGroup(e) {
      var _iterator24 = _createForOfIteratorHelper(e.items),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var t = _step24.value;
          this._deregisterFocusableListItem(t);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      e.items.off("change", this._listItemGroupToChangeListeners.get(e)), this._listItemGroupToChangeListeners.delete(e);
    }
  }]);
}(d);
var Xe = le("px"),
  Xi = {
    top: -99999,
    left: -99999,
    name: "arrowless",
    config: {
      withArrow: !1
    }
  },
  _ = /*#__PURE__*/function (_d19) {
    function _(e) {
      var _this72;
      _classCallCheck(this, _);
      _this72 = _callSuper(this, _, [e]);
      l(_this72, "content");
      l(_this72, "_pinWhenIsVisibleCallback");
      l(_this72, "_resizeObserver");
      var t = _this72.bindTemplate;
      _this72.set("top", 0), _this72.set("left", 0), _this72.set("position", "arrow_nw"), _this72.set("isVisible", !1), _this72.set("withArrow", !0), _this72.set("class", void 0), _this72._pinWhenIsVisibleCallback = null, _this72._resizeObserver = null, _this72.content = _this72.createCollection(), _this72.setTemplate({
        tag: "div",
        attributes: {
          class: ["ck", "ck-balloon-panel", t.to("position", function (i) {
            return "ck-balloon-panel_".concat(i);
          }), t.if("isVisible", "ck-balloon-panel_visible"), t.if("withArrow", "ck-balloon-panel_with-arrow"), t.to("class")],
          style: {
            top: t.to("top", Xe),
            left: t.to("left", Xe)
          }
        },
        children: _this72.content
      });
      return _this72;
    }
    _inherits(_, _d19);
    return _createClass(_, [{
      key: "destroy",
      value: function destroy() {
        this.hide(), _superPropGet(_, "destroy", this, 3)([]);
      }
    }, {
      key: "show",
      value: function show() {
        this.isVisible = !0;
      }
    }, {
      key: "hide",
      value: function hide() {
        this.isVisible = !1;
      }
    }, {
      key: "attachTo",
      value: function attachTo(e) {
        var t = J(e.target);
        if (t && !B(t)) return !1;
        this.show();
        var i = _.defaultPositions,
          n = Object.assign({}, {
            element: this.element,
            positions: [i.southArrowNorth, i.southArrowNorthMiddleWest, i.southArrowNorthMiddleEast, i.southArrowNorthWest, i.southArrowNorthEast, i.northArrowSouth, i.northArrowSouthMiddleWest, i.northArrowSouthMiddleEast, i.northArrowSouthWest, i.northArrowSouthEast, i.viewportStickyNorth],
            limiter: f.document.body,
            fitInViewport: !0
          }, e),
          r = _._getOptimalPosition(n) || Xi,
          a = parseInt(r.left),
          u = parseInt(r.top),
          c = r.name,
          h = r.config || {},
          _h$withArrow = h.withArrow,
          p = _h$withArrow === void 0 ? !0 : _h$withArrow;
        return this.top = u, this.left = a, this.position = c, this.withArrow = p, !0;
      }
    }, {
      key: "pin",
      value: function pin(e) {
        var _this73 = this;
        this.unpin(), this._startPinning(e) && (this._pinWhenIsVisibleCallback = function () {
          _this73.isVisible ? _this73._startPinning(e) : _this73._stopPinning();
        }, this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback));
      }
    }, {
      key: "unpin",
      value: function unpin() {
        this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
      }
    }, {
      key: "_startPinning",
      value: function _startPinning(e) {
        var _this74 = this;
        if (!this.attachTo(e)) return !1;
        var t = J(e.target);
        var i = e.limiter ? J(e.limiter) : f.document.body;
        if (this.listenTo(f.document, "scroll", function (n, r) {
          var a = r.target,
            u = t && a.contains(t),
            c = i && a.contains(i);
          (u || c || !t || !i) && _this74.attachTo(e);
        }, {
          useCapture: !0
        }), this.listenTo(f.window, "resize", function () {
          _this74.attachTo(e);
        }), !this._resizeObserver && (t && $t(t) && (t = t.parentElement), t)) {
          var n = function n() {
            B(t) || _this74.unpin();
          };
          this._resizeObserver = new ht(t, n);
        }
        return !0;
      }
    }, {
      key: "_stopPinning",
      value: function _stopPinning() {
        this.stopListening(f.document, "scroll"), this.stopListening(f.window, "resize"), this._resizeObserver && (this._resizeObserver.destroy(), this._resizeObserver = null);
      }
    }], [{
      key: "generatePositions",
      value: function generatePositions() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _e$sideOffset = e.sideOffset,
          t = _e$sideOffset === void 0 ? _.arrowSideOffset : _e$sideOffset,
          _e$heightOffset = e.heightOffset,
          i = _e$heightOffset === void 0 ? _.arrowHeightOffset : _e$heightOffset,
          _e$stickyVerticalOffs = e.stickyVerticalOffset,
          n = _e$stickyVerticalOffs === void 0 ? _.stickyVerticalOffset : _e$stickyVerticalOffs,
          r = e.config;
        return {
          northWestArrowSouthWest: function northWestArrowSouthWest(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left - t,
              name: "arrow_sw"
            }, r && {
              config: r
            });
          },
          northWestArrowSouthMiddleWest: function northWestArrowSouthMiddleWest(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left - h.width * .25 - t,
              name: "arrow_smw"
            }, r && {
              config: r
            });
          },
          northWestArrowSouth: function northWestArrowSouth(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left - h.width / 2,
              name: "arrow_s"
            }, r && {
              config: r
            });
          },
          northWestArrowSouthMiddleEast: function northWestArrowSouthMiddleEast(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left - h.width * .75 + t,
              name: "arrow_sme"
            }, r && {
              config: r
            });
          },
          northWestArrowSouthEast: function northWestArrowSouthEast(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left - h.width + t,
              name: "arrow_se"
            }, r && {
              config: r
            });
          },
          northArrowSouthWest: function northArrowSouthWest(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left + c.width / 2 - t,
              name: "arrow_sw"
            }, r && {
              config: r
            });
          },
          northArrowSouthMiddleWest: function northArrowSouthMiddleWest(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left + c.width / 2 - h.width * .25 - t,
              name: "arrow_smw"
            }, r && {
              config: r
            });
          },
          northArrowSouth: function northArrowSouth(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left + c.width / 2 - h.width / 2,
              name: "arrow_s"
            }, r && {
              config: r
            });
          },
          northArrowSouthMiddleEast: function northArrowSouthMiddleEast(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left + c.width / 2 - h.width * .75 + t,
              name: "arrow_sme"
            }, r && {
              config: r
            });
          },
          northArrowSouthEast: function northArrowSouthEast(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.left + c.width / 2 - h.width + t,
              name: "arrow_se"
            }, r && {
              config: r
            });
          },
          northEastArrowSouthWest: function northEastArrowSouthWest(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.right - t,
              name: "arrow_sw"
            }, r && {
              config: r
            });
          },
          northEastArrowSouthMiddleWest: function northEastArrowSouthMiddleWest(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.right - h.width * .25 - t,
              name: "arrow_smw"
            }, r && {
              config: r
            });
          },
          northEastArrowSouth: function northEastArrowSouth(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.right - h.width / 2,
              name: "arrow_s"
            }, r && {
              config: r
            });
          },
          northEastArrowSouthMiddleEast: function northEastArrowSouthMiddleEast(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.right - h.width * .75 + t,
              name: "arrow_sme"
            }, r && {
              config: r
            });
          },
          northEastArrowSouthEast: function northEastArrowSouthEast(c, h) {
            return _objectSpread({
              top: a(c, h),
              left: c.right - h.width + t,
              name: "arrow_se"
            }, r && {
              config: r
            });
          },
          southWestArrowNorthWest: function southWestArrowNorthWest(c) {
            return _objectSpread({
              top: u(c),
              left: c.left - t,
              name: "arrow_nw"
            }, r && {
              config: r
            });
          },
          southWestArrowNorthMiddleWest: function southWestArrowNorthMiddleWest(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left - h.width * .25 - t,
              name: "arrow_nmw"
            }, r && {
              config: r
            });
          },
          southWestArrowNorth: function southWestArrowNorth(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left - h.width / 2,
              name: "arrow_n"
            }, r && {
              config: r
            });
          },
          southWestArrowNorthMiddleEast: function southWestArrowNorthMiddleEast(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left - h.width * .75 + t,
              name: "arrow_nme"
            }, r && {
              config: r
            });
          },
          southWestArrowNorthEast: function southWestArrowNorthEast(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left - h.width + t,
              name: "arrow_ne"
            }, r && {
              config: r
            });
          },
          southArrowNorthWest: function southArrowNorthWest(c) {
            return _objectSpread({
              top: u(c),
              left: c.left + c.width / 2 - t,
              name: "arrow_nw"
            }, r && {
              config: r
            });
          },
          southArrowNorthMiddleWest: function southArrowNorthMiddleWest(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left + c.width / 2 - h.width * .25 - t,
              name: "arrow_nmw"
            }, r && {
              config: r
            });
          },
          southArrowNorth: function southArrowNorth(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left + c.width / 2 - h.width / 2,
              name: "arrow_n"
            }, r && {
              config: r
            });
          },
          southArrowNorthMiddleEast: function southArrowNorthMiddleEast(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left + c.width / 2 - h.width * .75 + t,
              name: "arrow_nme"
            }, r && {
              config: r
            });
          },
          southArrowNorthEast: function southArrowNorthEast(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.left + c.width / 2 - h.width + t,
              name: "arrow_ne"
            }, r && {
              config: r
            });
          },
          southEastArrowNorthWest: function southEastArrowNorthWest(c) {
            return _objectSpread({
              top: u(c),
              left: c.right - t,
              name: "arrow_nw"
            }, r && {
              config: r
            });
          },
          southEastArrowNorthMiddleWest: function southEastArrowNorthMiddleWest(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.right - h.width * .25 - t,
              name: "arrow_nmw"
            }, r && {
              config: r
            });
          },
          southEastArrowNorth: function southEastArrowNorth(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.right - h.width / 2,
              name: "arrow_n"
            }, r && {
              config: r
            });
          },
          southEastArrowNorthMiddleEast: function southEastArrowNorthMiddleEast(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.right - h.width * .75 + t,
              name: "arrow_nme"
            }, r && {
              config: r
            });
          },
          southEastArrowNorthEast: function southEastArrowNorthEast(c, h) {
            return _objectSpread({
              top: u(c),
              left: c.right - h.width + t,
              name: "arrow_ne"
            }, r && {
              config: r
            });
          },
          westArrowEast: function westArrowEast(c, h) {
            return _objectSpread({
              top: c.top + c.height / 2 - h.height / 2,
              left: c.left - h.width - i,
              name: "arrow_e"
            }, r && {
              config: r
            });
          },
          eastArrowWest: function eastArrowWest(c, h) {
            return _objectSpread({
              top: c.top + c.height / 2 - h.height / 2,
              left: c.right + i,
              name: "arrow_w"
            }, r && {
              config: r
            });
          },
          viewportStickyNorth: function viewportStickyNorth(c, h, p) {
            var b = new C(f.document.body).getIntersection(p.getVisible());
            if (!b) return null;
            var g = b.getVisible();
            return !c.getIntersection(g) || !(g.top - c.top - n < h.height && g.bottom - c.bottom < h.height) ? null : {
              top: g.top + n,
              left: c.left + c.width / 2 - h.width / 2,
              name: "arrowless",
              config: _objectSpread({
                withArrow: !1
              }, r)
            };
          }
        };
        function a(c, h) {
          return c.top - h.height - i;
        }
        function u(c) {
          return c.bottom + i;
        }
      }
    }]);
  }(d);
l(_, "arrowSideOffset", 25), l(_, "arrowHeightOffset", 10), l(_, "stickyVerticalOffset", 20), l(_, "_getOptimalPosition", xe), l(_, "defaultPositions", _.generatePositions());
var R = _;
function J(s) {
  return Pe(s) ? s : jt(s) ? s.commonAncestorContainer : typeof s == "function" ? J(s()) : null;
}
var Ot = /*#__PURE__*/function (_d20) {
  function Ot(o) {
    var _this75;
    _classCallCheck(this, Ot);
    _this75 = _callSuper(this, Ot, [o]), _this75.setTemplate({
      tag: "span",
      attributes: {
        class: ["ck", "ck-toolbar__separator"]
      }
    });
    return _this75;
  }
  _inherits(Ot, _d20);
  return _createClass(Ot);
}(d);
var qi = /*#__PURE__*/function (_d21) {
  function qi(o) {
    var _this76;
    _classCallCheck(this, qi);
    _this76 = _callSuper(this, qi, [o]), _this76.setTemplate({
      tag: "span",
      attributes: {
        class: ["ck", "ck-toolbar__line-break"]
      }
    });
    return _this76;
  }
  _inherits(qi, _d21);
  return _createClass(qi);
}(d);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function Yi(s) {
  return s.bindTemplate.to(function (o) {
    o.target === s.element && o.preventDefault();
  });
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Qi(s) {
  if (Array.isArray(s)) return {
    items: s,
    removeItems: []
  };
  var o = {
    items: [],
    removeItems: []
  };
  return s ? _objectSpread(_objectSpread({}, o), s) : o;
}
var Zi = {
  alignLeft: ii,
  bold: ti,
  importExport: ei,
  paragraph: Jt,
  plus: Zt,
  text: Qt,
  threeVerticalDots: Ie,
  pilcrow: Yt,
  dragIndicator: qt
};
var Ji = /*#__PURE__*/function (_d22) {
  function Ji(e, t) {
    var _this77;
    _classCallCheck(this, Ji);
    _this77 = _callSuper(this, Ji, [e]);
    l(_this77, "options");
    l(_this77, "items");
    l(_this77, "focusTracker");
    l(_this77, "keystrokes");
    l(_this77, "itemsView");
    l(_this77, "children");
    l(_this77, "focusables");
    l(_this77, "_focusCycler");
    l(_this77, "_behavior");
    var i = _this77.bindTemplate,
      n = _this77.t;
    _this77.options = t || {}, _this77.set("ariaLabel", n("Editor toolbar")), _this77.set("maxWidth", "auto"), _this77.set("role", "toolbar"), _this77.set("isGrouping", !!_this77.options.shouldGroupWhenFull), _this77.items = _this77.createCollection(), _this77.focusTracker = new T(), _this77.keystrokes = new O(), _this77.set("class", void 0), _this77.set("isCompact", !1), _this77.set("isVertical", !1), _this77.itemsView = new es(e), _this77.children = _this77.createCollection(), _this77.children.add(_this77.itemsView), _this77.focusables = _this77.createCollection();
    var r = e.uiLanguageDirection === "rtl";
    _this77._focusCycler = new H({
      focusables: _this77.focusables,
      focusTracker: _this77.focusTracker,
      keystrokeHandler: _this77.keystrokes,
      actions: {
        focusPrevious: [r ? "arrowright" : "arrowleft", "arrowup"],
        focusNext: [r ? "arrowleft" : "arrowright", "arrowdown"]
      }
    });
    var a = ["ck", "ck-toolbar", i.to("class"), i.if("isCompact", "ck-toolbar_compact"), i.if("isGrouping", "ck-toolbar_grouping"), i.if("isVertical", "ck-toolbar_vertical")];
    _this77.options.shouldGroupWhenFull && _this77.options.isFloating && a.push("ck-toolbar_floating"), _this77.setTemplate({
      tag: "div",
      attributes: {
        class: a,
        role: i.to("role"),
        "aria-label": i.to("ariaLabel"),
        style: {
          maxWidth: i.to("maxWidth")
        },
        tabindex: -1
      },
      children: _this77.children,
      on: {
        mousedown: Yi(_this77)
      }
    }), _this77._behavior = _this77.options.shouldGroupWhenFull ? new Ye(_this77) : new qe(_this77);
    return _this77;
  }
  _inherits(Ji, _d22);
  return _createClass(Ji, [{
    key: "render",
    value: function render() {
      var _this78 = this;
      _superPropGet(Ji, "render", this, 3)([]), this.focusTracker.add(this.element);
      var _iterator25 = _createForOfIteratorHelper(this.items),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _e13 = _step25.value;
          this.focusTracker.add(_e13);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      this.items.on("add", function (e, t) {
        _this78.focusTracker.add(t);
      }), this.items.on("remove", function (e, t) {
        _this78.focusTracker.remove(t);
      }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), _superPropGet(Ji, "destroy", this, 3)([]);
    }
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
  }, {
    key: "fillFromConfig",
    value: function fillFromConfig(e, t, i) {
      this.items.addMany(this._buildItemsFromConfig(e, t, i));
    }
  }, {
    key: "switchBehavior",
    value: function switchBehavior(e) {
      this._behavior.type !== e && (this._behavior.destroy(), this.itemsView.children.clear(), this.focusables.clear(), e === "dynamic" ? (this._behavior = new Ye(this), this._behavior.render(this), this._behavior.refreshItems()) : (this._behavior = new qe(this), this._behavior.render(this)));
    }
  }, {
    key: "_buildItemsFromConfig",
    value: function _buildItemsFromConfig(e, t, i) {
      var _this79 = this;
      var n = Qi(e),
        r = i || n.removeItems;
      return this._cleanItemsConfiguration(n.items, t, r).map(function (u) {
        return ie(u) ? _this79._createNestedToolbarDropdown(u, t, r) : u === "|" ? new Ot() : u === "-" ? new qi() : t.create(u);
      }).filter(function (u) {
        return !!u;
      });
    }
  }, {
    key: "_cleanItemsConfiguration",
    value: function _cleanItemsConfiguration(e, t, i) {
      var _this80 = this;
      var n = e.filter(function (r, a, u) {
        return r === "|" ? !0 : i.indexOf(r) !== -1 ? !1 : r === "-" ? _this80.options.shouldGroupWhenFull ? (x("toolbarview-line-break-ignored-when-grouping-items", u), !1) : !0 : !ie(r) && !t.has(r) ? (x("toolbarview-item-unavailable", {
          item: r
        }), !1) : !0;
      });
      return this._cleanSeparatorsAndLineBreaks(n);
    }
  }, {
    key: "_cleanSeparatorsAndLineBreaks",
    value: function _cleanSeparatorsAndLineBreaks(e) {
      var t = function t(a) {
          return a !== "-" && a !== "|";
        },
        i = e.length,
        n = e.findIndex(t);
      if (n === -1) return [];
      var r = i - e.slice().reverse().findIndex(t);
      return e.slice(n, r).filter(function (a, u, c) {
        return t(a) ? !0 : !(u > 0 && c[u - 1] === a);
      });
    }
  }, {
    key: "_createNestedToolbarDropdown",
    value: function _createNestedToolbarDropdown(e, t, i) {
      var n = e.label,
        r = e.icon,
        a = e.items,
        _e$tooltip = e.tooltip,
        u = _e$tooltip === void 0 ? !0 : _e$tooltip,
        _e$withText = e.withText,
        c = _e$withText === void 0 ? !1 : _e$withText;
      if (a = this._cleanItemsConfiguration(a, t, i), !a.length) return null;
      var h = this.locale,
        p = De(h);
      return n || x("toolbarview-nested-toolbar-dropdown-missing-label", e), p.class = "ck-toolbar__nested-toolbar-dropdown", p.buttonView.set({
        label: n,
        tooltip: u,
        withText: !!c
      }), r !== !1 ? p.buttonView.icon = Zi[r] || r || Ie : p.buttonView.withText = !0, Pt(p, function () {
        return p.toolbarView._buildItemsFromConfig(a, t, i);
      }), p;
    }
  }]);
}(d);
var es = /*#__PURE__*/function (_d23) {
  function es(e) {
    var _this81;
    _classCallCheck(this, es);
    _this81 = _callSuper(this, es, [e]);
    l(_this81, "children");
    _this81.children = _this81.createCollection(), _this81.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-toolbar__items"]
      },
      children: _this81.children
    });
    return _this81;
  }
  _inherits(es, _d23);
  return _createClass(es);
}(d);
var qe = /*#__PURE__*/function () {
  function qe(o) {
    _classCallCheck(this, qe);
    l(this, "type", "static");
    o.isGrouping = !1, o.itemsView.children.bindTo(o.items).using(function (e) {
      return e;
    }), o.focusables.bindTo(o.items).using(function (e) {
      return j(e) ? e : null;
    });
  }
  return _createClass(qe, [{
    key: "render",
    value: function render() {}
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
}();
var Ye = /*#__PURE__*/function () {
  function Ye(o) {
    var _this82 = this;
    _classCallCheck(this, Ye);
    l(this, "type", "dynamic");
    l(this, "view");
    l(this, "viewChildren");
    l(this, "viewFocusables");
    l(this, "viewItemsView");
    l(this, "viewFocusTracker");
    l(this, "viewLocale");
    l(this, "ungroupedItems");
    l(this, "groupedItems");
    l(this, "groupedItemsDropdown");
    l(this, "resizeObserver", null);
    l(this, "cachedPadding", null);
    l(this, "shouldUpdateGroupingOnNextResize", !1);
    l(this, "viewElement");
    this.view = o, this.viewChildren = o.children, this.viewFocusables = o.focusables, this.viewItemsView = o.itemsView, this.viewFocusTracker = o.focusTracker, this.viewLocale = o.locale, this.view.isGrouping = !0, this.ungroupedItems = o.createCollection(), this.groupedItems = o.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), o.itemsView.children.bindTo(this.ungroupedItems).using(function (e) {
      return e;
    }), this.ungroupedItems.on("change", this._updateFocusCyclableItems.bind(this)), o.children.on("change", this._updateFocusCyclableItems.bind(this)), o.items.on("change", function (e, t) {
      var i = t.index,
        n = Array.from(t.added);
      var _iterator26 = _createForOfIteratorHelper(t.removed),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _r2 = _step26.value;
          i >= _this82.ungroupedItems.length ? _this82.groupedItems.remove(_r2) : _this82.ungroupedItems.remove(_r2);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      for (var r = i; r < i + n.length; r++) {
        var a = n[r - i];
        r > _this82.ungroupedItems.length ? _this82.groupedItems.add(a, r - _this82.ungroupedItems.length) : _this82.ungroupedItems.add(a, r);
      }
      _this82._updateGrouping();
    });
  }
  return _createClass(Ye, [{
    key: "render",
    value: function render(o) {
      this.viewElement = o.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(o);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.groupedItemsDropdown.destroy(), this.viewChildren.length > 1 && (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last)), this.resizeObserver.destroy();
    }
  }, {
    key: "refreshItems",
    value: function refreshItems() {
      var o = this.view;
      if (o.items.length) {
        for (var _e14 = 0; _e14 < o.items.length; _e14++) {
          var t = _toConsumableArray(o.items)[_e14];
          this.ungroupedItems.add(t, _e14);
        }
        this._updateGrouping();
      }
    }
  }, {
    key: "_updateGrouping",
    value: function _updateGrouping() {
      if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
      if (!B(this.viewElement)) {
        this.shouldUpdateGroupingOnNextResize = !0;
        return;
      }
      var o = this.groupedItems.length;
      var e;
      for (; this._areItemsOverflowing;) this._groupLastItem(), e = !0;
      if (!e && this.groupedItems.length) {
        for (; this.groupedItems.length && !this._areItemsOverflowing;) this._ungroupFirstItem();
        this._areItemsOverflowing && this._groupLastItem();
      }
      this.groupedItems.length !== o && this.view.fire("groupedItemsUpdate");
    }
  }, {
    key: "_areItemsOverflowing",
    get: function get() {
      if (!this.ungroupedItems.length) return !1;
      var o = this.viewElement,
        e = this.viewLocale.uiLanguageDirection,
        t = new C(o.lastChild),
        i = new C(o);
      if (!this.cachedPadding) {
        var n = f.window.getComputedStyle(o),
          r = e === "ltr" ? "paddingRight" : "paddingLeft";
        this.cachedPadding = Number.parseInt(n[r]);
      }
      return e === "ltr" ? t.right > i.right - this.cachedPadding : t.left < i.left + this.cachedPadding;
    }
  }, {
    key: "_enableGroupingOnResize",
    value: function _enableGroupingOnResize() {
      var _this83 = this;
      var o;
      this.resizeObserver = new ht(this.viewElement, function (e) {
        (!o || o !== e.contentRect.width || _this83.shouldUpdateGroupingOnNextResize) && (_this83.shouldUpdateGroupingOnNextResize = !1, _this83._updateGrouping(), o = e.contentRect.width);
      }), this._updateGrouping();
    }
  }, {
    key: "_enableGroupingOnMaxWidthChange",
    value: function _enableGroupingOnMaxWidthChange(o) {
      var _this84 = this;
      o.on("change:maxWidth", function () {
        _this84._updateGrouping();
      });
    }
  }, {
    key: "_groupLastItem",
    value: function _groupLastItem() {
      this.groupedItems.length || (this.viewChildren.add(new Ot()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
    }
  }, {
    key: "_ungroupFirstItem",
    value: function _ungroupFirstItem() {
      this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
    }
  }, {
    key: "_createGroupedItemsDropdown",
    value: function _createGroupedItemsDropdown() {
      var o = this.viewLocale,
        e = o.t,
        t = De(o);
      return t.class = "ck-toolbar__grouped-dropdown", t.panelPosition = o.uiLanguageDirection === "ltr" ? "sw" : "se", Pt(t, this.groupedItems), t.buttonView.set({
        label: e("Show more items"),
        tooltip: !0,
        tooltipPosition: o.uiLanguageDirection === "rtl" ? "se" : "sw",
        icon: Ie
      }), t;
    }
  }, {
    key: "_updateFocusCyclableItems",
    value: function _updateFocusCyclableItems() {
      var _this85 = this;
      this.viewFocusables.clear(), this.ungroupedItems.map(function (o) {
        j(o) && _this85.viewFocusables.add(o);
      }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
    }
  }]);
}();
var ts = /*#__PURE__*/function (_d24) {
  function ts(e, t) {
    var _this86;
    _classCallCheck(this, ts);
    _this86 = _callSuper(this, ts, [e]);
    l(_this86, "children");
    l(_this86, "actionView");
    l(_this86, "arrowView");
    l(_this86, "keystrokes");
    l(_this86, "focusTracker");
    var i = _this86.bindTemplate;
    _this86.set("class", void 0), _this86.set("labelStyle", void 0), _this86.set("icon", void 0), _this86.set("isEnabled", !0), _this86.set("isOn", !1), _this86.set("isToggleable", !1), _this86.set("isVisible", !0), _this86.set("keystroke", void 0), _this86.set("withKeystroke", !1), _this86.set("label", void 0), _this86.set("tabindex", -1), _this86.set("tooltip", !1), _this86.set("tooltipPosition", "s"), _this86.set("type", "button"), _this86.set("withText", !1), _this86.children = _this86.createCollection(), _this86.actionView = _this86._createActionView(t), _this86.arrowView = _this86._createArrowView(), _this86.keystrokes = new O(), _this86.focusTracker = new T(), _this86.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-splitbutton", i.to("class"), i.if("isVisible", "ck-hidden", function (n) {
          return !n;
        }), _this86.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
      },
      children: _this86.children
    });
    return _this86;
  }
  _inherits(ts, _d24);
  return _createClass(ts, [{
    key: "render",
    value: function render() {
      var _this87 = this;
      _superPropGet(ts, "render", this, 3)([]), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", function (e, t) {
        _this87.focusTracker.focusedElement === _this87.actionView.element && (_this87.arrowView.focus(), t());
      }), this.keystrokes.set("arrowleft", function (e, t) {
        _this87.focusTracker.focusedElement === _this87.arrowView.element && (_this87.actionView.focus(), t());
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ts, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.actionView.focus();
    }
  }, {
    key: "_createActionView",
    value: function _createActionView(e) {
      var t = e || new w();
      return e || t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), t.extendTemplate({
        attributes: {
          class: "ck-splitbutton__action"
        }
      }), t.delegate("execute").to(this), t;
    }
  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var e = new w(),
        t = e.bindTemplate;
      return e.icon = ue, e.extendTemplate({
        attributes: {
          class: ["ck-splitbutton__arrow"],
          "data-cke-tooltip-disabled": t.to("isOn"),
          "aria-haspopup": !0,
          "aria-expanded": t.to("isOn", function (i) {
            return String(i);
          })
        }
      }), e.bind("isEnabled").to(this), e.bind("label").to(this), e.bind("tooltip").to(this), e.delegate("execute").to(this, "open"), e;
    }
  }]);
}(d);
function De(s) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ji;
  var e = typeof o == "function" ? new o(s) : o,
    t = new Ki(s),
    i = new ye(s, e, t);
  return e.bind("isEnabled").to(i), e instanceof ts ? e.arrowView.bind("isOn").to(i, "isOpen") : e.bind("isOn").to(i, "isOpen"), is(i), i;
}
function Pt(s, o) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  s.extendTemplate({
    attributes: {
      class: ["ck-toolbar-dropdown"]
    }
  }), s.isOpen ? Qe(s, o, e) : s.once("change:isOpen", function () {
    return Qe(s, o, e);
  }, {
    priority: "highest"
  }), e.enableActiveItemFocusOnDropdownOpen && Bt(s, function () {
    return s.toolbarView.items.find(function (t) {
      return t.isOn;
    });
  });
}
function Qe(s, o, e) {
  var t = s.locale,
    i = t.t,
    n = s.toolbarView = new Ji(t),
    r = typeof o == "function" ? o() : o;
  n.ariaLabel = e.ariaLabel || i("Dropdown toolbar"), e.maxWidth && (n.maxWidth = e.maxWidth), e.class && (n.class = e.class), e.isCompact && (n.isCompact = e.isCompact), e.isVertical && (n.isVertical = !0), r instanceof A ? n.items.bindTo(r).using(function (a) {
    return a;
  }) : n.items.addMany(r), s.panelView.children.add(n), s.focusTracker.add(n), n.items.delegate("execute").to(s);
}
function ko(s, o) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  s.isOpen ? Ze(s, o, e) : s.once("change:isOpen", function () {
    return Ze(s, o, e);
  }, {
    priority: "highest"
  }), Bt(s, function () {
    return s.listView.items.find(function (t) {
      return t instanceof F ? t.children.first.isOn : !1;
    });
  });
}
function Ze(s, o, e) {
  var t = s.locale,
    i = s.listView = new Ae(t),
    n = typeof o == "function" ? o() : o;
  i.ariaLabel = e.ariaLabel, i.role = e.role, Ft(s, i.items, n, t), s.panelView.children.add(i), i.items.delegate("execute").to(s);
}
function Bt(s, o) {
  s.on("change:isOpen", function () {
    if (!s.isOpen) return;
    var e = o();
    e && (typeof e.focus == "function" ? e.focus() : x("ui-dropdown-focus-child-on-open-child-missing-focus", {
      view: e
    }));
  }, {
    priority: Ut.low - 10
  });
}
function is(s) {
  ss(s), os(s), ns(s), rs(s), ls(s), as(s);
}
function ss(s) {
  kt({
    emitter: s,
    activator: function activator() {
      return s.isRendered && s.isOpen;
    },
    callback: function callback() {
      s.isOpen = !1;
    },
    contextElements: function contextElements() {
      return [s.element].concat(_toConsumableArray(Lt(s.focusTracker).filter(function (o) {
        return !s.element.contains(o);
      })));
    }
  });
}
function Lt(s) {
  return [].concat(_toConsumableArray(s.elements), _toConsumableArray(s.externalViews.flatMap(function (o) {
    return Lt(o.focusTracker);
  })));
}
function os(s) {
  s.on("execute", function (o) {
    o.source instanceof yt || (s.isOpen = !1);
  });
}
function ns(s) {
  s.focusTracker.on("change:isFocused", function (o, e, t) {
    t || !s.isOpen || (s.isOpen = !1);
  });
}
function rs(s) {
  s.keystrokes.set("arrowdown", function (o, e) {
    s.isOpen && (s.panelView.focus(), e());
  }), s.keystrokes.set("arrowup", function (o, e) {
    s.isOpen && (s.panelView.focusLast(), e());
  });
}
function ls(s) {
  s.on("change:isOpen", function (o, e, t) {
    if (t) return;
    s.focusTracker.elements.some(function (n) {
      return n.contains(f.document.activeElement);
    }) && s.buttonView.focus();
  });
}
function as(s) {
  s.on("change:isOpen", function (o, e, t) {
    t && s.panelView.focus();
  }, {
    priority: "low"
  });
}
function Ft(s, o, e, t) {
  cs(o), o.bindTo(e).using(function (i) {
    if (i.type === "separator") return new Fe(t);
    if (i.type === "group") {
      var n = new Z(t);
      return n.set({
        label: i.label
      }), Ft(s, n.items, i.items, t), n.items.delegate("execute").to(s), n;
    } else if (i.type === "button" || i.type === "switchbutton") {
      var _a;
      var _n4 = i.model.role === "menuitemcheckbox" || i.model.role === "menuitemradio",
        r = new F(t);
      var a;
      return i.type === "button" ? (a = new z(t), a.set({
        isToggleable: _n4
      })) : a = new yt(t), (_a = a).bind.apply(_a, _toConsumableArray(Object.keys(i.model))).to(i.model), a.delegate("execute").to(r), r.children.add(a), r;
    }
    return null;
  });
}
function cs(s) {
  var o = 0;
  var e = function e(n) {
      return !(n instanceof F) || !(n.children.first instanceof z) ? null : n.children.first;
    },
    t = function t(n) {
      var r = e(n);
      return !r || !r.isToggleable ? null : r;
    },
    i = function i(n) {
      var _iterator27 = _createForOfIteratorHelper(s),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var r = _step27.value;
          var a = e(r);
          a && (a.hasCheckSpace = n);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    };
  s.on("change", function (n, r) {
    var a = o > 0;
    var _iterator28 = _createForOfIteratorHelper(r.removed),
      _step28;
    try {
      for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
        var c = _step28.value;
        t(c) && o--;
      }
    } catch (err) {
      _iterator28.e(err);
    } finally {
      _iterator28.f();
    }
    var _iterator29 = _createForOfIteratorHelper(r.added),
      _step29;
    try {
      for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
        var _c2 = _step29.value;
        var h = e(_c2);
        h && (h.isToggleable && o++, h.hasCheckSpace = o > 0);
      }
    } catch (err) {
      _iterator29.e(err);
    } finally {
      _iterator29.f();
    }
    var u = o > 0;
    a !== u && i(u);
  });
}
var hs = function hs(s, o, e) {
    var t = new Ui(s.locale);
    return t.set({
      id: o,
      ariaDescribedById: e
    }), t.bind("isReadOnly").to(s, "isEnabled", function (i) {
      return !i;
    }), t.bind("hasError").to(s, "errorText", function (i) {
      return !!i;
    }), t.on("input", function () {
      s.errorText = null;
    }), s.bind("isEmpty", "isFocused", "placeholder").to(t), t;
  },
  To = function To(s, o, e) {
    var t = new $i(s.locale);
    return t.set({
      id: o,
      ariaDescribedById: e,
      inputMode: "numeric"
    }), t.bind("isReadOnly").to(s, "isEnabled", function (i) {
      return !i;
    }), t.bind("hasError").to(s, "errorText", function (i) {
      return !!i;
    }), t.on("input", function () {
      s.errorText = null;
    }), s.bind("isEmpty", "isFocused", "placeholder").to(t), t;
  },
  vo = function vo(s, o, e) {
    var t = De(s.locale);
    return t.set({
      id: o,
      ariaDescribedById: e
    }), t.bind("isEnabled").to(s), t;
  },
  us = 150;
var ds = /*#__PURE__*/function (_d25) {
  function ds(e) {
    var _this88;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ds);
    _this88 = _callSuper(this, ds, [e]);
    l(_this88, "hexInputRow");
    l(_this88, "_debounceColorPickerEvent");
    l(_this88, "_config");
    _this88.set({
      color: "",
      _hexColor: ""
    }), _this88.hexInputRow = _this88._createInputRow();
    var i = _this88.createCollection();
    t.hideInput || i.add(_this88.hexInputRow), _this88.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-picker"],
        tabindex: -1
      },
      children: i
    }), _this88._config = t, _this88._debounceColorPickerEvent = _e(function (n) {
      _this88.set("color", n), _this88.fire("colorSelected", {
        color: _this88.color
      });
    }, us, {
      leading: !0
    }), _this88.on("set:color", function (n, r, a) {
      n.return = xt(a, _this88._config.format || "hsl");
    }), _this88.on("change:color", function () {
      _this88._hexColor = pe(_this88.color);
    }), _this88.on("change:_hexColor", function () {
      document.activeElement !== _this88.picker && _this88.picker.setAttribute("color", _this88._hexColor), pe(_this88.color) != pe(_this88._hexColor) && (_this88.color = _this88._hexColor);
    });
    return _this88;
  }
  _inherits(ds, _d25);
  return _createClass(ds, [{
    key: "render",
    value: function render() {
      var _this89 = this;
      if (_superPropGet(ds, "render", this, 3)([]), Ni("hex-color-picker", ci), this.picker = f.document.createElement("hex-color-picker"), this.picker.setAttribute("class", "hex-color-picker"), this.picker.setAttribute("tabindex", "-1"), this._createSlidersView(), this.element) {
        this.hexInputRow.element ? this.element.insertBefore(this.picker, this.hexInputRow.element) : this.element.appendChild(this.picker);
        var _e15 = document.createElement("style");
        _e15.textContent = '[role="slider"]:focus [part$="pointer"] {border: 1px solid #fff;outline: 1px solid var(--ck-color-focus-border);box-shadow: 0 0 0 2px #fff;}', this.picker.shadowRoot.appendChild(_e15);
      }
      this.picker.addEventListener("color-changed", function (e) {
        var t = e.detail.value;
        _this89._debounceColorPickerEvent(t);
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      /* istanbul ignore next -- @preserve */!this._config.hideInput && (S.isGecko || S.isiOS || S.isSafari || S.isBlink) && this.hexInputRow.children.get(1).focus(), this.slidersView.first.focus();
    }
  }, {
    key: "_createSlidersView",
    value: function _createSlidersView() {
      var _this90 = this;
      var i = _toConsumableArray(this.picker.shadowRoot.children).filter(function (n) {
        return n.getAttribute("role") === "slider";
      }).map(function (n) {
        return new fs(n);
      });
      this.slidersView = this.createCollection(), i.forEach(function (n) {
        _this90.slidersView.add(n);
      });
    }
  }, {
    key: "_createInputRow",
    value: function _createInputRow() {
      var e = this._createColorInput();
      return new ms(this.locale, e);
    }
  }, {
    key: "_createColorInput",
    value: function _createColorInput() {
      var _this91 = this;
      var e = new Ri(this.locale, hs),
        t = this.locale.t;
      return e.set({
        label: t("HEX"),
        class: "color-picker-hex-input"
      }), e.fieldView.bind("value").to(this, "_hexColor", function (i) {
        return e.isFocused ? e.fieldView.value : i.startsWith("#") ? i.substring(1) : i;
      }), e.fieldView.on("input", function () {
        var i = e.fieldView.element.value;
        if (i) {
          var n = At(i);
          n && _this91._debounceColorPickerEvent(n);
        }
      }), e;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var e = this.locale.t;
      return this._config.hideInput ? !0 : (this.resetValidationStatus(), this.hexInputRow.getParsedColor() ? !0 : (this.hexInputRow.inputView.errorText = e('Please enter a valid color (e.g. "ff0000").'), !1));
    }
  }, {
    key: "resetValidationStatus",
    value: function resetValidationStatus() {
      this.hexInputRow.inputView.errorText = null;
    }
  }]);
}(d);
function pe(s) {
  var o = Mi(s);
  return o || (o = "#000"), o.length === 4 && (o = "#" + [o[1], o[1], o[2], o[2], o[3], o[3]].join("")), o.toLowerCase();
}
var fs = /*#__PURE__*/function (_d26) {
  function fs(o) {
    var _this92;
    _classCallCheck(this, fs);
    _this92 = _callSuper(this, fs), _this92.element = o;
    return _this92;
  }
  _inherits(fs, _d26);
  return _createClass(fs, [{
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }]);
}(d);
var ps = /*#__PURE__*/function (_d27) {
  function ps(o) {
    var _this93;
    _classCallCheck(this, ps);
    _this93 = _callSuper(this, ps, [o]), _this93.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-picker__hash-view"]
      },
      children: "#"
    });
    return _this93;
  }
  _inherits(ps, _d27);
  return _createClass(ps);
}(d);
var ms = /*#__PURE__*/function (_d28) {
  function ms(e, t) {
    var _this94;
    _classCallCheck(this, ms);
    _this94 = _callSuper(this, ms, [e]);
    l(_this94, "children");
    l(_this94, "inputView");
    _this94.inputView = t, _this94.children = _this94.createCollection([new ps(), _this94.inputView]), _this94.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-picker__row"]
      },
      children: _this94.children
    });
    return _this94;
  }
  _inherits(ms, _d28);
  return _createClass(ms, [{
    key: "getParsedColor",
    value: function getParsedColor() {
      return At(this.inputView.fieldView.element.value);
    }
  }]);
}(d);
function At(s) {
  if (!s) return null;
  var o = s.trim().replace(/^#/, "");
  return ![3, 4, 6, 8].includes(o.length) || !/^(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})$/.test(o) ? null : "#".concat(o);
}
var ws = /*#__PURE__*/function (_ce) {
  function ws(o) {
    var _this95;
    _classCallCheck(this, ws);
    _this95 = _callSuper(this, ws, [o]), _this95.set("isEmpty", !0), _this95.on("change", function () {
      _this95.set("isEmpty", _this95.length === 0);
    });
    return _this95;
  }
  _inherits(ws, _ce);
  return _createClass(ws, [{
    key: "add",
    value: function add(o, e) {
      return this.find(function (t) {
        return t.color === o.color;
      }) ? this : _superPropGet(ws, "add", this, 3)([o, e]);
    }
  }, {
    key: "hasColor",
    value: function hasColor(o) {
      return !!this.find(function (e) {
        return e.color === o;
      });
    }
  }]);
}(ce(Ve));
var bs = /*#__PURE__*/function (_d29) {
  function bs(e, _ref10) {
    var _this96;
    var t = _ref10.colors,
      i = _ref10.columns,
      n = _ref10.removeButtonLabel,
      r = _ref10.documentColorsLabel,
      a = _ref10.documentColorsCount,
      u = _ref10.colorPickerLabel,
      c = _ref10.focusTracker,
      h = _ref10.focusables;
    _classCallCheck(this, bs);
    _this96 = _callSuper(this, bs, [e]);
    l(_this96, "items");
    l(_this96, "colorDefinitions");
    l(_this96, "focusTracker");
    l(_this96, "columns");
    l(_this96, "documentColors");
    l(_this96, "documentColorsCount");
    l(_this96, "staticColorsGrid");
    l(_this96, "documentColorsGrid");
    l(_this96, "colorPickerButtonView");
    l(_this96, "removeColorButtonView");
    l(_this96, "_focusables");
    l(_this96, "_documentColorsLabel");
    l(_this96, "_removeButtonLabel");
    l(_this96, "_colorPickerLabel");
    var p = _this96.bindTemplate;
    _this96.set("isVisible", !0), _this96.focusTracker = c, _this96.items = _this96.createCollection(), _this96.colorDefinitions = t, _this96.columns = i, _this96.documentColors = new ws(), _this96.documentColorsCount = a, _this96._focusables = h, _this96._removeButtonLabel = n, _this96._colorPickerLabel = u, _this96._documentColorsLabel = r, _this96.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck-color-grids-fragment", p.if("isVisible", "ck-hidden", function (b) {
          return !b;
        })]
      },
      children: _this96.items
    }), _this96.removeColorButtonView = _this96._createRemoveColorButton(), _this96.items.add(_this96.removeColorButtonView);
    return _this96;
  }
  _inherits(bs, _d29);
  return _createClass(bs, [{
    key: "updateDocumentColors",
    value: function updateDocumentColors(e, t) {
      var i = e.document,
        n = this.documentColorsCount;
      this.documentColors.clear();
      var _iterator30 = _createForOfIteratorHelper(i.getRoots()),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var r = _step30.value;
          var a = e.createRangeIn(r);
          var _iterator31 = _createForOfIteratorHelper(a.getItems()),
            _step31;
          try {
            for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
              var u = _step31.value;
              if (u.is("$textProxy") && u.hasAttribute(t) && (this._addColorToDocumentColors(u.getAttribute(t)), this.documentColors.length >= n)) return;
            }
          } catch (err) {
            _iterator31.e(err);
          } finally {
            _iterator31.f();
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }
  }, {
    key: "updateSelectedColors",
    value: function updateSelectedColors() {
      var e = this.documentColorsGrid,
        t = this.staticColorsGrid,
        i = this.selectedColor;
      t.selectedColor = i, e && (e.selectedColor = i);
    }
  }, {
    key: "render",
    value: function render() {
      if (_superPropGet(bs, "render", this, 3)([]), this.staticColorsGrid = this._createStaticColorsGrid(), this.items.add(this.staticColorsGrid), this.documentColorsCount) {
        var _e16 = E.bind(this.documentColors, this.documentColors),
          t = new d(this.locale);
        t.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-color-grid__label", _e16.if("isEmpty", "ck-hidden")]
          },
          children: [{
            text: this._documentColorsLabel
          }]
        }), this.items.add(t), this.documentColorsGrid = this._createDocumentColorsGrid(), this.items.add(this.documentColorsGrid);
      }
      this._createColorPickerButton(), this._addColorSelectorElementsToFocusTracker();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.removeColorButtonView.focus();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(bs, "destroy", this, 3)([]);
    }
  }, {
    key: "addColorPickerButton",
    value: function addColorPickerButton() {
      this.colorPickerButtonView && (this.items.add(this.colorPickerButtonView), this.focusTracker.add(this.colorPickerButtonView.element), this._focusables.add(this.colorPickerButtonView));
    }
  }, {
    key: "_addColorSelectorElementsToFocusTracker",
    value: function _addColorSelectorElementsToFocusTracker() {
      this.focusTracker.add(this.removeColorButtonView.element), this._focusables.add(this.removeColorButtonView), this.staticColorsGrid && (this.focusTracker.add(this.staticColorsGrid.element), this._focusables.add(this.staticColorsGrid)), this.documentColorsGrid && (this.focusTracker.add(this.documentColorsGrid.element), this._focusables.add(this.documentColorsGrid));
    }
  }, {
    key: "_createColorPickerButton",
    value: function _createColorPickerButton() {
      var _this97 = this;
      this.colorPickerButtonView = new w(), this.colorPickerButtonView.set({
        label: this._colorPickerLabel,
        withText: !0,
        icon: ni,
        class: "ck-color-selector__color-picker"
      }), this.colorPickerButtonView.on("execute", function () {
        _this97.fire("colorPicker:show");
      });
    }
  }, {
    key: "_createRemoveColorButton",
    value: function _createRemoveColorButton() {
      var _this98 = this;
      var e = new w();
      return e.set({
        withText: !0,
        icon: ri,
        label: this._removeButtonLabel
      }), e.class = "ck-color-selector__remove-color", e.on("execute", function () {
        _this98.fire("execute", {
          value: null,
          source: "removeColorButton"
        });
      }), e.render(), e;
    }
  }, {
    key: "_createStaticColorsGrid",
    value: function _createStaticColorsGrid() {
      var _this99 = this;
      var e = new je(this.locale, {
        colorDefinitions: this.colorDefinitions,
        columns: this.columns
      });
      return e.on("execute", function (t, i) {
        _this99.fire("execute", {
          value: i.value,
          source: "staticColorsGrid"
        });
      }), e;
    }
  }, {
    key: "_createDocumentColorsGrid",
    value: function _createDocumentColorsGrid() {
      var _this100 = this;
      var e = E.bind(this.documentColors, this.documentColors),
        t = new je(this.locale, {
          columns: this.columns
        });
      return t.extendTemplate({
        attributes: {
          class: e.if("isEmpty", "ck-hidden")
        }
      }), t.items.bindTo(this.documentColors).using(function (i) {
        var r;
        var n = new Vt();
        return n.set({
          color: i.color,
          hasBorder: (r = i.options) == null ? void 0 : r.hasBorder
        }), i.label && n.set({
          label: i.label,
          tooltip: !0
        }), n.on("execute", function () {
          _this100.fire("execute", {
            value: i.color,
            source: "documentColorsGrid"
          });
        }), n;
      }), this.documentColors.on("change:isEmpty", function (i, n, r) {
        r && (t.selectedColor = null);
      }), t;
    }
  }, {
    key: "_addColorToDocumentColors",
    value: function _addColorToDocumentColors(e) {
      var t = this.colorDefinitions.find(function (i) {
        return i.color === e;
      });
      t ? this.documentColors.add(Object.assign({}, t)) : this.documentColors.add({
        color: e,
        label: e,
        options: {
          hasBorder: !1
        }
      });
    }
  }]);
}(d);
var gs = /*#__PURE__*/function (_d30) {
  function gs(e, _ref11) {
    var _this101;
    var t = _ref11.focusTracker,
      i = _ref11.focusables,
      n = _ref11.keystrokes,
      r = _ref11.colorPickerViewConfig;
    _classCallCheck(this, gs);
    _this101 = _callSuper(this, gs, [e]);
    l(_this101, "items");
    l(_this101, "colorPickerView");
    l(_this101, "saveButtonView");
    l(_this101, "cancelButtonView");
    l(_this101, "actionBarView");
    l(_this101, "focusTracker");
    l(_this101, "keystrokes");
    l(_this101, "_focusables");
    l(_this101, "_colorPickerViewConfig");
    _this101.items = _this101.createCollection(), _this101.focusTracker = t, _this101.keystrokes = n, _this101.set("isVisible", !1), _this101.set("selectedColor", void 0), _this101._focusables = i, _this101._colorPickerViewConfig = r;
    var a = _this101.bindTemplate,
      _this101$_createActio = _this101._createActionButtons(),
      u = _this101$_createActio.saveButtonView,
      c = _this101$_createActio.cancelButtonView;
    _this101.saveButtonView = u, _this101.cancelButtonView = c, _this101.actionBarView = _this101._createActionBarView({
      saveButtonView: u,
      cancelButtonView: c
    }), _this101.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck-color-picker-fragment", a.if("isVisible", "ck-hidden", function (h) {
          return !h;
        })]
      },
      children: _this101.items
    });
    return _this101;
  }
  _inherits(gs, _d30);
  return _createClass(gs, [{
    key: "render",
    value: function render() {
      _superPropGet(gs, "render", this, 3)([]);
      var e = new ds(this.locale, _objectSpread({}, this._colorPickerViewConfig));
      this.colorPickerView = e, this.colorPickerView.render(), this.selectedColor && (e.color = this.selectedColor), this.listenTo(this, "change:selectedColor", function (t, i, n) {
        e.color = n;
      }), this.items.add(this.colorPickerView), this.items.add(this.actionBarView), this._addColorPickersElementsToFocusTracker(), this._stopPropagationOnArrowsKeys(), this._executeOnEnterPress(), this._executeUponColorChange();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(gs, "destroy", this, 3)([]);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.colorPickerView.focus();
    }
  }, {
    key: "resetValidationStatus",
    value: function resetValidationStatus() {
      this.colorPickerView.resetValidationStatus();
    }
  }, {
    key: "_executeOnEnterPress",
    value: function _executeOnEnterPress() {
      var _this102 = this;
      this.keystrokes.set("enter", function (e) {
        _this102.isVisible && _this102.focusTracker.focusedElement !== _this102.cancelButtonView.element && _this102.colorPickerView.isValid() && (_this102.fire("execute", {
          value: _this102.selectedColor
        }), e.stopPropagation(), e.preventDefault());
      });
    }
  }, {
    key: "_stopPropagationOnArrowsKeys",
    value: function _stopPropagationOnArrowsKeys() {
      var e = function e(t) {
        return t.stopPropagation();
      };
      this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e);
    }
  }, {
    key: "_addColorPickersElementsToFocusTracker",
    value: function _addColorPickersElementsToFocusTracker() {
      var _iterator32 = _createForOfIteratorHelper(this.colorPickerView.slidersView),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var t = _step32.value;
          this.focusTracker.add(t.element), this._focusables.add(t);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      var e = this.colorPickerView.hexInputRow.children.get(1);
      e.element && (this.focusTracker.add(e.element), this._focusables.add(e)), this.focusTracker.add(this.saveButtonView.element), this._focusables.add(this.saveButtonView), this.focusTracker.add(this.cancelButtonView.element), this._focusables.add(this.cancelButtonView);
    }
  }, {
    key: "_createActionBarView",
    value: function _createActionBarView(_ref12) {
      var e = _ref12.saveButtonView,
        t = _ref12.cancelButtonView;
      var i = new d(),
        n = this.createCollection();
      return n.add(e), n.add(t), i.setTemplate({
        tag: "div",
        attributes: {
          class: ["ck", "ck-color-selector_action-bar"]
        },
        children: n
      }), i;
    }
  }, {
    key: "_createActionButtons",
    value: function _createActionButtons() {
      var _this103 = this;
      var e = this.locale,
        t = e.t,
        i = new w(e),
        n = new w(e);
      return i.set({
        icon: ft,
        class: "ck-button-save",
        type: "button",
        withText: !1,
        label: t("Accept")
      }), n.set({
        icon: dt,
        class: "ck-button-cancel",
        type: "button",
        withText: !1,
        label: t("Cancel")
      }), i.on("execute", function () {
        _this103.colorPickerView.isValid() && _this103.fire("execute", {
          source: "colorPickerSaveButton",
          value: _this103.selectedColor
        });
      }), n.on("execute", function () {
        _this103.fire("colorPicker:cancel");
      }), {
        saveButtonView: i,
        cancelButtonView: n
      };
    }
  }, {
    key: "_executeUponColorChange",
    value: function _executeUponColorChange() {
      var _this104 = this;
      this.colorPickerView.on("colorSelected", function (e, t) {
        _this104.fire("execute", {
          value: t.color,
          source: "colorPicker"
        }), _this104.set("selectedColor", t.color);
      });
    }
  }]);
}(d);
var yo = /*#__PURE__*/function (_d31) {
  function yo(e, _ref13) {
    var _this105;
    var t = _ref13.colors,
      i = _ref13.columns,
      n = _ref13.removeButtonLabel,
      r = _ref13.documentColorsLabel,
      a = _ref13.documentColorsCount,
      u = _ref13.colorPickerLabel,
      c = _ref13.colorPickerViewConfig;
    _classCallCheck(this, yo);
    _this105 = _callSuper(this, yo, [e]);
    l(_this105, "focusTracker");
    l(_this105, "keystrokes");
    l(_this105, "items");
    l(_this105, "colorGridsFragmentView");
    l(_this105, "colorPickerFragmentView");
    l(_this105, "_focusCycler");
    l(_this105, "_focusables");
    l(_this105, "_colorPickerViewConfig");
    _this105.items = _this105.createCollection(), _this105.focusTracker = new T(), _this105.keystrokes = new O(), _this105._focusables = new A(), _this105._colorPickerViewConfig = c, _this105._focusCycler = new H({
      focusables: _this105._focusables,
      focusTracker: _this105.focusTracker,
      keystrokeHandler: _this105.keystrokes,
      actions: {
        focusPrevious: "shift + tab",
        focusNext: "tab"
      }
    }), _this105.colorGridsFragmentView = new bs(e, {
      colors: t,
      columns: i,
      removeButtonLabel: n,
      documentColorsLabel: r,
      documentColorsCount: a,
      colorPickerLabel: u,
      focusTracker: _this105.focusTracker,
      focusables: _this105._focusables
    }), _this105.colorPickerFragmentView = new gs(e, {
      focusables: _this105._focusables,
      focusTracker: _this105.focusTracker,
      keystrokes: _this105.keystrokes,
      colorPickerViewConfig: c
    }), _this105.set("_isColorGridsFragmentVisible", !0), _this105.set("_isColorPickerFragmentVisible", !1), _this105.set("selectedColor", void 0), _this105.colorGridsFragmentView.bind("isVisible").to(_this105, "_isColorGridsFragmentVisible"), _this105.colorPickerFragmentView.bind("isVisible").to(_this105, "_isColorPickerFragmentVisible"), _this105.on("change:selectedColor", function (h, p, b) {
      _this105.colorGridsFragmentView.set("selectedColor", b), _this105.colorPickerFragmentView.set("selectedColor", b);
    }), _this105.colorGridsFragmentView.on("change:selectedColor", function (h, p, b) {
      _this105.set("selectedColor", b);
    }), _this105.colorPickerFragmentView.on("change:selectedColor", function (h, p, b) {
      _this105.set("selectedColor", b);
    }), _this105.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-selector"]
      },
      children: _this105.items
    });
    return _this105;
  }
  _inherits(yo, _d31);
  return _createClass(yo, [{
    key: "render",
    value: function render() {
      _superPropGet(yo, "render", this, 3)([]), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(yo, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }, {
    key: "appendUI",
    value: function appendUI() {
      this._appendColorGridsFragment(), this._colorPickerViewConfig && this._appendColorPickerFragment();
    }
  }, {
    key: "showColorPickerFragment",
    value: function showColorPickerFragment() {
      !this.colorPickerFragmentView.colorPickerView || this._isColorPickerFragmentVisible || (this._isColorPickerFragmentVisible = !0, this.colorPickerFragmentView.focus(), this.colorPickerFragmentView.resetValidationStatus(), this._isColorGridsFragmentVisible = !1);
    }
  }, {
    key: "showColorGridsFragment",
    value: function showColorGridsFragment() {
      this._isColorGridsFragmentVisible || (this._isColorGridsFragmentVisible = !0, this.colorGridsFragmentView.focus(), this._isColorPickerFragmentVisible = !1);
    }
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
  }, {
    key: "updateDocumentColors",
    value: function updateDocumentColors(e, t) {
      this.colorGridsFragmentView.updateDocumentColors(e, t);
    }
  }, {
    key: "updateSelectedColors",
    value: function updateSelectedColors() {
      this.colorGridsFragmentView.updateSelectedColors();
    }
  }, {
    key: "_appendColorGridsFragment",
    value: function _appendColorGridsFragment() {
      this.items.length || (this.items.add(this.colorGridsFragmentView), this.colorGridsFragmentView.delegate("execute").to(this), this.colorGridsFragmentView.delegate("colorPicker:show").to(this));
    }
  }, {
    key: "_appendColorPickerFragment",
    value: function _appendColorPickerFragment() {
      var _this106 = this;
      this.items.length !== 2 && (this.items.add(this.colorPickerFragmentView), this.colorGridsFragmentView.colorPickerButtonView && this.colorGridsFragmentView.colorPickerButtonView.on("execute", function () {
        _this106.showColorPickerFragment();
      }), this.colorGridsFragmentView.addColorPickerButton(), this.colorPickerFragmentView.delegate("execute").to(this), this.colorPickerFragmentView.delegate("colorPicker:cancel").to(this));
    }
  }]);
}(d);
var _s = /*#__PURE__*/function () {
  function _s(o) {
    _classCallCheck(this, _s);
    l(this, "editor");
    l(this, "_components", new Map());
    this.editor = o;
  }
  return _createClass(_s, [{
    key: "names",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
      var _iterator33, _step33, o;
      return _regeneratorRuntime().wrap(function names$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _iterator33 = _createForOfIteratorHelper(this._components.values());
            _context3.prev = 1;
            _iterator33.s();
          case 3:
            if ((_step33 = _iterator33.n()).done) {
              _context3.next = 9;
              break;
            }
            o = _step33.value;
            _context3.next = 7;
            return o.originalName;
          case 7:
            _context3.next = 3;
            break;
          case 9:
            _context3.next = 14;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            _iterator33.e(_context3.t0);
          case 14:
            _context3.prev = 14;
            _iterator33.f();
            return _context3.finish(14);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, names, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "add",
    value: function add(o, e) {
      this._components.set(me(o), {
        callback: e,
        originalName: o
      });
    }
  }, {
    key: "create",
    value: function create(o) {
      if (!this.has(o)) throw new V("componentfactory-item-missing", this, {
        name: o
      });
      return this._components.get(me(o)).callback(this.editor.locale);
    }
  }, {
    key: "has",
    value: function has(o) {
      return this._components.has(me(o));
    }
  }]);
}();
function me(s) {
  return String(s).toLowerCase();
}
var Je = "ck-tooltip",
  m = /*#__PURE__*/function (_ae2) {
    function m(e) {
      var _this107;
      _classCallCheck(this, m);
      _this107 = _callSuper(this, m);
      l(_this107, "tooltipTextView");
      l(_this107, "balloonPanelView");
      l(_this107, "_currentElementWithTooltip", null);
      l(_this107, "_currentTooltipPosition", null);
      l(_this107, "_mutationObserver", null);
      l(_this107, "_pinTooltipDebounced");
      l(_this107, "_unpinTooltipDebounced");
      l(_this107, "_watchdogExcluded");
      if (m._editors.add(e), m._instance) return _possibleConstructorReturn(_this107, m._instance);
      m._instance = _this107, _this107.tooltipTextView = new d(e.locale), _this107.tooltipTextView.set("text", ""), _this107.tooltipTextView.setTemplate({
        tag: "span",
        attributes: {
          class: ["ck", "ck-tooltip__text"]
        },
        children: [{
          text: _this107.tooltipTextView.bindTemplate.to("text")
        }]
      }), _this107.balloonPanelView = new R(e.locale), _this107.balloonPanelView.class = Je, _this107.balloonPanelView.content.add(_this107.tooltipTextView), _this107._mutationObserver = ks(function () {
        _this107._updateTooltipPosition();
      }), _this107._pinTooltipDebounced = _e(_this107._pinTooltip, 600), _this107._unpinTooltipDebounced = _e(_this107._unpinTooltip, 400), _this107.listenTo(f.document, "keydown", _this107._onKeyDown.bind(_this107), {
        useCapture: !0
      }), _this107.listenTo(f.document, "mouseenter", _this107._onEnterOrFocus.bind(_this107), {
        useCapture: !0
      }), _this107.listenTo(f.document, "mouseleave", _this107._onLeaveOrBlur.bind(_this107), {
        useCapture: !0
      }), _this107.listenTo(f.document, "focus", _this107._onEnterOrFocus.bind(_this107), {
        useCapture: !0
      }), _this107.listenTo(f.document, "blur", _this107._onLeaveOrBlur.bind(_this107), {
        useCapture: !0
      }), _this107.listenTo(f.document, "scroll", _this107._onScroll.bind(_this107), {
        useCapture: !0
      }), _this107._watchdogExcluded = !0;
      return _this107;
    }
    _inherits(m, _ae2);
    return _createClass(m, [{
      key: "destroy",
      value: function destroy(e) {
        var t = e.ui.view && e.ui.view.body;
        m._editors.delete(e), this.stopListening(e.ui), t && t.has(this.balloonPanelView) && t.remove(this.balloonPanelView), m._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), m._instance = null);
      }
    }, {
      key: "_onKeyDown",
      value: function _onKeyDown(e, t) {
        t.key === "Escape" && this._currentElementWithTooltip && (this._unpinTooltip(), t.stopPropagation());
      }
    }, {
      key: "_onEnterOrFocus",
      value: function _onEnterOrFocus(e, _ref14) {
        var t = _ref14.target;
        var i = we(t);
        if (!i) {
          e.name === "focus" && this._unpinTooltip();
          return;
        }
        if (i === this._currentElementWithTooltip) {
          this._unpinTooltipDebounced.cancel();
          return;
        }
        this._unpinTooltip(), e.name === "focus" && !i.matches(":hover") || i.matches("[data-cke-tooltip-instant]") ? this._pinTooltip(i, be(i)) : this._pinTooltipDebounced(i, be(i));
      }
    }, {
      key: "_onLeaveOrBlur",
      value: function _onLeaveOrBlur(e, _ref15) {
        var t = _ref15.target,
          i = _ref15.relatedTarget;
        if (e.name === "mouseleave") {
          if (!Pe(t)) return;
          var n = this.balloonPanelView.element,
            r = n && (n === i || n.contains(i)),
            a = !r && t === n;
          if (r) {
            this._unpinTooltipDebounced.cancel();
            return;
          }
          if (!a && this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
          var u = we(t),
            c = we(i);
          (a || u && u !== c) && (this._pinTooltipDebounced.cancel(), this._currentElementWithTooltip && this._currentElementWithTooltip.matches("[data-cke-tooltip-instant]") || u && u.matches("[data-cke-tooltip-instant]") ? this._unpinTooltip() : this._unpinTooltipDebounced());
        } else {
          if (this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
          this._pinTooltipDebounced.cancel(), this._unpinTooltipDebounced();
        }
      }
    }, {
      key: "_onScroll",
      value: function _onScroll(e, _ref16) {
        var t = _ref16.target;
        this._currentElementWithTooltip && (t.contains(this.balloonPanelView.element) && t.contains(this._currentElementWithTooltip) || this._unpinTooltip());
      }
    }, {
      key: "_pinTooltip",
      value: function _pinTooltip(e, _ref17) {
        var t = _ref17.text,
          i = _ref17.position,
          n = _ref17.cssClass;
        this._unpinTooltip();
        var r = Kt(m._editors.values()).ui.view.body;
        r.has(this.balloonPanelView) || r.add(this.balloonPanelView), this.tooltipTextView.text = t, this.balloonPanelView.class = [Je, n].filter(function (a) {
          return a;
        }).join(" "), this.balloonPanelView.pin({
          target: e,
          positions: m.getPositioningFunctions(i)
        }), this._mutationObserver.attach(e);
        var _iterator34 = _createForOfIteratorHelper(m._editors),
          _step34;
        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var a = _step34.value;
            this.listenTo(a.ui, "update", this._updateTooltipPosition.bind(this), {
              priority: "low"
            });
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }
        this._currentElementWithTooltip = e, this._currentTooltipPosition = i;
      }
    }, {
      key: "_unpinTooltip",
      value: function _unpinTooltip() {
        this._unpinTooltipDebounced.cancel(), this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
        var _iterator35 = _createForOfIteratorHelper(m._editors),
          _step35;
        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var _e17 = _step35.value;
            this.stopListening(_e17.ui, "update");
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
        this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this.tooltipTextView.text = "", this._mutationObserver.detach();
      }
    }, {
      key: "_updateTooltipPosition",
      value: function _updateTooltipPosition() {
        if (!this._currentElementWithTooltip) return;
        var e = be(this._currentElementWithTooltip);
        if (!B(this._currentElementWithTooltip) || !e.text) {
          this._unpinTooltip();
          return;
        }
        this.balloonPanelView.pin({
          target: this._currentElementWithTooltip,
          positions: m.getPositioningFunctions(e.position)
        });
      }
    }], [{
      key: "getPositioningFunctions",
      value: function getPositioningFunctions(e) {
        var t = m.defaultBalloonPositions;
        return {
          s: [t.southArrowNorth, t.southArrowNorthEast, t.southArrowNorthWest],
          n: [t.northArrowSouth],
          e: [t.eastArrowWest],
          w: [t.westArrowEast],
          sw: [t.southArrowNorthEast],
          se: [t.southArrowNorthWest]
        }[e];
      }
    }]);
  }(ae());
l(m, "defaultBalloonPositions", R.generatePositions({
  heightOffset: 5,
  sideOffset: 13
})), l(m, "_editors", new Set()), l(m, "_instance", null);
var Ce = m;
function we(s) {
  return Pe(s) ? s.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
}
function be(s) {
  return {
    text: s.dataset.ckeTooltipText,
    position: s.dataset.ckeTooltipPosition || "s",
    cssClass: s.dataset.ckeTooltipClass || ""
  };
}
function ks(s) {
  var o = new MutationObserver(function () {
    s();
  });
  return {
    attach: function attach(e) {
      o.observe(e, {
        attributes: !0,
        attributeFilter: ["data-cke-tooltip-text", "data-cke-tooltip-position"]
      });
    },
    detach: function detach() {
      o.disconnect();
    }
  };
}
var Ts = 50,
  vs = 350;
var Dt = /*#__PURE__*/function (_ae3) {
  function Dt(e) {
    var _this108;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Dt);
    _this108 = _callSuper(this, Dt);
    l(_this108, "editor");
    l(_this108, "_balloonView", null);
    l(_this108, "_showBalloonThrottled", di(function () {
      return _this108._showBalloon();
    }, 50, {
      leading: !0
    }));
    l(_this108, "_lastFocusedEditableElement", null);
    l(_this108, "_balloonClass");
    _this108.editor = e, _this108._balloonClass = t.balloonClass, e.on("ready", function () {
      return _this108._handleEditorReady();
    });
    return _this108;
  }
  _inherits(Dt, _ae3);
  return _createClass(Dt, [{
    key: "destroy",
    value: function destroy() {
      var e = this._balloonView;
      e && (e.unpin(), this._balloonView = null), this._showBalloonThrottled.cancel(), this.stopListening();
    }
  }, {
    key: "_handleEditorReady",
    value: function _handleEditorReady() {
      var _this109 = this;
      var e = this.editor;
      this._isEnabled() && e.ui.view && (e.ui.focusTracker.on("change:isFocused", function (t, i, n) {
        _this109._updateLastFocusedEditableElement(), n ? _this109._showBalloon() : _this109._hideBalloon();
      }), e.ui.focusTracker.on("change:focusedElement", function (t, i, n) {
        _this109._updateLastFocusedEditableElement(), n && _this109._showBalloon();
      }), e.ui.on("update", function () {
        _this109._showBalloonThrottled();
      }));
    }
  }, {
    key: "_getNormalizedConfig",
    value: function _getNormalizedConfig() {
      return {
        side: this.editor.locale.contentLanguageDirection === "ltr" ? "right" : "left",
        position: "border",
        verticalOffset: 0,
        horizontalOffset: 5
      };
    }
  }, {
    key: "_showBalloon",
    value: function _showBalloon() {
      var e = this._getBalloonAttachOptions();
      e && (this._balloonView || (this._balloonView = this._createBalloonView()), this._balloonView.pin(e));
    }
  }, {
    key: "_hideBalloon",
    value: function _hideBalloon() {
      this._balloonView && this._balloonView.unpin();
    }
  }, {
    key: "_createBalloonView",
    value: function _createBalloonView() {
      var e = this.editor,
        t = new R(),
        i = this._createBadgeContent();
      return t.content.add(i), this._balloonClass && (t.class = this._balloonClass), e.ui.view.body.add(t), t;
    }
  }, {
    key: "_getBalloonAttachOptions",
    value: function _getBalloonAttachOptions() {
      if (!this._lastFocusedEditableElement) return null;
      var e = this._getNormalizedConfig(),
        t = e.side === "right" ? ys(this._lastFocusedEditableElement, e) : Cs(this._lastFocusedEditableElement, e);
      return {
        target: this._lastFocusedEditableElement,
        positions: [t]
      };
    }
  }, {
    key: "_updateLastFocusedEditableElement",
    value: function _updateLastFocusedEditableElement() {
      var e = this.editor,
        t = e.ui.focusTracker.isFocused,
        i = e.ui.focusTracker.focusedElement;
      if (!t || !i) {
        this._lastFocusedEditableElement = null;
        return;
      }
      var n = Array.from(e.ui.getEditableElementsNames()).map(function (r) {
        return e.ui.getEditableElement(r);
      });
      n.includes(i) ? this._lastFocusedEditableElement = i : this._lastFocusedEditableElement = n[0];
    }
  }]);
}(ae());
function ys(s, o) {
  return St(s, o, function (e, t) {
    return e.left + e.width - t.width - o.horizontalOffset;
  });
}
function Cs(s, o) {
  return St(s, o, function (e) {
    return e.left + o.horizontalOffset;
  });
}
function St(s, o, e) {
  return function (t, i) {
    var n = new C(s);
    if (n.width < vs || n.height < Ts) return null;
    var r;
    o.position === "inside" ? r = n.bottom - i.height : r = n.bottom - i.height / 2, r -= o.verticalOffset;
    var a = e(n, i),
      c = t.clone().moveTo(a, r).getIntersection(i.clone().moveTo(a, r)).getVisible();
    return !c || c.getArea() < i.getArea() ? null : {
      top: r,
      left: a,
      name: "position_".concat(o.position, "-side_").concat(o.side),
      config: {
        withArrow: !1
      }
    };
  };
}
var Vs = "Powered by";
var xs = /*#__PURE__*/function (_Dt) {
  function xs(o) {
    _classCallCheck(this, xs);
    return _callSuper(this, xs, [o, {
      balloonClass: "ck-powered-by-balloon"
    }]);
  }
  _inherits(xs, _Dt);
  return _createClass(xs, [{
    key: "_isEnabled",
    value: function _isEnabled() {
      var o = this.editor;
      if (o.config.get("ui.poweredBy.forceVisible")) return !0;
      var t = o.config.get("licenseKey");
      if (t == "GPL") return !0;
      var i = ut(t.split(".")[1]);
      return i ? !i.whiteLabel : !0;
    }
  }, {
    key: "_createBadgeContent",
    value: function _createBadgeContent() {
      return new Es(this.editor.locale, this._getNormalizedConfig().label);
    }
  }, {
    key: "_getNormalizedConfig",
    value: function _getNormalizedConfig() {
      var o = _superPropGet(xs, "_getNormalizedConfig", this, 3)([]),
        e = this.editor.config.get("ui.poweredBy") || {},
        t = e.position || o.position,
        i = t === "inside" ? 5 : o.verticalOffset;
      return {
        position: t,
        side: e.side || o.side,
        label: e.label === void 0 ? Vs : e.label,
        verticalOffset: e.verticalOffset !== void 0 ? e.verticalOffset : i,
        horizontalOffset: e.horizontalOffset !== void 0 ? e.horizontalOffset : o.horizontalOffset,
        forceVisible: !!e.forceVisible
      };
    }
  }]);
}(Dt);
var Es = /*#__PURE__*/function (_d32) {
  function Es(o, e) {
    var _this110;
    _classCallCheck(this, Es);
    _this110 = _callSuper(this, Es, [o]);
    var t = new L(),
      i = _this110.bindTemplate;
    t.set({
      content: li,
      isColorInherited: !1
    }), _this110.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-powered-by"],
        "aria-hidden": !0
      },
      children: [{
        tag: "a",
        attributes: {
          href: "https://ckeditor.com/powered-by-ckeditor/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
          target: "_blank",
          tabindex: "-1"
        },
        children: [].concat(_toConsumableArray(e ? [{
          tag: "span",
          attributes: {
            class: ["ck", "ck-powered-by__label"]
          },
          children: [e]
        }] : []), [t]),
        on: {
          dragstart: i.to(function (n) {
            return n.preventDefault();
          })
        }
      }]
    });
    return _this110;
  }
  _inherits(Es, _d32);
  return _createClass(Es);
}(d);
var Is = /*#__PURE__*/function (_Dt2) {
  function Is(e) {
    var _this111;
    _classCallCheck(this, Is);
    _this111 = _callSuper(this, Is, [e, {
      balloonClass: "ck-evaluation-badge-balloon"
    }]);
    l(_this111, "licenseTypeMessage", {
      evaluation: "For evaluation purposes only",
      trial: "For evaluation purposes only",
      development: "For development purposes only"
    });
    return _this111;
  }
  _inherits(Is, _Dt2);
  return _createClass(Is, [{
    key: "_isEnabled",
    value: function _isEnabled() {
      var t = this.editor.config.get("licenseKey"),
        i = et(t);
      return !!(i && this.licenseTypeMessage[i]);
    }
  }, {
    key: "_createBadgeContent",
    value: function _createBadgeContent() {
      var e = this.editor.config.get("licenseKey"),
        t = et(e);
      return new Os(this.editor.locale, this.licenseTypeMessage[t]);
    }
  }, {
    key: "_getNormalizedConfig",
    value: function _getNormalizedConfig() {
      var e = _superPropGet(Is, "_getNormalizedConfig", this, 3)([]),
        t = this.editor.config.get("ui.poweredBy") || {},
        i = t.position || e.position,
        n = t.side || e.side;
      return {
        position: i,
        side: n === "left" ? "right" : "left",
        verticalOffset: e.verticalOffset,
        horizontalOffset: e.horizontalOffset
      };
    }
  }]);
}(Dt);
var Os = /*#__PURE__*/function (_d33) {
  function Os(o, e) {
    var _this112;
    _classCallCheck(this, Os);
    _this112 = _callSuper(this, Os, [o]), _this112.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-evaluation-badge"],
        "aria-hidden": !0
      },
      children: [{
        tag: "span",
        attributes: {
          class: ["ck", "ck-evaluation-badge__label"]
        },
        children: [e]
      }]
    });
    return _this112;
  }
  _inherits(Os, _d33);
  return _createClass(Os);
}(d);
function et(s) {
  if (s == "GPL") return "GPL";
  var o = ut(s.split(".")[1]);
  return o ? o.licenseType || "production" : null;
}
var tt = {
  POLITE: "polite",
  ASSERTIVE: "assertive"
};
var Ps = /*#__PURE__*/function () {
  function Ps(o) {
    var _this113 = this;
    _classCallCheck(this, Ps);
    l(this, "editor");
    l(this, "view");
    this.editor = o, o.once("ready", function () {
      for (var _i7 = 0, _Object$values = Object.values(tt); _i7 < _Object$values.length; _i7++) {
        var _e18 = _Object$values[_i7];
        _this113.announce("", _e18);
      }
    });
  }
  return _createClass(Ps, [{
    key: "announce",
    value: function announce(o) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tt.POLITE;
      var t = this.editor;
      if (!t.ui.view) return;
      this.view || (this.view = new Bs(t.locale), t.ui.view.body.add(this.view));
      var _ref18 = typeof e == "string" ? {
          politeness: e
        } : e,
        i = _ref18.politeness,
        n = _ref18.isUnsafeHTML;
      var r = this.view.regionViews.find(function (a) {
        return a.politeness === i;
      });
      r || (r = new Ls(t, i), this.view.regionViews.add(r)), r.announce({
        announcement: o,
        isUnsafeHTML: n
      });
    }
  }]);
}();
var Bs = /*#__PURE__*/function (_d34) {
  function Bs(e) {
    var _this114;
    _classCallCheck(this, Bs);
    _this114 = _callSuper(this, Bs, [e]);
    l(_this114, "regionViews");
    _this114.regionViews = _this114.createCollection(), _this114.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-aria-live-announcer"]
      },
      children: _this114.regionViews
    });
    return _this114;
  }
  _inherits(Bs, _d34);
  return _createClass(Bs);
}(d);
var Ls = /*#__PURE__*/function (_d35) {
  function Ls(e, t) {
    var _this115;
    _classCallCheck(this, Ls);
    _this115 = _callSuper(this, Ls, [e.locale]);
    l(_this115, "politeness");
    l(_this115, "_domConverter");
    l(_this115, "_pruneAnnouncementsInterval");
    _this115.setTemplate({
      tag: "div",
      attributes: {
        "aria-live": t,
        "aria-relevant": "additions"
      },
      children: [{
        tag: "ul",
        attributes: {
          class: ["ck", "ck-aria-live-region-list"]
        }
      }]
    }), e.on("destroy", function () {
      _this115._pruneAnnouncementsInterval !== null && (clearInterval(_this115._pruneAnnouncementsInterval), _this115._pruneAnnouncementsInterval = null);
    }), _this115.politeness = t, _this115._domConverter = e.data.htmlProcessor.domConverter, _this115._pruneAnnouncementsInterval = setInterval(function () {
      _this115.element && _this115._listElement.firstChild && _this115._listElement.firstChild.remove();
    }, 5e3);
    return _this115;
  }
  _inherits(Ls, _d35);
  return _createClass(Ls, [{
    key: "announce",
    value: function announce(_ref19) {
      var e = _ref19.announcement,
        t = _ref19.isUnsafeHTML;
      if (!e.trim().length) return;
      var i = document.createElement("li");
      t ? this._domConverter.setContentOf(i, e) : i.innerText = e, this._listElement.appendChild(i);
    }
  }, {
    key: "_listElement",
    get: function get() {
      return this.element.querySelector("ul");
    }
  }]);
}(d);
var Mt = /*#__PURE__*/function (_F) {
  function Mt(o, e) {
    var _this116;
    _classCallCheck(this, Mt);
    _this116 = _callSuper(this, Mt, [o]);
    var t = _this116.bindTemplate;
    _this116.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__item"]
      },
      on: {
        mouseenter: t.to("mouseenter")
      }
    }), _this116.delegate("mouseenter").to(e);
    return _this116;
  }
  _inherits(Mt, _F);
  return _createClass(Mt);
}(F);
var X = 5,
  M = {
    toggleMenusAndFocusItemsOnHover: function toggleMenusAndFocusItemsOnHover(s) {
      s.on("menu:mouseenter", function (o) {
        if (!(!s.isFocusBorderEnabled && !s.isOpen)) {
          if (s.isOpen) {
            var _iterator36 = _createForOfIteratorHelper(s.menus),
              _step36;
            try {
              for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                var _e19 = _step36.value;
                var t = o.path[0],
                  i = t instanceof Mt && t.children.first === _e19;
                _e19.isOpen = (o.path.includes(_e19) || i) && _e19.isEnabled;
              }
            } catch (err) {
              _iterator36.e(err);
            } finally {
              _iterator36.f();
            }
          }
          o.source.focus();
        }
      });
    },
    focusCycleMenusOnArrows: function focusCycleMenusOnArrows(s) {
      var o = s.locale.uiLanguageDirection === "rtl";
      s.on("menu:arrowright", function (t) {
        e(t.source, o ? -1 : 1);
      }), s.on("menu:arrowleft", function (t) {
        e(t.source, o ? 1 : -1);
      });
      function e(t, i) {
        var n = s.children.getIndex(t),
          r = t.isOpen,
          a = s.children.length,
          u = s.children.get((n + a + i) % a);
        t.isOpen = !1, r && (u.isOpen = !0), u.buttonView.focus();
      }
    },
    closeMenusWhenTheBarCloses: function closeMenusWhenTheBarCloses(s) {
      s.on("change:isOpen", function () {
        s.isOpen || s.menus.forEach(function (o) {
          o.isOpen = !1;
        });
      });
    },
    closeMenuWhenAnotherOnTheSameLevelOpens: function closeMenuWhenAnotherOnTheSameLevelOpens(s) {
      s.on("menu:change:isOpen", function (o, e, t) {
        t && s.menus.filter(function (i) {
          return o.source.parentMenuView === i.parentMenuView && o.source !== i && i.isOpen;
        }).forEach(function (i) {
          i.isOpen = !1;
        });
      });
    },
    closeOnClickOutside: function closeOnClickOutside(s) {
      kt({
        emitter: s,
        activator: function activator() {
          return s.isOpen;
        },
        callback: function callback() {
          return s.close();
        },
        contextElements: function contextElements() {
          return s.children.map(function (o) {
            return o.element;
          });
        }
      });
    },
    enableFocusHighlightOnInteraction: function enableFocusHighlightOnInteraction(s) {
      var o = !1;
      s.on("change:isOpen", function (e, t, i) {
        i || (o || (s.isFocusBorderEnabled = !1), o = !1);
      }), s.listenTo(s.element, "keydown", function () {
        o = !0;
      }, {
        useCapture: !0
      }), s.listenTo(s.element, "keyup", function () {
        o = !1;
      }, {
        useCapture: !0
      }), s.listenTo(s.element, "focus", function () {
        o && (s.isFocusBorderEnabled = !0);
      }, {
        useCapture: !0
      });
    }
  },
  P = {
    openAndFocusPanelOnArrowDownKey: function openAndFocusPanelOnArrowDownKey(s) {
      s.keystrokes.set("arrowdown", function (o, e) {
        s.isEnabled && s.focusTracker.focusedElement === s.buttonView.element && (s.isOpen || (s.isOpen = !0), s.panelView.focus(), e());
      });
    },
    openOnArrowRightKey: function openOnArrowRightKey(s) {
      var o = s.locale.uiLanguageDirection === "rtl" ? "arrowleft" : "arrowright";
      s.keystrokes.set(o, function (e, t) {
        s.focusTracker.focusedElement !== s.buttonView.element || !s.isEnabled || (s.isOpen || (s.isOpen = !0), s.panelView.focus(), t());
      });
    },
    openOnButtonClick: function openOnButtonClick(s) {
      s.buttonView.on("execute", function () {
        s.isOpen = !0;
      });
    },
    toggleOnButtonClick: function toggleOnButtonClick(s) {
      s.buttonView.on("execute", function () {
        s.isOpen = !s.isOpen;
      });
    },
    openAndFocusOnEnterKeyPress: function openAndFocusOnEnterKeyPress(s) {
      s.keystrokes.set("enter", function (o, e) {
        s.focusTracker.focusedElement === s.buttonView.element && (s.isOpen = !0, s.panelView.focus(), e());
      });
    },
    closeOnArrowLeftKey: function closeOnArrowLeftKey(s) {
      var o = s.locale.uiLanguageDirection === "rtl" ? "arrowright" : "arrowleft";
      s.keystrokes.set(o, function (e, t) {
        s.isOpen && (s.isOpen = !1, s.focus(), t());
      });
    },
    closeOnEscKey: function closeOnEscKey(s) {
      s.keystrokes.set("esc", function (o, e) {
        s.isOpen && (s.isOpen = !1, s.focus(), e());
      });
    },
    closeOnParentClose: function closeOnParentClose(s) {
      s.parentMenuView.on("change:isOpen", function (o, e, t) {
        !t && o.source === s.parentMenuView && (s.isOpen = !1);
      });
    }
  },
  Fs = {
    southEast: function southEast(s) {
      return {
        top: s.bottom,
        left: s.left,
        name: "se"
      };
    },
    southWest: function southWest(s, o) {
      return {
        top: s.bottom,
        left: s.left - o.width + s.width,
        name: "sw"
      };
    },
    northEast: function northEast(s, o) {
      return {
        top: s.top - o.height,
        left: s.left,
        name: "ne"
      };
    },
    northWest: function northWest(s, o) {
      return {
        top: s.top - o.height,
        left: s.left - o.width + s.width,
        name: "nw"
      };
    },
    eastSouth: function eastSouth(s) {
      return {
        top: s.top,
        left: s.right - X,
        name: "es"
      };
    },
    eastNorth: function eastNorth(s, o) {
      return {
        top: s.top - o.height,
        left: s.right - X,
        name: "en"
      };
    },
    westSouth: function westSouth(s, o) {
      return {
        top: s.top,
        left: s.left - o.width + X,
        name: "ws"
      };
    },
    westNorth: function westNorth(s, o) {
      return {
        top: s.top - o.height,
        left: s.left - o.width + X,
        name: "wn"
      };
    }
  },
  As = [{
    menuId: "file",
    label: "File",
    groups: [{
      groupId: "export",
      items: ["menuBar:exportPdf", "menuBar:exportWord"]
    }, {
      groupId: "import",
      items: ["menuBar:importWord"]
    }, {
      groupId: "revisionHistory",
      items: ["menuBar:revisionHistory"]
    }]
  }, {
    menuId: "edit",
    label: "Edit",
    groups: [{
      groupId: "undo",
      items: ["menuBar:undo", "menuBar:redo"]
    }, {
      groupId: "selectAll",
      items: ["menuBar:selectAll"]
    }, {
      groupId: "findAndReplace",
      items: ["menuBar:findAndReplace"]
    }]
  }, {
    menuId: "view",
    label: "View",
    groups: [{
      groupId: "sourceEditingEnhanced",
      items: ["menuBar:sourceEditingEnhanced"]
    }, {
      groupId: "sourceEditing",
      items: ["menuBar:sourceEditing"]
    }, {
      groupId: "showBlocks",
      items: ["menuBar:showBlocks"]
    }, {
      groupId: "previewMergeFields",
      items: ["menuBar:previewMergeFields"]
    }, {
      groupId: "fullscreen",
      items: ["menuBar:fullscreen"]
    }, {
      groupId: "restrictedEditing",
      items: ["menuBar:restrictedEditing"]
    }]
  }, {
    menuId: "insert",
    label: "Insert",
    groups: [{
      groupId: "insertMainWidgets",
      items: ["menuBar:insertImage", "menuBar:ckbox", "menuBar:ckfinder", "menuBar:insertTable", "menuBar:insertTableLayout"]
    }, {
      groupId: "insertInline",
      items: ["menuBar:link", "menuBar:bookmark", "menuBar:comment", "menuBar:insertMergeField", "menuBar:emoji"]
    }, {
      groupId: "insertMinorWidgets",
      items: ["menuBar:mediaEmbed", "menuBar:insertTemplate", "menuBar:specialCharacters", "menuBar:blockQuote", "menuBar:codeBlock", "menuBar:htmlEmbed"]
    }, {
      groupId: "insertStructureWidgets",
      items: ["menuBar:horizontalLine", "menuBar:pageBreak", "menuBar:tableOfContents"]
    }, {
      groupId: "restrictedEditingException",
      items: ["menuBar:restrictedEditingException"]
    }]
  }, {
    menuId: "format",
    label: "Format",
    groups: [{
      groupId: "textAndFont",
      items: [{
        menuId: "text",
        label: "Text",
        groups: [{
          groupId: "basicStyles",
          items: ["menuBar:bold", "menuBar:italic", "menuBar:underline", "menuBar:strikethrough", "menuBar:superscript", "menuBar:subscript", "menuBar:code"]
        }, {
          groupId: "textPartLanguage",
          items: ["menuBar:textPartLanguage"]
        }]
      }, {
        menuId: "font",
        label: "Font",
        groups: [{
          groupId: "fontProperties",
          items: ["menuBar:fontSize", "menuBar:fontFamily"]
        }, {
          groupId: "fontColors",
          items: ["menuBar:fontColor", "menuBar:fontBackgroundColor"]
        }, {
          groupId: "highlight",
          items: ["menuBar:highlight"]
        }]
      }, "menuBar:heading"]
    }, {
      groupId: "list",
      items: ["menuBar:bulletedList", "menuBar:numberedList", "menuBar:multiLevelList", "menuBar:todoList"]
    }, {
      groupId: "indent",
      items: ["menuBar:alignment", "menuBar:indent", "menuBar:outdent"]
    }, {
      groupId: "caseChange",
      items: ["menuBar:caseChange"]
    }, {
      groupId: "removeFormat",
      items: ["menuBar:removeFormat"]
    }]
  }, {
    menuId: "tools",
    label: "Tools",
    groups: [{
      groupId: "aiTools",
      items: ["menuBar:aiAssistant", "menuBar:aiCommands"]
    }, {
      groupId: "tools",
      items: ["menuBar:trackChanges", "menuBar:commentsArchive"]
    }]
  }, {
    menuId: "help",
    label: "Help",
    groups: [{
      groupId: "help",
      items: ["menuBar:accessibilityHelp"]
    }]
  }];
function Ds(s) {
  var o;
  return !("items" in s) || !s.items ? o = _objectSpread({
    items: Oe(As),
    addItems: [],
    removeItems: [],
    isVisible: !0,
    isUsingDefaultConfig: !0
  }, s) : o = _objectSpread({
    items: s.items,
    removeItems: [],
    addItems: [],
    isVisible: !0,
    isUsingDefaultConfig: !1
  }, s), o;
}
function Ss(_ref20) {
  var s = _ref20.normalizedConfig,
    o = _ref20.locale,
    e = _ref20.componentFactory,
    t = _ref20.extraItems;
  var i = Oe(s);
  return it(s, i, t), Ms(s, i), it(s, i, i.addItems), Ns(s, i, e), Nt(s, i), Ws(i, o), i;
}
function Ms(s, o) {
  var e = o.removeItems,
    t = [];
  o.items = o.items.filter(function (_ref21) {
    var i = _ref21.menuId;
    return e.includes(i) ? (t.push(i), !1) : !0;
  }), U(o.items, function (i) {
    i.groups = i.groups.filter(function (_ref22) {
      var n = _ref22.groupId;
      return e.includes(n) ? (t.push(n), !1) : !0;
    });
    var _iterator37 = _createForOfIteratorHelper(i.groups),
      _step37;
    try {
      for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
        var n = _step37.value;
        n.items = n.items.filter(function (r) {
          var a = Wt(r);
          return e.includes(a) ? (t.push(a), !1) : !0;
        });
      }
    } catch (err) {
      _iterator37.e(err);
    } finally {
      _iterator37.f();
    }
  });
  var _iterator38 = _createForOfIteratorHelper(e),
    _step38;
  try {
    for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
      var i = _step38.value;
      t.includes(i) || x("menu-bar-item-could-not-be-removed", {
        menuBarConfig: s,
        itemName: i
      });
    }
  } catch (err) {
    _iterator38.e(err);
  } finally {
    _iterator38.f();
  }
}
function it(s, o, e) {
  var t = [];
  if (e.length != 0) {
    var _iterator39 = _createForOfIteratorHelper(e),
      _step39;
    try {
      var _loop4 = function _loop4() {
        var i = _step39.value;
        var n = Hs(i.position),
          r = zs(i.position);
        if (Gs(i)) {
          if (!r) n === "start" ? (o.items.unshift(i.menu), t.push(i)) : n === "end" && (o.items.push(i.menu), t.push(i));else {
            var a = o.items.findIndex(function (u) {
              return u.menuId === r;
            });
            a != -1 ? n === "before" ? (o.items.splice(a, 0, i.menu), t.push(i)) : n === "after" && (o.items.splice(a + 1, 0, i.menu), t.push(i)) : st(o, i.menu, r, n) && t.push(i);
          }
        } else Rs(i) ? U(o.items, function (a) {
          if (a.menuId === r) n === "start" ? (a.groups.unshift(i.group), t.push(i)) : n === "end" && (a.groups.push(i.group), t.push(i));else {
            var u = a.groups.findIndex(function (c) {
              return c.groupId === r;
            });
            u !== -1 && (n === "before" ? (a.groups.splice(u, 0, i.group), t.push(i)) : n === "after" && (a.groups.splice(u + 1, 0, i.group), t.push(i)));
          }
        }) : st(o, i.item, r, n) && t.push(i);
      };
      for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
        _loop4();
      }
    } catch (err) {
      _iterator39.e(err);
    } finally {
      _iterator39.f();
    }
    var _iterator40 = _createForOfIteratorHelper(e),
      _step40;
    try {
      for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
        var i = _step40.value;
        t.includes(i) || x("menu-bar-item-could-not-be-added", {
          menuBarConfig: s,
          addedItemConfig: i
        });
      }
    } catch (err) {
      _iterator40.e(err);
    } finally {
      _iterator40.f();
    }
  }
}
function st(s, o, e, t) {
  var i = !1;
  return U(s.items, function (n) {
    var _iterator41 = _createForOfIteratorHelper(n.groups),
      _step41;
    try {
      for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
        var _ref23 = _step41.value;
        var r = _ref23.groupId;
        var a = _ref23.items;
        if (i) return;
        if (r === e) t === "start" ? (a.unshift(o), i = !0) : t === "end" && (a.push(o), i = !0);else {
          var u = a.findIndex(function (c) {
            return Wt(c) === e;
          });
          u !== -1 && (t === "before" ? (a.splice(u, 0, o), i = !0) : t === "after" && (a.splice(u + 1, 0, o), i = !0));
        }
      }
    } catch (err) {
      _iterator41.e(err);
    } finally {
      _iterator41.f();
    }
  }), i;
}
function Ns(s, o, e) {
  U(o.items, function (t) {
    var _iterator42 = _createForOfIteratorHelper(t.groups),
      _step42;
    try {
      for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
        var i = _step42.value;
        i.items = i.items.filter(function (n) {
          var r = typeof n == "string" && !e.has(n);
          return r && !o.isUsingDefaultConfig && x("menu-bar-item-unavailable", {
            menuBarConfig: s,
            parentMenuConfig: Oe(t),
            componentName: n
          }), !r;
        });
      }
    } catch (err) {
      _iterator42.e(err);
    } finally {
      _iterator42.f();
    }
  });
}
function Nt(s, o) {
  var e = o.isUsingDefaultConfig;
  var t = !1;
  if (o.items = o.items.filter(function (i) {
    return i.groups.length ? !0 : (ge(s, i, e), !1);
  }), !o.items.length) {
    ge(s, s, e);
    return;
  }
  U(o.items, function (i) {
    i.groups = i.groups.filter(function (n) {
      return n.items.length ? !0 : (t = !0, !1);
    });
    var _iterator43 = _createForOfIteratorHelper(i.groups),
      _step43;
    try {
      for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
        var n = _step43.value;
        n.items = n.items.filter(function (r) {
          return Gt(r) && !r.groups.length ? (ge(s, r, e), t = !0, !1) : !0;
        });
      }
    } catch (err) {
      _iterator43.e(err);
    } finally {
      _iterator43.f();
    }
  }), t && Nt(s, o);
}
function ge(s, o, e) {
  e || x("menu-bar-menu-empty", {
    menuBarConfig: s,
    emptyMenuConfig: o
  });
}
function Ws(s, o) {
  var e = o.t,
    t = {
      File: e({
        string: "File",
        id: "MENU_BAR_MENU_FILE"
      }),
      Edit: e({
        string: "Edit",
        id: "MENU_BAR_MENU_EDIT"
      }),
      View: e({
        string: "View",
        id: "MENU_BAR_MENU_VIEW"
      }),
      Insert: e({
        string: "Insert",
        id: "MENU_BAR_MENU_INSERT"
      }),
      Format: e({
        string: "Format",
        id: "MENU_BAR_MENU_FORMAT"
      }),
      Tools: e({
        string: "Tools",
        id: "MENU_BAR_MENU_TOOLS"
      }),
      Help: e({
        string: "Help",
        id: "MENU_BAR_MENU_HELP"
      }),
      Text: e({
        string: "Text",
        id: "MENU_BAR_MENU_TEXT"
      }),
      Font: e({
        string: "Font",
        id: "MENU_BAR_MENU_FONT"
      })
    };
  U(s.items, function (i) {
    i.label in t && (i.label = t[i.label]);
  });
}
function U(s, o) {
  if (Array.isArray(s)) {
    var _iterator44 = _createForOfIteratorHelper(s),
      _step44;
    try {
      for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
        var t = _step44.value;
        e(t);
      }
    } catch (err) {
      _iterator44.e(err);
    } finally {
      _iterator44.f();
    }
  }
  function e(t) {
    o(t);
    var _iterator45 = _createForOfIteratorHelper(t.groups),
      _step45;
    try {
      for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
        var i = _step45.value;
        var _iterator46 = _createForOfIteratorHelper(i.items),
          _step46;
        try {
          for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
            var n = _step46.value;
            Gt(n) && e(n);
          }
        } catch (err) {
          _iterator46.e(err);
        } finally {
          _iterator46.f();
        }
      }
    } catch (err) {
      _iterator45.e(err);
    } finally {
      _iterator45.f();
    }
  }
}
function Gs(s) {
  return _typeof(s) == "object" && "menu" in s;
}
function Rs(s) {
  return _typeof(s) == "object" && "group" in s;
}
function Hs(s) {
  return s.startsWith("start") ? "start" : s.startsWith("end") ? "end" : s.startsWith("after") ? "after" : "before";
}
function zs(s) {
  var o = s.match(/^[^:]+:(.+)/);
  return o ? o[1] : null;
}
function Wt(s) {
  return typeof s == "string" ? s : s.menuId;
}
function Gt(s) {
  return _typeof(s) == "object" && "menuId" in s;
}
var Co = /*#__PURE__*/function (_ce2) {
  function Co(e) {
    var _this117;
    _classCallCheck(this, Co);
    _this117 = _callSuper(this, Co);
    l(_this117, "editor");
    l(_this117, "componentFactory");
    l(_this117, "focusTracker");
    l(_this117, "tooltipManager");
    l(_this117, "poweredBy");
    l(_this117, "evaluationBadge");
    l(_this117, "ariaLiveAnnouncer");
    l(_this117, "isReady", !1);
    l(_this117, "_editableElementsMap", new Map());
    l(_this117, "_focusableToolbarDefinitions", []);
    l(_this117, "_extraMenuBarElements", []);
    l(_this117, "_lastFocusedForeignElement", null);
    l(_this117, "_domEmitter");
    var t = e.editing.view;
    _this117.editor = e, _this117.componentFactory = new _s(e), _this117.focusTracker = new T(), _this117.tooltipManager = new Ce(e), _this117.poweredBy = new xs(e), _this117.evaluationBadge = new Is(e), _this117.ariaLiveAnnouncer = new Ps(e), _this117._initViewportOffset(_this117._readViewportOffsetFromConfig()), _this117.once("ready", function () {
      _this117._bindBodyCollectionWithFocusTracker(), _this117.isReady = !0;
    }), _this117.listenTo(t.document, "layoutChanged", _this117.update.bind(_this117)), _this117.listenTo(t, "scrollToTheSelection", _this117._handleScrollToTheSelection.bind(_this117)), _this117._initFocusTracking(), _this117._initVisualViewportSupport();
    return _this117;
  }
  _inherits(Co, _ce2);
  return _createClass(Co, [{
    key: "element",
    get: function get() {
      return null;
    }
  }, {
    key: "update",
    value: function update() {
      this.fire("update");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor), this.poweredBy.destroy(), this.evaluationBadge.destroy();
      var _iterator47 = _createForOfIteratorHelper(this._editableElementsMap.values()),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var _e20 = _step47.value;
          _e20.ckeditorInstance = null, this.editor.keystrokes.stopListening(_e20);
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
      this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [], this._domEmitter && this._domEmitter.stopListening();
    }
  }, {
    key: "setEditableElement",
    value: function setEditableElement(e, t) {
      var _this118 = this;
      this._editableElementsMap.set(e, t), t.ckeditorInstance || (t.ckeditorInstance = this.editor), this.focusTracker.add(t);
      var i = function i() {
        _this118.editor.editing.view.getDomRoot(e) || _this118.editor.keystrokes.listenTo(t);
      };
      this.isReady ? i() : this.once("ready", i);
    }
  }, {
    key: "removeEditableElement",
    value: function removeEditableElement(e) {
      var t = this._editableElementsMap.get(e);
      t && (this._editableElementsMap.delete(e), this.editor.keystrokes.stopListening(t), this.focusTracker.remove(t), t.ckeditorInstance = null);
    }
  }, {
    key: "getEditableElement",
    value: function getEditableElement() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
      return this._editableElementsMap.get(e);
    }
  }, {
    key: "getEditableElementsNames",
    value: function getEditableElementsNames() {
      return this._editableElementsMap.keys();
    }
  }, {
    key: "addToolbar",
    value: function addToolbar(e) {
      var _this119 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      e.isRendered ? (this.focusTracker.add(e), this.editor.keystrokes.listenTo(e.element)) : e.once("render", function () {
        _this119.focusTracker.add(e), _this119.editor.keystrokes.listenTo(e.element);
      }), this._focusableToolbarDefinitions.push({
        toolbarView: e,
        options: t
      });
    }
  }, {
    key: "extendMenuBar",
    value: function extendMenuBar(e) {
      this._extraMenuBarElements.push(e);
    }
  }, {
    key: "_editableElements",
    get: function get() {
      return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
        editorUI: this
      }), this._editableElementsMap;
    }
  }, {
    key: "initMenuBar",
    value: function initMenuBar(e) {
      var _this120 = this;
      var t = e.element;
      this.focusTracker.add(t), this.editor.keystrokes.listenTo(t);
      var i = Ds(this.editor.config.get("menuBar") || {});
      e.fillFromConfig(i, this.componentFactory, this._extraMenuBarElements), this.editor.keystrokes.set("Esc", function (n, r) {
        t.contains(_this120.editor.ui.focusTracker.focusedElement) && (_this120._lastFocusedForeignElement ? (_this120._lastFocusedForeignElement.focus(), _this120._lastFocusedForeignElement = null) : _this120.editor.editing.view.focus(), r());
      }), this.editor.keystrokes.set("Alt+F9", function (n, r) {
        t.contains(_this120.editor.ui.focusTracker.focusedElement) || (_this120._saveLastFocusedForeignElement(), e.isFocusBorderEnabled = !0, e.focus(), r());
      });
    }
  }, {
    key: "_readViewportOffsetFromConfig",
    value: function _readViewportOffsetFromConfig() {
      var e = this.editor,
        t = e.config.get("ui.viewportOffset");
      if (t) return t;
      var i = e.config.get("toolbar.viewportTopOffset");
      return i ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
        top: i
      }) : {
        top: 0
      };
    }
  }, {
    key: "_initFocusTracking",
    value: function _initFocusTracking() {
      var _this121 = this;
      var e = this.editor;
      var t;
      e.keystrokes.set("Alt+F10", function (i, n) {
        _this121._saveLastFocusedForeignElement();
        var r = _this121._getCurrentFocusedToolbarDefinition();
        (!r || !t) && (t = _this121._getFocusableCandidateToolbarDefinitions());
        for (var a = 0; a < t.length; a++) {
          var u = t.shift();
          if (t.push(u), u !== r && _this121._focusFocusableCandidateToolbar(u)) {
            r && r.options.afterBlur && r.options.afterBlur();
            break;
          }
        }
        n();
      }), e.keystrokes.set("Esc", function (i, n) {
        var r = _this121._getCurrentFocusedToolbarDefinition();
        r && (_this121._lastFocusedForeignElement ? (_this121._lastFocusedForeignElement.focus(), _this121._lastFocusedForeignElement = null) : e.editing.view.focus(), r.options.afterBlur && r.options.afterBlur(), n());
      });
    }
  }, {
    key: "_saveLastFocusedForeignElement",
    value: function _saveLastFocusedForeignElement() {
      var e = this.focusTracker.focusedElement;
      Array.from(this._editableElementsMap.values()).includes(e) && !Array.from(this.editor.editing.view.domRoots.values()).includes(e) && (this._lastFocusedForeignElement = e);
    }
  }, {
    key: "_getFocusableCandidateToolbarDefinitions",
    value: function _getFocusableCandidateToolbarDefinitions() {
      var e = [];
      var _iterator48 = _createForOfIteratorHelper(this._focusableToolbarDefinitions),
        _step48;
      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var t = _step48.value;
          var i = t.toolbarView,
            n = t.options;
          (B(i.element) || n.beforeFocus) && e.push(t);
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
      return e.sort(function (t, i) {
        return ot(t) - ot(i);
      }), e;
    }
  }, {
    key: "_getCurrentFocusedToolbarDefinition",
    value: function _getCurrentFocusedToolbarDefinition() {
      var _iterator49 = _createForOfIteratorHelper(this._focusableToolbarDefinitions),
        _step49;
      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var _e21 = _step49.value;
          if (_e21.toolbarView.element && _e21.toolbarView.element.contains(this.focusTracker.focusedElement)) return _e21;
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
      return null;
    }
  }, {
    key: "_focusFocusableCandidateToolbar",
    value: function _focusFocusableCandidateToolbar(e) {
      var t = e.toolbarView,
        i = e.options.beforeFocus;
      return i && i(), B(t.element) ? (t.focus(), !0) : !1;
    }
  }, {
    key: "_handleScrollToTheSelection",
    value: function _handleScrollToTheSelection(e, t) {
      var i = _objectSpread({
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }, this.viewportOffset);
      t.viewportOffset.top += i.top, t.viewportOffset.bottom += i.bottom, t.viewportOffset.left += i.left, t.viewportOffset.right += i.right;
    }
  }, {
    key: "_bindBodyCollectionWithFocusTracker",
    value: function _bindBodyCollectionWithFocusTracker() {
      var _this122 = this;
      var e = this.view.body;
      var _iterator50 = _createForOfIteratorHelper(e),
        _step50;
      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var t = _step50.value;
          this.focusTracker.add(t.element);
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
      e.on("add", function (t, i) {
        _this122.focusTracker.add(i.element);
      }), e.on("remove", function (t, i) {
        _this122.focusTracker.remove(i.element);
      });
    }
  }, {
    key: "_initViewportOffset",
    value: function _initViewportOffset(e) {
      var _this123 = this;
      this.on("set:viewportOffset", function (t, i, n) {
        var r = _this123._getVisualViewportTopOffset(n);
        n.visualTop !== r && (t.return = _objectSpread(_objectSpread({}, n), {}, {
          visualTop: r
        }));
      }), this.set("viewportOffset", e);
    }
  }, {
    key: "_initVisualViewportSupport",
    value: function _initVisualViewportSupport() {
      var _this124 = this;
      if (!f.window.visualViewport) return;
      var e = function e() {
        var t = _this124._getVisualViewportTopOffset(_this124.viewportOffset);
        _this124.viewportOffset.visualTop !== t && (_this124.viewportOffset = _objectSpread(_objectSpread({}, _this124.viewportOffset), {}, {
          visualTop: t
        }));
      };
      this._domEmitter = new (ae())(), this._domEmitter.listenTo(f.window.visualViewport, "scroll", e), this._domEmitter.listenTo(f.window.visualViewport, "resize", e);
    }
  }, {
    key: "_getVisualViewportTopOffset",
    value: function _getVisualViewportTopOffset(e) {
      var t = Y().top,
        i = e.top || 0;
      return t > i ? 0 : i - t;
    }
  }]);
}(ce());
function ot(s) {
  var o = s.toolbarView,
    e = s.options;
  var t = 10;
  return B(o.element) && t--, e.isContextual && (t -= 2), t;
}
var Us = /*#__PURE__*/function (_d36) {
  function Us(e) {
    var _this125;
    _classCallCheck(this, Us);
    _this125 = _callSuper(this, Us, [e]);
    l(_this125, "body");
    l(_this125, "menuBarView");
    l(_this125, "toolbar");
    _this125.body = new ve(e);
    return _this125;
  }
  _inherits(Us, _d36);
  return _createClass(Us, [{
    key: "render",
    value: function render() {
      _superPropGet(Us, "render", this, 3)([]), this.body.attachToDom();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.body.detachFromDom(), _superPropGet(Us, "destroy", this, 3)([]);
    }
  }]);
}(d);
var Vo = /*#__PURE__*/function (_Us) {
  function Vo(e) {
    var _this126;
    _classCallCheck(this, Vo);
    _this126 = _callSuper(this, Vo, [e]);
    l(_this126, "top");
    l(_this126, "main");
    l(_this126, "_voiceLabelView");
    _this126.top = _this126.createCollection(), _this126.main = _this126.createCollection(), _this126._voiceLabelView = _this126._createVoiceLabel(), _this126.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
        role: "application",
        dir: e.uiLanguageDirection,
        lang: e.uiLanguage,
        "aria-labelledby": _this126._voiceLabelView.id
      },
      children: [_this126._voiceLabelView, {
        tag: "div",
        attributes: {
          class: ["ck", "ck-editor__top", "ck-reset_all"],
          role: "presentation"
        },
        children: _this126.top
      }, {
        tag: "div",
        attributes: {
          class: ["ck", "ck-editor__main"],
          role: "presentation"
        },
        children: _this126.main
      }]
    });
    return _this126;
  }
  _inherits(Vo, _Us);
  return _createClass(Vo, [{
    key: "_createVoiceLabel",
    value: function _createVoiceLabel() {
      var e = this.t,
        t = new de();
      return t.text = e("Rich Text Editor"), t.extendTemplate({
        attributes: {
          class: "ck-voice-label"
        }
      }), t;
    }
  }]);
}(Us);
var $s = /*#__PURE__*/function (_d37) {
  function $s(e, t, i) {
    var _this127;
    _classCallCheck(this, $s);
    _this127 = _callSuper(this, $s, [e]);
    l(_this127, "name", null);
    l(_this127, "_editingView");
    l(_this127, "_editableElement");
    l(_this127, "_hasExternalElement");
    _this127.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
        lang: e.contentLanguage,
        dir: e.contentLanguageDirection
      }
    }), _this127.set("isFocused", !1), _this127._editableElement = i, _this127._hasExternalElement = !!_this127._editableElement, _this127._editingView = t;
    return _this127;
  }
  _inherits($s, _d37);
  return _createClass($s, [{
    key: "render",
    value: function render() {
      var _this128 = this;
      _superPropGet($s, "render", this, 3)([]), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
        return _this128._updateIsFocusedClasses();
      }), this._updateIsFocusedClasses();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._hasExternalElement && this.template.revert(this._editableElement), _superPropGet($s, "destroy", this, 3)([]);
    }
  }, {
    key: "hasExternalElement",
    get: function get() {
      return this._hasExternalElement;
    }
  }, {
    key: "_updateIsFocusedClasses",
    value: function _updateIsFocusedClasses() {
      var e = this._editingView;
      e.isRenderingInProgress ? i(this) : t(this);
      function t(n) {
        e.change(function (r) {
          var a = e.document.getRoot(n.name);
          r.addClass(n.isFocused ? "ck-focused" : "ck-blurred", a), r.removeClass(n.isFocused ? "ck-blurred" : "ck-focused", a);
        });
      }
      function i(n) {
        e.once("change:isRenderingInProgress", function (r, a, u) {
          u ? i(n) : t(n);
        });
      }
    }
  }]);
}(d);
var xo = /*#__PURE__*/function (_$s) {
  function xo(e, t, i) {
    var _this129;
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, xo);
    _this129 = _callSuper(this, xo, [e, t, i]);
    l(_this129, "_options");
    _this129._options = n, _this129.extendTemplate({
      attributes: {
        role: "textbox",
        class: "ck-editor__editable_inline"
      }
    });
    return _this129;
  }
  _inherits(xo, _$s);
  return _createClass(xo, [{
    key: "render",
    value: function render() {
      var _this130 = this;
      _superPropGet(xo, "render", this, 3)([]);
      var e = this._editingView;
      e.change(function (t) {
        var i = e.document.getRoot(_this130.name);
        t.setAttribute("aria-label", _this130.getEditableAriaLabel(), i);
      });
    }
  }, {
    key: "getEditableAriaLabel",
    value: function getEditableAriaLabel() {
      var e = this.locale.t,
        t = this._options.label,
        i = this._editableElement,
        n = this.name;
      if (typeof t == "string") return t;
      if (_typeof(t) == "object") return t[n];
      if (typeof t == "function") return t(this);
      if (i) {
        var r = i.getAttribute("aria-label");
        if (r) return r;
      }
      return e("Rich Text Editor. Editing area: %0", n);
    }
  }]);
}($s);
var Eo = /*#__PURE__*/function (_d38) {
  function Eo(e) {
    var _this131;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Eo);
    _this131 = _callSuper(this, Eo, [e]);
    l(_this131, "children");
    var i = _this131.bindTemplate;
    _this131.set("class", ["ck", "ck-form__row"].concat(_toConsumableArray(he(t.class || [])))), _this131.children = _this131.createCollection(), t.children && t.children.forEach(function (n) {
      return _this131.children.add(n);
    }), _this131.set("_role", null), _this131.set("_ariaLabelledBy", null), t.labelView && _this131.set({
      _role: "group",
      _ariaLabelledBy: t.labelView.id
    }), _this131.setTemplate({
      tag: "div",
      attributes: {
        class: i.to("class", function (n) {
          return n.join(" ");
        }),
        role: i.to("_role"),
        "aria-labelledby": i.to("_ariaLabelledBy")
      },
      children: _this131.children
    });
    return _this131;
  }
  _inherits(Eo, _d38);
  return _createClass(Eo);
}(d);
var Io = /*#__PURE__*/function (_Xt) {
  function Io() {
    _classCallCheck(this, Io);
    return _callSuper(this, Io, arguments);
  }
  _inherits(Io, _Xt);
  return _createClass(Io, [{
    key: "init",
    value: function init() {
      this.on("show:warning", function (o, e) {
        window.alert(e.message);
      }, {
        priority: "lowest"
      });
    }
  }, {
    key: "showSuccess",
    value: function showSuccess(o) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this._showNotification({
        message: o,
        type: "success",
        namespace: e.namespace,
        title: e.title
      });
    }
  }, {
    key: "showInfo",
    value: function showInfo(o) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this._showNotification({
        message: o,
        type: "info",
        namespace: e.namespace,
        title: e.title
      });
    }
  }, {
    key: "showWarning",
    value: function showWarning(o) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this._showNotification({
        message: o,
        type: "warning",
        namespace: e.namespace,
        title: e.title
      });
    }
  }, {
    key: "_showNotification",
    value: function _showNotification(o) {
      var e = o.namespace ? "show:".concat(o.type, ":").concat(o.namespace) : "show:".concat(o.type);
      this.fire(e, {
        message: o.message,
        type: o.type,
        title: o.title || ""
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Notification";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(Xt);
var Oo = /*#__PURE__*/function (_ce3) {
  function Oo(o, e) {
    var _this132;
    _classCallCheck(this, Oo);
    _this132 = _callSuper(this, Oo), e && hi(_assertThisInitialized(_this132), e), o && _this132.set(o);
    return _this132;
  }
  _inherits(Oo, _ce3);
  return _createClass(Oo);
}(ce());
var q = le("px");
var Po = /*#__PURE__*/function (_Ee3) {
  function Po(e) {
    var _this133;
    _classCallCheck(this, Po);
    _this133 = _callSuper(this, Po, [e]);
    l(_this133, "positionLimiter");
    l(_this133, "visibleStack");
    l(_this133, "_viewToStack", new Map());
    l(_this133, "_idToStack", new Map());
    l(_this133, "_view", null);
    l(_this133, "_rotatorView", null);
    l(_this133, "_fakePanelsView", null);
    _this133.positionLimiter = function () {
      var t = _this133.editor.editing.view,
        n = t.document.selection.editableElement;
      return n ? t.domConverter.mapViewToDom(n.root) : null;
    }, _this133.decorate("getPositionOptions"), _this133.set("visibleView", null), _this133.set("_numberOfStacks", 0), _this133.set("_singleViewMode", !1);
    return _this133;
  }
  _inherits(Po, _Ee3);
  return _createClass(Po, [{
    key: "destroy",
    value: function destroy() {
      _superPropGet(Po, "destroy", this, 3)([]), this._view && this._view.destroy(), this._rotatorView && this._rotatorView.destroy(), this._fakePanelsView && this._fakePanelsView.destroy();
    }
  }, {
    key: "view",
    get: function get() {
      return this._view || this._createPanelView(), this._view;
    }
  }, {
    key: "hasView",
    value: function hasView(e) {
      return Array.from(this._viewToStack.keys()).includes(e);
    }
  }, {
    key: "add",
    value: function add(e) {
      if (this._view || this._createPanelView(), this.hasView(e.view)) throw new V("contextualballoon-add-view-exist", [this, e]);
      var t = e.stackId || "main";
      if (!this._idToStack.has(t)) {
        this._idToStack.set(t, new Map([[e.view, e]])), this._viewToStack.set(e.view, this._idToStack.get(t)), this._numberOfStacks = this._idToStack.size, (!this._visibleStack || e.singleViewMode) && this.showStack(t);
        return;
      }
      var i = this._idToStack.get(t);
      e.singleViewMode && this.showStack(t), i.set(e.view, e), this._viewToStack.set(e.view, i), i === this._visibleStack && this._showView(e);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      if (!this.hasView(e)) throw new V("contextualballoon-remove-view-not-exist", [this, e]);
      var t = this._viewToStack.get(e);
      this._singleViewMode && this.visibleView === e && (this._singleViewMode = !1), this.visibleView === e && (t.size === 1 ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(t.values())[t.size - 2])), t.size === 1 ? (this._idToStack.delete(this._getStackId(t)), this._numberOfStacks = this._idToStack.size) : t.delete(e), this._viewToStack.delete(e);
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(e) {
      e && (this._visibleStack.get(this.visibleView).position = e), this.view.pin(this.getPositionOptions()), this._fakePanelsView.updatePosition();
    }
  }, {
    key: "getPositionOptions",
    value: function getPositionOptions() {
      var e = Array.from(this._visibleStack.values()).pop().position;
      return e && (e.limiter || (e = Object.assign({}, e, {
        limiter: this.positionLimiter
      })), e = Object.assign({}, e, {
        viewportOffsetConfig: _objectSpread(_objectSpread({}, this.editor.ui.viewportOffset), {}, {
          top: this.editor.ui.viewportOffset.visualTop
        })
      })), e;
    }
  }, {
    key: "showStack",
    value: function showStack(e) {
      this.visibleStack = e;
      var t = this._idToStack.get(e);
      if (!t) throw new V("contextualballoon-showstack-stack-not-exist", this);
      this._visibleStack !== t && this._showView(Array.from(t.values()).pop());
    }
  }, {
    key: "_createPanelView",
    value: function _createPanelView() {
      this._view = new R(this.editor.locale), this.editor.ui.view.body.add(this._view), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
    }
  }, {
    key: "_visibleStack",
    get: function get() {
      return this._viewToStack.get(this.visibleView);
    }
  }, {
    key: "_getStackId",
    value: function _getStackId(e) {
      return Array.from(this._idToStack.entries()).find(function (i) {
        return i[1] === e;
      })[0];
    }
  }, {
    key: "_showNextStack",
    value: function _showNextStack() {
      var e = Array.from(this._idToStack.values());
      var t = e.indexOf(this._visibleStack) + 1;
      e[t] || (t = 0), this.showStack(this._getStackId(e[t]));
    }
  }, {
    key: "_showPrevStack",
    value: function _showPrevStack() {
      var e = Array.from(this._idToStack.values());
      var t = e.indexOf(this._visibleStack) - 1;
      e[t] || (t = e.length - 1), this.showStack(this._getStackId(e[t]));
    }
  }, {
    key: "_createRotatorView",
    value: function _createRotatorView() {
      var _this134 = this;
      var e = new Ks(this.editor.locale),
        t = this.editor.locale.t;
      return this.view.content.add(e), e.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (i, n) {
        return !n && i > 1;
      }), e.on("change:isNavigationVisible", function () {
        return _this134.updatePosition();
      }, {
        priority: "low"
      }), e.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (i, n) {
        if (n < 2) return "";
        var r = Array.from(_this134._idToStack.values()).indexOf(_this134._visibleStack) + 1;
        return t("%0 of %1", [r, n]);
      }), e.buttonNextView.on("execute", function () {
        e.focusTracker.isFocused && _this134.editor.editing.view.focus(), _this134._showNextStack();
      }), e.buttonPrevView.on("execute", function () {
        e.focusTracker.isFocused && _this134.editor.editing.view.focus(), _this134._showPrevStack();
      }), e;
    }
  }, {
    key: "_createFakePanelsView",
    value: function _createFakePanelsView() {
      var e = new js(this.editor.locale, this.view);
      return e.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, i) {
        return !i && t >= 2 ? Math.min(t - 1, 2) : 0;
      }), e.listenTo(this.view, "change:top", function () {
        return e.updatePosition();
      }), e.listenTo(this.view, "change:left", function () {
        return e.updatePosition();
      }), this.editor.ui.view.body.add(e), e;
    }
  }, {
    key: "_showView",
    value: function _showView(_ref24) {
      var e = _ref24.view,
        _ref24$balloonClassNa = _ref24.balloonClassName,
        t = _ref24$balloonClassNa === void 0 ? "" : _ref24$balloonClassNa,
        _ref24$withArrow = _ref24.withArrow,
        i = _ref24$withArrow === void 0 ? !0 : _ref24$withArrow,
        _ref24$singleViewMode = _ref24.singleViewMode,
        n = _ref24$singleViewMode === void 0 ? !1 : _ref24$singleViewMode;
      this.view.class = t, this.view.withArrow = i, this._rotatorView.showView(e), this.visibleView = e, this.view.pin(this.getPositionOptions()), this._fakePanelsView.updatePosition(), n && (this._singleViewMode = !0);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ContextualBalloon";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(Ee);
var Ks = /*#__PURE__*/function (_d39) {
  function Ks(e) {
    var _this135;
    _classCallCheck(this, Ks);
    _this135 = _callSuper(this, Ks, [e]);
    l(_this135, "focusTracker");
    l(_this135, "buttonPrevView");
    l(_this135, "buttonNextView");
    l(_this135, "content");
    var t = e.t,
      i = _this135.bindTemplate;
    _this135.set("isNavigationVisible", !0), _this135.focusTracker = new T(), _this135.buttonPrevView = _this135._createButtonView(t("Previous"), si), _this135.buttonNextView = _this135._createButtonView(t("Next"), oi), _this135.content = _this135.createCollection(), _this135.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-balloon-rotator"],
        "z-index": "-1"
      },
      children: [{
        tag: "div",
        attributes: {
          class: ["ck-balloon-rotator__navigation", i.to("isNavigationVisible", function (n) {
            return n ? "" : "ck-hidden";
          })]
        },
        children: [_this135.buttonPrevView, {
          tag: "span",
          attributes: {
            class: ["ck-balloon-rotator__counter"]
          },
          children: [{
            text: i.to("counter")
          }]
        }, _this135.buttonNextView]
      }, {
        tag: "div",
        attributes: {
          class: "ck-balloon-rotator__content"
        },
        children: _this135.content
      }]
    });
    return _this135;
  }
  _inherits(Ks, _d39);
  return _createClass(Ks, [{
    key: "render",
    value: function render() {
      _superPropGet(Ks, "render", this, 3)([]), this.focusTracker.add(this.element);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Ks, "destroy", this, 3)([]), this.focusTracker.destroy();
    }
  }, {
    key: "showView",
    value: function showView(e) {
      this.hideView(), this.content.add(e);
    }
  }, {
    key: "hideView",
    value: function hideView() {
      this.content.clear();
    }
  }, {
    key: "_createButtonView",
    value: function _createButtonView(e, t) {
      var i = new w(this.locale);
      return i.set({
        label: e,
        icon: t,
        tooltip: !0
      }), i;
    }
  }]);
}(d);
var js = /*#__PURE__*/function (_d40) {
  function js(e, t) {
    var _this136;
    _classCallCheck(this, js);
    _this136 = _callSuper(this, js, [e]);
    l(_this136, "content");
    l(_this136, "_balloonPanelView");
    var i = _this136.bindTemplate;
    _this136.set("top", 0), _this136.set("left", 0), _this136.set("height", 0), _this136.set("width", 0), _this136.set("numberOfPanels", 0), _this136.content = _this136.createCollection(), _this136._balloonPanelView = t, _this136.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck-fake-panel", i.to("numberOfPanels", function (n) {
          return n ? "" : "ck-hidden";
        })],
        style: {
          top: i.to("top", q),
          left: i.to("left", q),
          width: i.to("width", q),
          height: i.to("height", q)
        }
      },
      children: _this136.content
    }), _this136.on("change:numberOfPanels", function (n, r, a, u) {
      a > u ? _this136._addPanels(a - u) : _this136._removePanels(u - a), _this136.updatePosition();
    });
    return _this136;
  }
  _inherits(js, _d40);
  return _createClass(js, [{
    key: "_addPanels",
    value: function _addPanels(e) {
      for (; e--;) {
        var t = new d();
        t.setTemplate({
          tag: "div"
        }), this.content.add(t), this.registerChild(t);
      }
    }
  }, {
    key: "_removePanels",
    value: function _removePanels(e) {
      for (; e--;) {
        var t = this.content.last;
        this.content.remove(t), this.deregisterChild(t), t.destroy();
      }
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.numberOfPanels) {
        var _this$_balloonPanelVi = this._balloonPanelView,
          _e22 = _this$_balloonPanelVi.top,
          t = _this$_balloonPanelVi.left,
          _C = new C(this._balloonPanelView.element),
          i = _C.width,
          n = _C.height;
        Object.assign(this, {
          top: _e22,
          left: t,
          width: i,
          height: n
        });
      }
    }
  }]);
}(d);
var N = le("px");
var Bo = /*#__PURE__*/function (_d41) {
  function Bo(e) {
    var _this137;
    _classCallCheck(this, Bo);
    _this137 = _callSuper(this, Bo, [e]);
    l(_this137, "content");
    l(_this137, "contentPanelElement");
    l(_this137, "_contentPanelPlaceholder");
    var t = _this137.bindTemplate;
    _this137.set("isActive", !1), _this137.set("isSticky", !1), _this137.set("limiterElement", null), _this137.set("limiterBottomOffset", 50), _this137.set("viewportTopOffset", 0), _this137.set("_marginLeft", null), _this137.set("_isStickyToTheBottomOfLimiter", !1), _this137.set("_stickyTopOffset", null), _this137.set("_stickyBottomOffset", null), _this137.content = _this137.createCollection(), _this137._contentPanelPlaceholder = new E({
      tag: "div",
      attributes: {
        class: ["ck", "ck-sticky-panel__placeholder"],
        style: {
          display: t.to("isSticky", function (i) {
            return i ? "block" : "none";
          }),
          height: t.to("isSticky", function (i) {
            return i ? N(_this137._contentPanelRect.height) : null;
          })
        }
      }
    }).render(), _this137.contentPanelElement = new E({
      tag: "div",
      attributes: {
        class: ["ck", "ck-sticky-panel__content", t.if("isSticky", "ck-sticky-panel__content_sticky"), t.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
        style: {
          width: t.to("isSticky", function (i) {
            return i ? N(_this137._contentPanelPlaceholder.getBoundingClientRect().width) : null;
          }),
          top: t.to("_stickyTopOffset", function (i) {
            return i && N(i);
          }),
          bottom: t.to("_stickyBottomOffset", function (i) {
            return i && N(i);
          }),
          marginLeft: t.to("_marginLeft")
        }
      },
      children: _this137.content
    }).render(), _this137.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-sticky-panel"]
      },
      children: [_this137._contentPanelPlaceholder, _this137.contentPanelElement]
    });
    return _this137;
  }
  _inherits(Bo, _d41);
  return _createClass(Bo, [{
    key: "render",
    value: function render() {
      var _this138 = this;
      _superPropGet(Bo, "render", this, 3)([]), this.checkIfShouldBeSticky(), this.listenTo(f.document, "scroll", function () {
        _this138.checkIfShouldBeSticky();
      }, {
        useCapture: !0
      }), this.listenTo(this, "change:isActive", function () {
        _this138.checkIfShouldBeSticky();
      }), f.window.visualViewport && (this.listenTo(f.window.visualViewport, "scroll", function () {
        _this138.checkIfShouldBeSticky();
      }), this.listenTo(f.window.visualViewport, "resize", function () {
        _this138.checkIfShouldBeSticky();
      }));
    }
  }, {
    key: "checkIfShouldBeSticky",
    value: function checkIfShouldBeSticky() {
      if (!this.limiterElement || !this.isActive) {
        this._unstick();
        return;
      }
      var e = new C(this.limiterElement);
      var t = e.getVisible();
      if (t) {
        var r = new C(f.window);
        r.top += this.viewportTopOffset, r.height -= this.viewportTopOffset, t = t.getIntersection(r);
      }
      var _Y = Y(),
        i = _Y.left,
        n = _Y.top;
      if (e.moveBy(i, n), t && t.moveBy(i, n), t && e.top < t.top) {
        if (this._contentPanelRect.height + this.limiterBottomOffset > t.height) {
          var _r3 = Math.max(e.bottom - t.bottom, 0) + this.limiterBottomOffset;
          this._contentPanelRect.height + _r3 + 1 < e.height ? this._stickToBottomOfLimiter(_r3) : this._unstick();
        } else this._contentPanelRect.height + this.limiterBottomOffset < e.height ? this._stickToTopOfAncestors(t.top) : this._unstick();
      } else this._unstick();
    }
  }, {
    key: "_stickToTopOfAncestors",
    value: function _stickToTopOfAncestors(e) {
      this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = e, this._stickyBottomOffset = null, this._marginLeft = N(-f.window.scrollX + Y().left);
    }
  }, {
    key: "_stickToBottomOfLimiter",
    value: function _stickToBottomOfLimiter(e) {
      this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !0, this._stickyTopOffset = null, this._stickyBottomOffset = e, this._marginLeft = N(-f.window.scrollX + Y().left);
    }
  }, {
    key: "_unstick",
    value: function _unstick() {
      this.isSticky = !1, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = null, this._stickyBottomOffset = null, this._marginLeft = null;
    }
  }, {
    key: "_contentPanelRect",
    get: function get() {
      return new C(this.contentPanelElement);
    }
  }]);
}(d);
var Xs = /*#__PURE__*/function (_z2) {
  function Xs(e) {
    var _this139;
    _classCallCheck(this, Xs);
    _this139 = _callSuper(this, Xs, [e]);
    l(_this139, "arrowView");
    var t = _this139.bindTemplate;
    _this139.set({
      withText: !0,
      role: "menuitem"
    }), _this139.arrowView = _this139._createArrowView(), _this139.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__button"],
        "aria-haspopup": !0,
        "aria-expanded": _this139.bindTemplate.to("isOn", function (i) {
          return String(i);
        }),
        "data-cke-tooltip-disabled": t.to("isOn")
      },
      on: {
        mouseenter: t.to("mouseenter")
      }
    });
    return _this139;
  }
  _inherits(Xs, _z2);
  return _createClass(Xs, [{
    key: "render",
    value: function render() {
      _superPropGet(Xs, "render", this, 3)([]), this.children.add(this.arrowView);
    }
  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var e = new L();
      return e.content = ue, e.extendTemplate({
        attributes: {
          class: "ck-menu-bar__menu__button__arrow"
        }
      }), e;
    }
  }]);
}(z);
var qs = /*#__PURE__*/function (_d42) {
  function qs(e) {
    var _this140;
    _classCallCheck(this, qs);
    _this140 = _callSuper(this, qs, [e]);
    l(_this140, "children");
    var t = _this140.bindTemplate;
    _this140.set("isVisible", !1), _this140.set("position", "se"), _this140.children = _this140.createCollection(), _this140.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-reset", "ck-menu-bar__menu__panel", t.to("position", function (i) {
          return "ck-menu-bar__menu__panel_position_".concat(i);
        }), t.if("isVisible", "ck-hidden", function (i) {
          return !i;
        })],
        tabindex: "-1"
      },
      children: _this140.children,
      on: {
        selectstart: t.to(function (i) {
          i.target.tagName.toLocaleLowerCase() !== "input" && i.preventDefault();
        })
      }
    });
    return _this140;
  }
  _inherits(qs, _d42);
  return _createClass(qs, [{
    key: "focus",
    value: function focus() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.children.length && (e === 1 ? this.children.first.focus() : this.children.last.focus());
    }
  }]);
}(d);
var re = /*#__PURE__*/function (_d43) {
  function re(e) {
    var _this141;
    _classCallCheck(this, re);
    _this141 = _callSuper(this, re, [e]);
    l(_this141, "buttonView");
    l(_this141, "panelView");
    l(_this141, "focusTracker");
    l(_this141, "keystrokes");
    var t = _this141.bindTemplate;
    _this141.buttonView = new Xs(e), _this141.buttonView.delegate("mouseenter").to(_this141), _this141.buttonView.bind("isOn", "isEnabled").to(_this141, "isOpen", "isEnabled"), _this141.panelView = new qs(e), _this141.panelView.bind("isVisible").to(_this141, "isOpen"), _this141.keystrokes = new O(), _this141.focusTracker = new T(), _this141.set("isOpen", !1), _this141.set("isEnabled", !0), _this141.set("panelPosition", "w"), _this141.set("class", void 0), _this141.set("parentMenuView", null), _this141.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-menu-bar__menu", t.to("class"), t.if("isEnabled", "ck-disabled", function (i) {
          return !i;
        }), t.if("parentMenuView", "ck-menu-bar__menu_top-level", function (i) {
          return !i;
        })]
      },
      children: [_this141.buttonView, _this141.panelView]
    });
    return _this141;
  }
  _inherits(re, _d43);
  return _createClass(re, [{
    key: "render",
    value: function render() {
      _superPropGet(re, "render", this, 3)([]), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.keystrokes.listenTo(this.element), P.closeOnEscKey(this), this._repositionPanelOnOpen();
    }
  }, {
    key: "_attachBehaviors",
    value: function _attachBehaviors() {
      this.parentMenuView ? (P.openOnButtonClick(this), P.openOnArrowRightKey(this), P.closeOnArrowLeftKey(this), P.openAndFocusOnEnterKeyPress(this), P.closeOnParentClose(this)) : (this._propagateArrowKeystrokeEvents(), P.openAndFocusPanelOnArrowDownKey(this), P.toggleOnButtonClick(this));
    }
  }, {
    key: "_propagateArrowKeystrokeEvents",
    value: function _propagateArrowKeystrokeEvents() {
      var _this142 = this;
      this.keystrokes.set("arrowright", function (e, t) {
        _this142.fire("arrowright"), t();
      }), this.keystrokes.set("arrowleft", function (e, t) {
        _this142.fire("arrowleft"), t();
      });
    }
  }, {
    key: "_repositionPanelOnOpen",
    value: function _repositionPanelOnOpen() {
      var _this143 = this;
      this.on("change:isOpen", function (e, t, i) {
        if (!i) return;
        var n = re._getOptimalPosition({
          element: _this143.panelView.element,
          target: _this143.buttonView.element,
          fitInViewport: !0,
          positions: _this143._panelPositions
        });
        _this143.panelView.position = n ? n.name : _this143._defaultMenuPositionName;
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      this.buttonView.focus();
    }
  }, {
    key: "_panelPositions",
    get: function get() {
      var e = Fs.southEast,
        t = Fs.southWest,
        i = Fs.northEast,
        n = Fs.northWest,
        r = Fs.westSouth,
        a = Fs.eastSouth,
        u = Fs.westNorth,
        c = Fs.eastNorth;
      return this.locale.uiLanguageDirection === "ltr" ? this.parentMenuView ? [a, c, r, u] : [e, t, i, n] : this.parentMenuView ? [r, u, a, c] : [t, e, n, i];
    }
  }, {
    key: "_defaultMenuPositionName",
    get: function get() {
      return this.locale.uiLanguageDirection === "ltr" ? this.parentMenuView ? "es" : "se" : this.parentMenuView ? "ws" : "sw";
    }
  }]);
}(d);
l(re, "_getOptimalPosition", xe);
var $ = re;
var nt = /*#__PURE__*/function (_Ae) {
  function nt(o) {
    var _this144;
    _classCallCheck(this, nt);
    _this144 = _callSuper(this, nt, [o]), _this144.role = "menu", _this144.items.on("change", _this144._setItemsCheckSpace.bind(_assertThisInitialized(_this144)));
    return _this144;
  }
  _inherits(nt, _Ae);
  return _createClass(nt, [{
    key: "_setItemsCheckSpace",
    value: function _setItemsCheckSpace() {
      var o = Array.from(this.items).some(function (e) {
        var t = rt(e);
        return t && t.isToggleable;
      });
      this.items.forEach(function (e) {
        var t = rt(e);
        t && (t.hasCheckSpace = o);
      });
    }
  }]);
}(Ae);
function rt(s) {
  return s instanceof F ? s.children.map(function (o) {
    return Ys(o) ? o.buttonView : o;
  }).find(function (o) {
    return o instanceof z;
  }) : null;
}
function Ys(s) {
  return _typeof(s) == "object" && "buttonView" in s && s.buttonView instanceof w;
}
var Qs = /*#__PURE__*/function (_Ai) {
  function Qs(o) {
    var _this145;
    _classCallCheck(this, Qs);
    _this145 = _callSuper(this, Qs, [o]), _this145.set({
      withText: !0,
      withKeystroke: !0,
      tooltip: !1,
      role: "menuitem"
    }), _this145.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__item__button"]
      }
    });
    return _this145;
  }
  _inherits(Qs, _Ai);
  return _createClass(Qs);
}(Ai);
var lt = ["mouseenter", "arrowleft", "arrowright", "change:isOpen"];
var Lo = /*#__PURE__*/function (_d44) {
  function Lo(e) {
    var _this146;
    _classCallCheck(this, Lo);
    _this146 = _callSuper(this, Lo, [e]);
    l(_this146, "children");
    l(_this146, "menus", []);
    var t = e.t,
      i = _this146.bindTemplate;
    _this146.set({
      isOpen: !1,
      isFocusBorderEnabled: !1
    }), _this146._setupIsOpenUpdater(), _this146.children = _this146.createCollection(), _this146.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-menu-bar", i.if("isFocusBorderEnabled", "ck-menu-bar_focus-border-enabled")],
        "aria-label": t("Editor menu bar"),
        role: "menubar"
      },
      children: _this146.children
    });
    return _this146;
  }
  _inherits(Lo, _d44);
  return _createClass(Lo, [{
    key: "fillFromConfig",
    value: function fillFromConfig(e, t) {
      var _this147 = this;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var n = this.locale,
        a = Ss({
          normalizedConfig: e,
          locale: n,
          componentFactory: t,
          extraItems: i
        }).items.map(function (u) {
          return _this147._createMenu({
            componentFactory: t,
            menuDefinition: u
          });
        });
      this.children.addMany(a);
    }
  }, {
    key: "render",
    value: function render() {
      _superPropGet(Lo, "render", this, 3)([]), M.toggleMenusAndFocusItemsOnHover(this), M.closeMenusWhenTheBarCloses(this), M.closeMenuWhenAnotherOnTheSameLevelOpens(this), M.focusCycleMenusOnArrows(this), M.closeOnClickOutside(this), M.enableFocusHighlightOnInteraction(this);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.children.first && this.children.first.focus();
    }
  }, {
    key: "close",
    value: function close() {
      var _iterator51 = _createForOfIteratorHelper(this.children),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var _e23 = _step51.value;
          _e23.isOpen = !1;
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      var _iterator52 = _createForOfIteratorHelper(this.children),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var _e24 = _step52.value;
          _e24.isEnabled = !1;
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
    }
  }, {
    key: "enable",
    value: function enable() {
      var _iterator53 = _createForOfIteratorHelper(this.children),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _e25 = _step53.value;
          _e25.isEnabled = !0;
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }
  }, {
    key: "registerMenu",
    value: function registerMenu(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      t ? (e.delegate.apply(e, lt).to(t), e.parentMenuView = t) : e.delegate.apply(e, lt).to(this, function (i) {
        return "menu:" + i;
      }), e._attachBehaviors(), this.menus.push(e);
    }
  }, {
    key: "_createMenu",
    value: function _createMenu(_ref25) {
      var _this148 = this;
      var e = _ref25.componentFactory,
        t = _ref25.menuDefinition,
        i = _ref25.parentMenuView;
      var n = this.locale,
        r = new $(n);
      return this.registerMenu(r, i), r.buttonView.set({
        label: t.label
      }), r.once("change:isOpen", function () {
        var a = new nt(n);
        a.ariaLabel = t.label, r.panelView.children.add(a), a.items.addMany(_this148._createMenuItems({
          menuDefinition: t,
          parentMenuView: r,
          componentFactory: e
        }));
      }), r;
    }
  }, {
    key: "_createMenuItems",
    value: function _createMenuItems(_ref26) {
      var e = _ref26.menuDefinition,
        t = _ref26.parentMenuView,
        i = _ref26.componentFactory;
      var n = this.locale,
        r = [];
      var _iterator54 = _createForOfIteratorHelper(e.groups),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var a = _step54.value;
          var _iterator55 = _createForOfIteratorHelper(a.items),
            _step55;
          try {
            for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
              var u = _step55.value;
              var c = new Mt(n, t);
              if (ie(u)) c.children.add(this._createMenu({
                componentFactory: i,
                menuDefinition: u,
                parentMenuView: t
              }));else {
                var h = this._createMenuItemContentFromFactory({
                  componentName: u,
                  componentFactory: i,
                  parentMenuView: t
                });
                if (!h) continue;
                c.children.add(h);
              }
              r.push(c);
            }
          } catch (err) {
            _iterator55.e(err);
          } finally {
            _iterator55.f();
          }
          a !== e.groups[e.groups.length - 1] && r.push(new Fe(n));
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      return r;
    }
  }, {
    key: "_createMenuItemContentFromFactory",
    value: function _createMenuItemContentFromFactory(_ref27) {
      var _this149 = this;
      var e = _ref27.componentName,
        t = _ref27.parentMenuView,
        i = _ref27.componentFactory;
      var n = i.create(e);
      return n instanceof $ || n instanceof vt || n instanceof Qs ? (this._registerMenuTree(n, t), n.on("execute", function () {
        _this149.close();
      }), n) : (x("menu-bar-component-unsupported", {
        componentName: e,
        componentView: n
      }), null);
    }
  }, {
    key: "_registerMenuTree",
    value: function _registerMenuTree(e, t) {
      if (!(e instanceof $)) {
        e.delegate("mouseenter").to(t);
        return;
      }
      this.registerMenu(e, t);
      var i = e.panelView.children.filter(function (r) {
        return r instanceof nt;
      })[0];
      if (!i) {
        e.delegate("mouseenter").to(t);
        return;
      }
      var n = i.items.filter(function (r) {
        return r instanceof F;
      });
      var _iterator56 = _createForOfIteratorHelper(n),
        _step56;
      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var r = _step56.value;
          this._registerMenuTree(r.children.get(0), e);
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
    }
  }, {
    key: "_setupIsOpenUpdater",
    value: function _setupIsOpenUpdater() {
      var _this150 = this;
      var e;
      this.on("menu:change:isOpen", function (t, i, n) {
        clearTimeout(e), n ? _this150.isOpen = !0 : e = setTimeout(function () {
          _this150.isOpen = Array.from(_this150.children).some(function (r) {
            return r.isOpen;
          });
        }, 0);
      });
    }
  }]);
}(d);
export { mo as AccessibilityHelp, R as BalloonPanelView, ve as BodyCollection, Vo as BoxedEditorUIView, Tt as ButtonLabelView, w as ButtonView, bo as CollapsibleView, je as ColorGridView, ds as ColorPickerView, yo as ColorSelectorView, Vt as ColorTileView, _s as ComponentFactory, Po as ContextualBalloon, fo as CssTransitionDisablerMixin, As as DefaultMenuBarItems, Te as Dialog, ke as DialogView, v as DialogViewPosition, ws as DocumentColorCollection, ji as DropdownButtonView, Ki as DropdownPanelView, ye as DropdownView, Co as EditorUI, Us as EditorUIView, wo as FileDialogButtonView, Ai as FileDialogListItemButtonView, H as FocusCycler, Vi as FormHeaderView, Eo as FormRowView, L as IconView, xo as InlineEditableUIView, $i as InputNumberView, Ui as InputTextView, It as InputView, de as LabelView, Ri as LabeledFieldView, z as ListItemButtonView, Z as ListItemGroupView, F as ListItemView, Fe as ListSeparatorView, Ae as ListView, vt as MenuBarMenuListItemButtonView, Qs as MenuBarMenuListItemFileDialogButtonView, Mt as MenuBarMenuListItemView, nt as MenuBarMenuListView, $ as MenuBarMenuView, Lo as MenuBarView, Io as Notification, ts as SplitButtonView, Bo as StickyPanelView, yt as SwitchButtonView, E as Template, qi as ToolbarLineBreakView, Ot as ToolbarSeparatorView, Ji as ToolbarView, Ce as TooltipManager, d as View, A as ViewCollection, Oo as ViewModel, Ci as addKeyboardHandlingForGrid, ko as addListToDropdown, Pt as addToolbarToDropdown, kt as clickOutsideHandler, De as createDropdown, vo as createLabeledDropdown, To as createLabeledInputNumber, hs as createLabeledInputText, Bt as focusChildOnDropdownOpen, go as getLocalizedColorOptions, j as isFocusable, xi as isViewWithFocusCycler, _o as normalizeColorOptions, Ds as normalizeMenuBarConfig, Si as normalizeSingleColorDefinition, Qi as normalizeToolbarConfig, po as submitHandler };